import React, {useState, useEffect} from "react";

export default function UltimateBack({
  lightContrast,
  darkContrast,
  stitching,
  patchColor,
  azomo,
  printStyle,
  getDataFromChild,
  preview,
}) {
  function adjust(color, amount) {
    return (
      "#" +
      color
        .replace(/^#/, "")
        .replace(/../g, (color) =>
          (
            "0" + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)
          ).substr(-2)
        )
    );
  }

  const [darkenColor, setDarkenColor] = useState(darkContrast);

  const [lightContrastActive, setLightContrastActive] = useState(false);
  const [darkContrastActive, setDarkContrastActive] = useState(false);
  const [stitchingActive, setStitchingActive] = useState(false);
  const [patchActive, setPatchActive] = useState(false);
  const [azomoActive, setAzomoActive] = useState(false);

  const handleClick = (tabId) => {
    if (!preview) {
      getDataFromChild(tabId);
    }
  };

  useEffect(() => {
    setDarkenColor(adjust(lightContrast, -150));
  }, lightContrast);

  return (
    <svg
      className={printStyle}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 500 500"
      enableBackground="new 0 0 500 500"
    >
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M473.369,299.732c0-0.223-0.001-0.448-0.001-0.674c0-0.136-0.001-0.272-0.001-0.408
   c0-0.243-0.001-0.487-0.001-0.733c-0.002-0.045-0.002-0.091-0.002-0.136c-0.001-0.2-0.001-0.401-0.002-0.603
   c-0.001-0.249-0.002-0.498-0.003-0.749c-0.001-0.251-0.002-0.502-0.003-0.756c-0.004-0.54-0.007-1.087-0.01-1.64
   c-0.001-0.178-0.003-0.357-0.004-0.537c-0.001-0.179-0.002-0.36-0.003-0.541c-0.002-0.259-0.003-0.519-0.005-0.782
   c-0.002-0.132-0.003-0.265-0.004-0.399c-0.001-0.197-0.003-0.395-0.004-0.593c-0.001-0.317-0.005-0.634-0.007-0.954
   c-0.001-0.142-0.002-0.284-0.004-0.425c0-0.152-0.001-0.304-0.004-0.455c-0.002-0.274-0.004-0.548-0.007-0.825
   c0-0.033,0-0.068-0.001-0.102c-0.001-0.202-0.004-0.406-0.006-0.61c0-0.04-0.001-0.078-0.001-0.118
   c-0.003-0.407-0.008-0.817-0.012-1.228c-0.001-0.151-0.001-0.302-0.004-0.453c-0.003-0.283-0.006-0.567-0.008-0.851
   c-0.004-0.242-0.006-0.485-0.008-0.729c-0.001-0.017-0.001-0.034-0.001-0.051c-0.003-0.312-0.007-0.626-0.011-0.941
   c-0.005-0.424-0.01-0.851-0.015-1.279v-0.029c-0.004-0.438-0.011-0.879-0.015-1.323c-0.002-0.147-0.004-0.294-0.005-0.442
   c-0.002-0.051-0.003-0.102-0.003-0.152c-0.003-0.218-0.005-0.436-0.009-0.654c-0.002-0.179-0.004-0.357-0.005-0.535
   c-0.003-0.299-0.008-0.599-0.012-0.9c-0.004-0.301-0.008-0.604-0.012-0.907c-0.008-0.548-0.016-1.099-0.022-1.655
   c-0.004-0.224-0.007-0.45-0.01-0.676c-0.007-0.452-0.014-0.906-0.02-1.362c-0.012-0.911-0.027-1.831-0.041-2.757
   c-0.003-0.232-0.007-0.463-0.01-0.696c-0.033-2.159-0.069-4.355-0.106-6.584c-0.011-0.652-0.022-1.307-0.033-1.965h0
   c-0.023-1.401-0.049-2.816-0.074-4.24c-0.013-0.712-0.027-1.427-0.039-2.145c-0.004-0.212-0.008-0.425-0.012-0.638
   c-0.012-0.677-0.024-1.355-0.038-2.037c-0.003-0.19-0.007-0.381-0.011-0.572c-0.013-0.717-0.026-1.437-0.04-2.159
   c-0.005-0.27-0.01-0.542-0.015-0.813l-0.104-7.56l-0.049-0.188c-0.353-17.605-0.774-36.054-1.166-53.24
   c-0.059-2.615-0.12-5.208-0.178-7.771c-0.057-2.562-0.116-5.096-0.171-7.594c-0.028,0.013-0.073,0.035-0.104,0.05l-0.014-0.672
   c0.036-0.018,0.075-0.036,0.102-0.049c-0.239-10.634-0.458-20.607-0.631-29.411c-0.04-2.032-0.095-4.152-0.164-6.343l-0.072,0.024
   l-0.014-0.639l0.065-0.022c-0.045-1.34-0.096-2.709-0.153-4.1l-0.001-0.04l-0.001-0.002c-0.05-1.213-0.104-2.441-0.164-3.691
   c-0.093-1.938-0.206-3.93-0.328-5.947l0.004-0.001c0,0-1.658-27.738-2.653-28.863c-0.002-0.003-0.007-0.01-0.01-0.013
   c-1.601-12.668-3.877-25.736-7.115-38.243c-0.413-1.595-0.495-1.912-0.426-2.058c0.05-0.351,0.085-0.705,0.127-1.057l0.009-0.003
   l0.018-0.223c0.022-0.199,0.051-0.397,0.071-0.596c-0.007,0-0.017,0-0.025,0l0.048-0.612c0.01,0,0.024,0,0.033,0
   c0.069-0.787,0.116-1.571,0.151-2.352l0.01-0.134l-0.005-0.038c0.189-4.441-0.115-8.706-0.471-11.855
   c-0.37-3.247-0.833-5.789-1.126-7.214l0-0.001c0,0-0.005-0.275-0.124-0.584c-0.002-0.009-0.005-0.022-0.007-0.031
   c-0.001,0.002-0.003,0.003-0.004,0.005c-0.074-0.184-0.196-0.37-0.383-0.524c0.012-0.017,0.026-0.032,0.038-0.05
   c-0.047-0.01-0.094-0.019-0.142-0.029c-0.245-0.161-0.577-0.263-1.057-0.217c-0.001,0-0.004,0-0.005,0
   c-2.222-0.453-4.378-0.876-6.253-1.241c-2.815-0.546-5.152-1.079-7.411-1.597c-2.972-0.679-5.779-1.321-9.443-1.945
   c-9.07-1.545-17.137-2.768-24.664-3.736c-6.915-0.89-15.122-1.842-23.556-2.154c-8.687-0.321-17.196-0.144-25.289,0.528
   c-7.045,0.584-14.701,1.498-24.094,2.877c-7.232,1.063-14.75,2.298-22.982,3.776c-2.888,0.518-4.991,1.043-7.215,1.599
   c-1.854,0.463-3.769,0.942-6.217,1.43c-0.521,0.104-1.084,0.216-1.67,0.336c-0.498,0.1-1.019,0.207-1.542,0.315l-0.006,0.001
   c0,0-0.755-0.153-0.757,1.291c0,0.001,0,0.002,0,0.003c-0.294,1.434-0.75,3.953-1.116,7.163c-0.412,3.649-0.759,8.793-0.342,13.978
   l-0.005,0.012l0.018,0.18c0.006,0.072,0.009,0.143,0.015,0.215c0.002,0,0.005,0,0.007,0l0.062,0.612c-0.003,0-0.008,0-0.011,0
   c0.019,0.192,0.047,0.382,0.069,0.574l0.052,0.514l0.112,1.044c-0.008,0.057-0.019,0.121-0.037,0.204c0,0.001,0,0.002-0.001,0.003
   c0,0.003-0.001,0.003-0.001,0.005c-0.002,0.029-0.007,0.056-0.017,0.081c0,0.002-0.001,0.003-0.001,0.006v0.001
   c-0.068,0.3-0.187,0.764-0.377,1.498c-3.358,12.973-5.684,26.547-7.294,39.652l-0.554,4.782c-0.727,6.559-1.284,12.966-1.698,19.075
   l-0.041,0.091l-0.108,2.157l-0.011,0.23c-0.328,5.23-0.56,10.233-0.714,14.899l0.024,0.008l-0.029,0.633l-0.015-0.005
   c-0.01,0.307-0.017,0.601-0.026,0.904l-0.005,0.115l0.002,0.006c-0.055,1.829-0.102,3.617-0.135,5.332
   c-0.169,8.541-0.38,18.185-0.61,28.461l-0.021,0.051v1.555c-0.004-0.002-0.011-0.005-0.015-0.007
   c-0.115,5.002-0.232,10.148-0.351,15.385c-0.403,17.636-0.835,36.605-1.195,54.62l-0.021,0.018v1.634c-0.003,0-0.008,0-0.011,0
   c-0.095,4.853-0.185,9.625-0.267,14.283h-0.052l-0.052,6.046v0c-0.5,30.245-0.616,54.267,0.264,58.673
   c0.642,3.208,0.853,18.252,0.992,37.439c0,0,0,0,0.001,0v4.343l0.03,0.01c0.022,3.326,0.042,6.746,0.063,10.237
   c0.244,40.804,0.548,91.53,3.5,100.082c1.089,0.318,8.213,2.302,19.385,3.325c11.13,1.021,28.66,1.268,49.055-3.326
   c0.399-5.236,5.664-109.718,5.717-110.793c0.002-0.049,0.017-0.386,0.042-0.984l0.104-0.134v-2.431c0,0,0,0,0,0
   c0.556-13.812,2.52-64.75,2.605-97.892l0.004-0.01v-6.25l-0.012-0.06c-0.018-3.172-0.059-6.118-0.126-8.766l-0.001-0.01l0.001-0.011
   c1.133-25.484,7.025-50.179,7.267-51.183c0.002-0.037,0.004-0.103,0.009-0.198c0.003-0.094,0.009-0.217,0.015-0.366l-0.075,0.004
   l0.351-5.19c0,0.006,0.001,0.014,0.001,0.02c0.012-0.19,0.026-0.398,0.038-0.595l0.19-2.804c0.217-3.015,0.507-6.478,0.888-9.936
   c0.614-5.561,1.336-10.008,2.147-13.216c0.914-3.614,1.94-5.636,3.12-6.181l1.363,0.073c1.108,0.656,2.078,2.667,2.947,6.108
   c0.812,3.207,1.534,7.654,2.147,13.215c0.242,2.189,0.447,4.381,0.62,6.461l0.802,11.252c-0.016,0.317-0.027,0.55-0.035,0.689
   c0.016,0.356,0.026,0.584,0.029,0.663c0.244,1.009,6.136,25.702,7.268,51.183l0.001,0.011c0,0,0,0.016-0.001,0.042
   c-0.019,0.71-0.034,1.443-0.049,2.194c-0.004,0.211-0.009,0.424-0.012,0.639v0.019c-0.003,0.162-0.006,0.327-0.009,0.492
   c-0.003,0.208-0.005,0.417-0.009,0.628v0.026c-0.004,0.303-0.009,0.61-0.013,0.92c-0.003,0.201-0.006,0.403-0.008,0.607v0.046
   c-0.004,0.316-0.007,0.637-0.011,0.96c-0.002,0.222-0.003,0.446-0.004,0.671c-0.002,0.184-0.004,0.368-0.005,0.554
   c-0.002,0.235-0.003,0.473-0.005,0.712c-0.001,0.186-0.002,0.373-0.002,0.561c-0.003,0.246-0.004,0.493-0.005,0.741
   c-0.001,0.295-0.002,0.594-0.003,0.895c-0.001,0.289-0.001,0.582-0.002,0.875c-0.001,0.628-0.002,1.262-0.001,1.904
   c0.001,0,0.003,0,0.004,0.001c0,0,0,0,0,0.001c-0.001,0-0.003,0-0.004-0.001c0,0.182,0.001,0.374,0.002,0.557
   c-0.065,14.068,0.035,36.114,1.024,53.799c0,0.007,0.001,0.013,0.001,0.019c0.007,0.246,0.014,0.5,0.022,0.745
   c0.017,0.636,0.037,1.27,0.056,1.901c0.002,0.058,0.003,0.116,0.005,0.174c0.008,0.233,0.015,0.466,0.022,0.699
   c0.007,0.231,0.014,0.463,0.021,0.695c0.013,0.376,0.025,0.751,0.035,1.125c0.017,0.527,0.034,1.05,0.049,1.572
   c0.015,0.45,0.03,0.897,0.043,1.344c0.022,0.666,0.042,1.327,0.064,1.984c0.013,0.39,0.026,0.777,0.038,1.162
   c0.016,0.492,0.032,0.98,0.049,1.466c0.015,0.495,0.032,0.987,0.048,1.475c0.013,0.407,0.028,0.811,0.041,1.214
   c0.018,0.539,0.036,1.075,0.054,1.608c0.008,0.236,0.017,0.47,0.024,0.703c0.002,0.01,0.002,0.018,0.002,0.027
   c0.006,0.223,0.014,0.444,0.022,0.664c0.008,0.239,0.016,0.476,0.024,0.714c0.008,0.221,0.015,0.441,0.023,0.661
   c0.017,0.455,0.031,0.906,0.048,1.354c0.007,0.227,0.015,0.453,0.023,0.677c0.008,0.221,0.015,0.441,0.023,0.661
   c0.015,0.438,0.031,0.872,0.046,1.303c0.007,0.215,0.015,0.429,0.022,0.642c0.015,0.394,0.028,0.784,0.042,1.17
   c0.015,0.387,0.028,0.769,0.042,1.149c0.003,0.065,0.005,0.129,0.007,0.194c0,0.01,0.001,0.021,0.001,0.032
   c0.008,0.2,0.013,0.398,0.021,0.595c0.008,0.197,0.014,0.393,0.022,0.587c0.008,0.209,0.015,0.417,0.022,0.622
   c0.002,0.058,0.005,0.116,0.007,0.174c0.008,0.208,0.015,0.413,0.023,0.618c0.007,0.212,0.016,0.426,0.023,0.635
   c0.001,0.049,0.003,0.096,0.006,0.143c0.004,0.13,0.009,0.258,0.014,0.386c0.013,0.383,0.028,0.761,0.042,1.134
   c0.007,0.212,0.014,0.423,0.022,0.631c0.009,0.207,0.017,0.414,0.023,0.618c0.007,0.182,0.015,0.363,0.021,0.541
   c0.015,0.371,0.028,0.734,0.041,1.092c0.013,0.346,0.026,0.688,0.039,1.023c0.022,0.595,0.045,1.174,0.066,1.734
   c0.004,0.105,0.008,0.209,0.012,0.313c0.01,0.243,0.02,0.484,0.028,0.721c0.01,0.237,0.019,0.469,0.027,0.699
   c0.002,0.028,0.003,0.057,0.004,0.085c0.006,0.167,0.012,0.332,0.019,0.495c0.017,0.442,0.033,0.87,0.049,1.283
   c0.004,0.083,0.007,0.165,0.01,0.245c0.007,0.164,0.013,0.323,0.019,0.481c0.012,0.304,0.024,0.598,0.035,0.883
   c0.009,0.239,0.019,0.472,0.028,0.699c0.012,0.301,0.023,0.589,0.034,0.867c0.003,0.068,0.006,0.137,0.009,0.205
   c0.005,0.117,0.01,0.233,0.014,0.345v0.004c0,0.016,0,0.032,0.001,0.048c0,0.012,0.002,0.024,0.002,0.036
   c0.001,0.011,0.001,0.023,0.002,0.034c0.026,0.005,0.052,0.009,0.078,0.014v0c-0.026-0.005-0.052-0.009-0.077-0.013
   c0,0.015,0,0.031,0.001,0.046c0.005,0.162,0.012,0.32,0.019,0.473c0.004,0.11,0.008,0.216,0.013,0.321
   c0.01,0.245,0.019,0.475,0.027,0.69c0.004,0.068,0.006,0.134,0.009,0.198c0.005,0.113,0.009,0.221,0.014,0.323
   c0.001,0.052,0.003,0.101,0.005,0.151c0.001,0.048,0.003,0.096,0.006,0.143c0.001,0.023,0.002,0.047,0.003,0.07
   c0.001,0.03,0.002,0.06,0.003,0.089c0.002,0.04,0.004,0.079,0.006,0.117c0.002,0.045,0.003,0.088,0.005,0.13
   c0.002,0.044,0.004,0.087,0.006,0.128v0.009c0.009,0.219,0.015,0.388,0.02,0.506c0.001,0.013,0.001,0.025,0.002,0.037
   c0,0.01,0,0.018,0.001,0.027c0,0.018,0.001,0.034,0.002,0.048c0.001,0.042,0.002,0.069,0.004,0.081
   c0.02,0.398,0.758,15.037,1.698,33.557l0,0.007l0,0c1.593,31.391,3.768,73.935,4.021,77.228c20.403,4.596,37.94,4.348,49.074,3.326
   c11.166-1.026,18.276-3.007,19.364-3.325c2.251-6.524,2.963-37.593,3.282-70.076l0,0l0-0.008c0.091-9.241,0.15-18.594,0.203-27.531
   l0.216-29.204c0.002-0.207,0.006-0.413,0.008-0.617c0.003-0.285,0.006-0.568,0.01-0.85c0.003-0.323,0.007-0.643,0.012-0.96
   l0.002-0.268c0.003-0.228,0.006-0.454,0.009-0.679c0.002-0.156,0.004-0.312,0.007-0.467c0.01-0.738,0.021-1.462,0.031-2.172
   c0.004-0.309,0.008-0.616,0.014-0.919c0.007-0.394,0.013-0.782,0.02-1.166v-0.011c0.002-0.188,0.005-0.374,0.009-0.559
   c0.002-0.114,0.004-0.227,0.006-0.34c0.004-0.19,0.007-0.379,0.01-0.565c0.008-0.37,0.014-0.734,0.021-1.093
   c0.002-0.108,0.005-0.216,0.007-0.324c0.008-0.337,0.014-0.668,0.022-0.996c0.002-0.129,0.005-0.258,0.009-0.386
   c0.002-0.128,0.004-0.255,0.007-0.382c0.004-0.127,0.007-0.253,0.009-0.377c0.01-0.376,0.019-0.745,0.028-1.106
   c0.003-0.121,0.007-0.24,0.01-0.36c0.009-0.302,0.016-0.599,0.025-0.891c0.002-0.093,0.006-0.184,0.008-0.276
   c0.021-0.685,0.042-1.34,0.064-1.964c0.005-0.168,0.012-0.333,0.018-0.495c0.001-0.04,0.003-0.079,0.004-0.119
   c0.006-0.154,0.012-0.304,0.018-0.453c0.007-0.163,0.014-0.325,0.02-0.484c0.006-0.13,0.012-0.26,0.017-0.387
   c0.001-0.02,0.002-0.041,0.004-0.062c0.005-0.145,0.013-0.288,0.019-0.428c0.005-0.105,0.009-0.21,0.015-0.311
   c0.004-0.086,0.009-0.172,0.013-0.256c0.004-0.084,0.009-0.168,0.013-0.25c0.001-0.005,0.001-0.009,0.001-0.013
   c0.006-0.133,0.014-0.263,0.021-0.391c0.026-0.447,0.052-0.865,0.08-1.249c0.008-0.111,0.016-0.219,0.024-0.323
   c0.011-0.15,0.023-0.294,0.036-0.432c0.006-0.092,0.014-0.182,0.023-0.27c0.006-0.074,0.013-0.146,0.021-0.216
   c0.004-0.055,0.01-0.109,0.015-0.161c0.006-0.044,0.01-0.087,0.014-0.131c0.005-0.043,0.009-0.085,0.015-0.125
   c0.035-0.312,0.072-0.582,0.11-0.807c0.006-0.035,0.012-0.07,0.018-0.103c0.006-0.034,0.012-0.066,0.019-0.097
   C473.213,320.737,473.395,312.132,473.369,299.732z"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M202.115,476.183c4.92-1.279,10.102-2.909,15.499-4.989c-0.521-9.234-7.02-60.656-7.086-61.186
   c-0.043-0.414-4.334-41.607-7.098-59.039c-1.76-11.099-5.185-24.954-7.748-34.624c-1.416-5.335-2.094-10.842-2.018-16.368
   c0.113-8.044,0.258-22.112-0.025-25.946c-0.124-1.658-0.443-3.994-0.815-6.698c-0.928-6.77-2.2-16.042-1.661-23.895
   c0.237-3.42,0.82-8.269,1.495-13.883c1.49-12.361,3.528-29.289,3.454-44.613c-0.01-2.039-0.002-3.975,0.012-5.859l0.139-8.361
   c0.27-10.056,0.82-16.952,1.108-20.017c0.079-0.846,0.233-1.691,0.457-2.511c0.878-3.213,3.697-14.989,3.093-31.596
   c-0.114-3.133-0.343-6.254-0.678-9.362l0.002-0.009l-0.011-0.081c-0.13-1.196-0.272-2.39-0.435-3.581
   c-0.013,0.013-0.025,0.026-0.039,0.038l-0.098-0.731l0.048,0.053c-0.09-0.642-0.198-1.281-0.298-1.921l-0.068-0.511l-0.015-0.027
   c-0.228-1.42-0.474-2.838-0.749-4.252l0.004-0.011l-0.055-0.269c-0.013-0.066-0.023-0.132-0.036-0.198l-0.004,0.001l-0.122-0.599
   l0.008-0.001c-0.041-0.201-0.089-0.402-0.131-0.603l-0.209-1.022l-0.042-0.132c-0.905-4.177-2.007-8.324-3.319-12.435l-0.002-0.029
   c0,0-0.03-0.088-0.079-0.234c-0.036-0.111-0.067-0.223-0.103-0.334c-0.003,0-0.007,0.001-0.01,0.001
   c-0.221-0.652-0.596-1.754-0.922-2.713c0.006-0.001,0.016-0.003,0.021-0.004c-0.148-0.427-0.306-0.852-0.458-1.278
   c-0.095-0.277-0.161-0.469-0.178-0.515c-0.002-0.005-0.015-0.03-0.025-0.049c-2.37-6.534-5.255-12.969-8.652-19.287l0.005-0.002
   l-0.975-1.97c-1.552-3.428-5.861-13.768-8.479-28.147c-0.025-0.131-0.122-0.233-0.244-0.265c-0.072,0.001-0.141,0.002-0.209,0.003
   c-0.006,0-0.012,0.002-0.018,0.002c-4.165,0.502-8.255,1.296-12.212,2.237l-0.008-0.008l-0.179,0.052
   c-0.378,0.091-0.763,0.174-1.139,0.268l0.007,0.064l-0.596,0.175l-0.008-0.079l-8.436,2.572l-5.303,1.617l-1.612,0.475l-0.009-0.076
   c-0.884,0.291-1.777,0.578-2.672,0.865l-25.467,7.213c-0.199,0.05-0.393,0.101-0.593,0.151c-1.133,0.318-2.275,0.654-3.414,0.984
   l-1.159,0.328l-0.321,0.098c-0.192,0.056-0.381,0.109-0.573,0.165l0,0.01l-16.286,4.993l-0.025,0.008
   c-2.447,0.75-4.964,1.531-7.434,2.328l0,0.026l-0.607,0.192l0-0.023c-0.644,0.209-1.281,0.419-1.914,0.63l-0.08,0.025l0,0.001
   c-2.323,0.773-4.561,1.553-6.596,2.327c-0.105,0.04-0.176,0.144-0.176,0.258v17.164c0.008-0.002,0.022-0.006,0.03-0.008l0.011,0.629
   c-0.01,0.003-0.025,0.007-0.035,0.01l0.093,3.237v0.001l0.925,32.375l0,0l0.017,0.6c0.004,0.134,0.008,0.266,0.012,0.399
   l-0.58,0.972c0-0.015-0.001-0.029-0.001-0.044c-0.1,0.174-0.201,0.346-0.301,0.519c-0.197,0.34-0.398,0.687-0.602,1.041
   l-0.004,0.007l-0.001,0.002c-0.549,0.951-1.125,1.956-1.747,3.049c-1.175,2.062-2.4,4.24-3.643,6.471
   c-1.554,2.789-3.135,5.664-4.701,8.548c-1.85,3.407-3.71,6.882-5.528,10.329c-2.076,3.937-4.138,7.912-6.126,11.816
   c-2.223,4.363-4.408,8.739-6.493,13.004c-2.293,4.692-4.524,9.369-6.629,13.9c-2.288,4.924-4.488,9.802-6.536,14.499
   c-2.207,5.057-4.297,10.036-6.212,14.802c-2.049,5.093-3.952,10.076-5.658,14.808c-0.318,0.882-0.628,1.753-0.932,2.616
   l-0.001,0.002v0.001c-0.963,2.733-1.857,5.376-2.697,7.972c0,0,0,0,0,0c-0.427,1.319-0.841,2.627-1.242,3.927
   c-1.523,4.937-2.784,9.495-3.857,13.933l-0.143,0.594c-1.063,4.392-2.163,8.933-2.577,13.415c-0.21,2.287-0.179,4.617-0.148,6.869
   c0.01,0.74,0.021,1.507,0.022,2.263c0.004,1.56,0.008,3.122,0.013,4.684c0.011,3.795,0.027,7.653,0.045,11.466
   c0.022,4.584,0.049,9.122,0.079,13.49c0.037,5.126,0.077,9.899,0.124,14.591c0.054,5.298,0.112,10.129,0.178,14.767
   c0.02,1.33,0.038,2.622,0.059,3.882c0,0,0,0,0,0c0.056,3.614,0.116,6.959,0.183,10.141c0.098,4.753,0.198,8.677,0.314,12.352
   c0.09,2.882,0.209,6.294,0.396,9.755l0.013,0.224c0.106,1.975,0.216,4.018,0.474,6.002c0.038,0.289,0.085,0.628,0.15,0.961
   c2.028,10.476,1.781,30.458,0.971,37.848c-0.81,7.388,0.99,30.033,1.169,32.254c1.317,0.619,11.035,4.922,25.736,4.627
   c4.661-0.094,8.843-0.198,12.69-0.338c0-0.017-0.001-0.043-0.001-0.062l0.609-0.01c0,0.014,0.001,0.035,0.001,0.048
   c0.64-0.024,1.256-0.051,1.879-0.078l0.099-0.002l0-0.003c7.376-0.314,13.583-0.786,19.758-1.61
   c8.555-1.143,9.641-3.063,9.739-3.285c0.005-1.498,0.138-35.246,1.183-49.885c1.147-16.055,2.97-59.733,1.295-71.469l-0.004-0.043
   c0-5.84,2.84-9.668,3.066-9.963c0.084-0.144,1.63-2.975,2.959-17.603c1.383-15.219,3.532-27.335,3.553-27.456l0.002-0.012
   c0.016-0.072,0.404-1.788,1.667-3.905c1.14-1.912,3.233-4.507,6.771-6.139l0.68,0.18l0.043,0.166l-0.004,0.002
   c0.988,4.239,4.204,18.583,3.925,24.513c-0.317,6.784,0.946,42.49,1.934,50.182c0.309,2.403,2.139,9.275,4.478,17.486c0,0,0,0,0,0
   c4.879,17.135,11.972,40.102,12.077,40.443l0.006,0.018c0.091,0.379,9.165,38.073,10.549,54.045
   c1.388,16.011,4.667,30.308,5.19,31.225c0.555,0.319,7.873,2.787,20.798,3.162c6.802,0.196,15.985-0.206,26.822-2.322l0.001,0.001
   l0.06-0.014c0.584-0.114,1.169-0.23,1.762-0.355c-0.001-0.012-0.004-0.032-0.006-0.045l0.598-0.136
   c0.002,0.016,0.005,0.041,0.007,0.056c1.847-0.396,3.742-0.848,5.675-1.348l0.101-0.023L202.115,476.183z"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M1079.413,307.765l-0.876-49.583c-0.017-0.003-0.034-0.005-0.051-0.008v-0.617
   c0.013,0.002,0.027,0.004,0.04,0.006l-0.256-14.44c-0.001-0.357-0.071-21.245-0.871-50.432l0-0.001l-0.001-0.031
   c-0.046-1.678-0.094-3.379-0.145-5.11c-0.013-0.001-0.028-0.001-0.041-0.002l-1.32-36.233l0.013,0.001
   c-0.018-0.394-0.038-0.794-0.056-1.189l-0.006-0.176l-0.005-0.054c-0.42-9.071-0.909-18.338-1.486-27.584
   c-1.082-17.365-2.62-30.821-4.204-41.094l-0.002-0.027l-0.021-0.122c-0.271-1.756-0.544-3.429-0.816-5
   c-0.01-0.001-0.019-0.002-0.028-0.002l-0.105-0.62c0.008,0.001,0.017,0.001,0.026,0.002c-0.13-0.74-0.26-1.454-0.389-2.154
   l-0.005-0.033l-0.001-0.001c-0.796-4.305-1.574-7.849-2.281-10.712c-2.334-9.443-4.347-13.484-4.882-14.458l0-0.001l-0.233-0.936
   l-1.406-17.5c-0.07-0.011-0.156-0.025-0.256-0.04c-0.02-0.003-0.041-0.006-0.062-0.01c-0.059-0.01-0.123-0.019-0.192-0.03
   c-0.024-0.004-0.048-0.007-0.074-0.012c-0.05-0.007-0.102-0.016-0.157-0.023c-0.027-0.005-0.055-0.009-0.084-0.013
   c-0.067-0.011-0.137-0.022-0.21-0.034c-0.05-0.007-0.103-0.015-0.157-0.023c-0.013-0.002-0.027-0.004-0.04-0.007
   c-0.053-0.007-0.107-0.016-0.162-0.024c-0.016-0.003-0.031-0.005-0.047-0.008c-0.036-0.005-0.074-0.011-0.11-0.017
   c-0.038-0.006-0.075-0.012-0.114-0.017c-0.038-0.006-0.077-0.012-0.116-0.017c-0.057-0.009-0.115-0.019-0.174-0.028
   c-0.041-0.005-0.081-0.011-0.122-0.018c-0.151-0.022-0.308-0.046-0.471-0.071c-0.036-0.005-0.071-0.01-0.108-0.016
   c-0.036-0.005-0.073-0.01-0.109-0.016c-0.041-0.007-0.083-0.013-0.123-0.018c-0.041-0.007-0.083-0.013-0.125-0.02l0.001,0.025
   l-15.673-2.167l0-0.019c-0.476-0.06-0.967-0.121-1.455-0.182l-0.039-0.005c0,0-0.008,0-0.008-0.001
   c-0.977-0.122-1.969-0.244-2.992-0.368c-0.221-0.027-0.442-0.054-0.665-0.081c-0.111-0.013-0.223-0.027-0.335-0.039
   c-0.111-0.014-0.223-0.027-0.336-0.04c-0.224-0.027-0.449-0.054-0.676-0.081c-0.226-0.027-0.454-0.054-0.682-0.08
   c-0.114-0.014-0.228-0.026-0.343-0.039c-0.229-0.028-0.458-0.054-0.69-0.081c-0.576-0.067-1.158-0.134-1.745-0.199
   c-6.934-0.782-15.223-1.608-23.764-2.211c-0.001,0-0.002,0-0.003-0.001c-5.853-1.563-52.897-0.259-52.897-0.259l-4.663,0.468
   c-7.544,0.578-14.798,1.307-20.972,2.003c-0.939,0.107-1.866,0.213-2.779,0.319c-0.341,0.04-0.681,0.08-1.02,0.121
   c-0.226,0.026-0.451,0.053-0.673,0.08c-0.149,0.018-0.297,0.036-0.445,0.053c-0.313,0.037-0.614,0.075-0.923,0.112l-0.044,0.004
   l-0.069,0.009c-0.494,0.06-0.994,0.121-1.478,0.18c-0.421,0.051-0.838,0.104-1.251,0.155c-0.287,0.036-0.572,0.073-0.855,0.108
   l-0.001,0.043l-15.701,2.129l0.001-0.017c-0.113,0.017-0.224,0.033-0.332,0.049c-0.05,0.008-0.098,0.015-0.147,0.023
   c-0.053,0.008-0.107,0.016-0.159,0.024c-0.048,0.008-0.095,0.014-0.143,0.021c-0.075,0.011-0.149,0.023-0.221,0.034
   c-0.045,0.006-0.09,0.014-0.133,0.02c-0.218,0.032-0.424,0.063-0.615,0.093c-0.074,0.011-0.145,0.022-0.215,0.033
   c-0.077,0.012-0.151,0.024-0.223,0.035c-0.1,0.014-0.196,0.029-0.286,0.043c-0.103,0.017-0.201,0.032-0.292,0.045
   c-0.056,0.009-0.11,0.018-0.161,0.025c-0.052,0.008-0.1,0.015-0.146,0.023c-0.023,0.004-0.045,0.008-0.067,0.011
   c-0.068,0.01-0.129,0.02-0.183,0.029c-0.033,0.004-0.063,0.01-0.091,0.013l-1.412,17.577l0,0l-0.244,0.89v0
   c-0.56,1.029-2.557,5.088-4.865,14.429c-0.757,3.063-1.595,6.911-2.449,11.631l-0.005,0.015l-0.062,0.354
   c-0.054,0.301-0.108,0.592-0.162,0.9c0.001,0,0.003,0,0.005,0l-0.109,0.622c0,0-0.003,0-0.004,0
   c-0.036,0.205-0.071,0.423-0.107,0.631l-0.048,0.276l0.001,0.002c-1.816,10.713-3.651,25.468-4.889,45.332
   c-0.45,7.221-0.869,14.811-1.251,22.622l-0.003,0.018l-0.008,0.2c-0.099,2.038-0.198,4.082-0.292,6.148l0.057-0.006l-1.39,36.249
   c-0.006,0-0.012,0.001-0.018,0.001c-0.02,0.671-0.04,1.34-0.059,2.004c-0.883,30.782-0.953,53.345-0.954,53.57l-0.121,6.825
   l-0.134,0.492v7.725c-0.004,0.001-0.007,0.001-0.011,0.002l-0.877,49.603c0.08,0.995,3.437,43.036,3.918,48.967
   c0.485,5.982,0.975,44.857,0.98,45.248c-0.005,0.537-0.484,53.158,0,61.542c0.508,8.817,1.314,15.909,1.739,16.97
   c0.977,0.482,12.184,2.232,26.419,2.979c12.512,0.655,29.691,0.66,40.656-3.019c0.864-4.803,4.867-39.956,5.52-59.538
   c0.653-19.606-0.993-68.225-1.469-73.929c-0.463-5.565-1.013-37.61,0.659-45.803c1.283-6.287,4.196-27.729,5.761-39.249
   c0.423-3.105,0.756-5.559,0.93-6.777c0.274-1.921,0.385-5.835,0.512-10.367c0.249-8.881,0.591-21.044,2.434-27.875
   c1.378-5.104,2.429-10.835,3.202-15.55l0.001-0.001l0.055-0.341c0.074-0.456,0.149-0.916,0.218-1.35c-0.001,0-0.002,0-0.002,0
   l0.104-0.651l0.001,0c0.009-0.058,0.017-0.109,0.026-0.167l0.019-0.118l0.193-1.243c0.001-0.008,0.003-0.017,0.004-0.025l0,0
   l0.616-3.964c0.006-0.034,0.01-0.062,0.016-0.095l0.149-0.847c0.049-0.262,0.095-0.487,0.134-0.629
   c0.024-0.089,0.047-0.273,0.069-0.53l0-0.002l0-0.007c0.063-0.741,0.12-2.099,0.187-3.712c0.035-0.837,0.075-1.775,0.12-2.753
   l0.066-1.397c0.197-3.973,0.505-8.694,1.1-13.036c0.862-6.284,2.095-10.118,3.754-11.642l1.751-0.371
   c1.908,1.187,3.299,5.128,4.243,12.013c0.82,5.992,1.101,12.729,1.286,17.187c0.052,1.228,0.097,2.3,0.143,3.074v0.001l0,0.001
   c0.036,0.6,0.073,1.026,0.114,1.177c0.095,0.346,0.218,1.052,0.381,2.076c0.001-0.018,0.002-0.038,0.003-0.056l0.466,2.994
   c-0.001,0.021-0.003,0.05-0.003,0.07c0.1,0.648,0.206,1.341,0.321,2.072c0.005,0.001,0.011,0.002,0.016,0.003l0.1,0.643
   c-0.005-0.001-0.009-0.001-0.014-0.002c0.104,0.655,0.215,1.339,0.331,2.041l0.006,0.037l0.001,0.001
   c0.766,4.627,1.794,10.16,3.128,15.103c1.844,6.831,2.184,18.993,2.434,27.875c0.128,4.531,0.238,8.446,0.512,10.367
   c0.175,1.218,0.508,3.671,0.929,6.777c1.566,11.52,4.48,32.962,5.763,39.249c1.672,8.193,1.122,40.237,0.658,45.803
   c-0.475,5.704-2.122,54.323-1.469,73.929c0.653,19.582,4.656,54.735,5.52,59.537c10.965,3.679,28.144,3.675,40.656,3.02
   c14.234-0.747,25.442-2.498,26.419-2.98c0.426-1.06,1.231-8.153,1.74-16.969c0.483-8.384,0.004-61.005-0.001-61.535
   c0.005-0.399,0.496-39.273,0.981-45.255C1075.977,350.802,1079.334,308.76,1079.413,307.765z"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M797.815,336.08l-5.179-0.348c-0.156-1.494-0.323-2.884-0.503-4.153c-4-28.205-4.507-52.918-4.521-53.697
   c-0.073-0.565-1.908-14.66-4.918-31.315c-0.564-3.121-1.196-6.467-1.884-9.912h0.002l0.62-0.012
   c0.001,0.004,0.002,0.008,0.003,0.012c0.373-0.007,1.1-0.023,2.119-0.055l0.023,0v0c6.686-0.21,26.166-1.125,45.668-4.979
   c-1.105-3.416-2.304-6.913-3.63-10.591c-1.706-4.733-3.609-9.715-5.658-14.808c-1.915-4.766-4.005-9.746-6.212-14.802
   c-2.048-4.698-4.248-9.575-6.536-14.5c-2.105-4.53-4.336-9.208-6.629-13.899c-2.085-4.265-4.27-8.641-6.493-13.005
   c-1.988-3.904-4.05-7.878-6.126-11.815c-1.818-3.447-3.678-6.922-5.528-10.329c-1.566-2.884-3.147-5.759-4.701-8.549
   c-1.243-2.231-2.468-4.408-3.643-6.47c-0.232-0.408-0.457-0.801-0.677-1.186l0,0l-0.002-0.003c-0.591-1.034-1.144-1.995-1.675-2.91
   c-0.1-0.172-0.201-0.345-0.301-0.518c-0.001,0.04-0.003,0.078-0.004,0.118l-0.58-0.97c0.005-0.159,0.01-0.315,0.015-0.475
   l0.873-30.538l0.169-1.285v-5.021v-4.562V52.901c0-0.114-0.071-0.218-0.176-0.258c-1.687-0.642-3.52-1.287-5.418-1.929l-0.001-0.004
   l-0.138-0.044c-0.997-0.337-2.006-0.673-3.034-1.006l-0.001,0.044l-0.607-0.192l0.001-0.046c-3.017-0.974-6.108-1.925-9.049-2.824
   l-0.019-0.006l-14.677-4.494l0-0.016c-0.294-0.087-0.586-0.167-0.88-0.254l-0.466-0.143l-0.042-0.004
   c-1.362-0.398-2.725-0.796-4.08-1.176c-10.447-2.612-19.857-5.306-28.732-8.228l-0.001,0.01l-15.961-4.695l0.006-0.062
   c-0.356-0.088-0.72-0.167-1.078-0.253l-0.17-0.05l-0.005,0.009c-3.98-0.948-8.096-1.75-12.286-2.255
   c-0.005,0-0.012-0.001-0.017-0.001c-0.069-0.001-0.138-0.003-0.209-0.004c-0.122,0.032-0.22,0.134-0.244,0.265
   c-2.59,14.225-6.835,24.492-8.428,28.03l-1.141,2.298l-0.012,0.036c-3.659,6.833-6.727,13.802-9.183,20.884
   c0,0-4.316,11.556-5.635,22.063c-0.007,0.054-0.013,0.102-0.02,0.155c-0.169,1.024-0.332,2.049-0.477,3.076l0.057-0.062
   c0.006,0.006,0.012,0.012,0.018,0.018c-0.036,0.257-0.071,0.505-0.106,0.74c-0.02-0.019-0.038-0.038-0.057-0.057
   c-0.102,0.745-0.188,1.492-0.277,2.238c-0.607,3.721-0.75,3.313-0.555,5.629l0.006,0.045c-0.128,1.703-0.233,3.409-0.295,5.12
   c-0.604,16.607,2.215,28.382,3.093,31.596c0.224,0.82,0.378,1.664,0.457,2.511c0.302,3.223,0.895,10.68,1.147,21.595l0.107,7.697
   c0.009,1.601,0.013,3.236,0.005,4.945c-0.074,15.323,1.964,32.251,3.453,44.612c0.677,5.614,1.26,10.463,1.495,13.883
   c0.539,7.854-0.732,17.125-1.66,23.896c-0.372,2.704-0.691,5.039-0.815,6.698c-0.283,3.833-0.138,17.902-0.026,25.946
   c0.077,5.526-0.601,11.032-2.016,16.367c-2.564,9.67-5.989,23.525-7.749,34.624c-2.763,17.432-7.054,58.625-7.097,59.039
   c-0.067,0.53-6.566,51.953-7.087,61.186c7.102,2.736,13.831,4.699,20.076,6.095l-0.001,0.006l0.221,0.044
   c0.325,0.072,0.655,0.15,0.978,0.219c0.001-0.007,0.002-0.018,0.003-0.025l0.601,0.119c-0.001,0.009-0.003,0.023-0.004,0.032
   c1.555,0.326,3.076,0.615,4.565,0.873l0.065,0.013l0.001-0.002c9.618,1.665,17.808,1.984,24.014,1.804
   c12.925-0.374,20.244-2.842,20.798-3.162c0.524-0.916,3.802-15.213,5.19-31.224c1.385-15.973,10.458-53.666,10.55-54.045
   l0.005-0.018c0.105-0.341,7.199-23.308,12.078-40.443c-26.211,0.169-53.769-4.386-58.261-5.16l-0.927-0.22
   c2.909-17.405,5.896-33.439,8.631-44.761c2.665-11.038,5.787-31.22,9.29-60.033l1.411,0.308h0
   c5.183,1.153,29.164,6.243,52.274,7.144l0.002,0.003l0.082,0.001c0.171,0.007,0.343,0.015,0.514,0.022l0.004-0.016l0.627,0.006
   l-2.597,10.177c3.54,1.631,5.634,4.227,6.774,6.14c1.263,2.118,1.651,3.834,1.667,3.906l0.002,0.012
   c0.021,0.12,2.17,12.237,3.553,27.456c1.329,14.627,2.875,17.459,2.959,17.603c0.226,0.295,3.066,4.123,3.066,9.962l-0.004,0.044
   c-1.675,11.736,0.148,55.414,1.295,71.469c1.045,14.639,1.178,48.387,1.183,49.884c0.098,0.222,1.184,2.142,9.739,3.286
   c6.522,0.87,13.075,1.349,21.011,1.662l0,0.002l0.316,0.011c0.139,0.005,0.27,0.012,0.409,0.017c0-0.001,0-0.002,0-0.003
   l0.609,0.021c0,0.001,0,0.003,0,0.004c0.82,0.03,1.664,0.057,2.516,0.084l0.257,0.009v0c3.07,0.095,6.351,0.173,9.917,0.245
   c14.701,0.295,24.419-4.008,25.736-4.627c0.179-2.221,1.979-24.866,1.169-32.253c-0.81-7.39-1.056-27.373,0.971-37.849
   c0.065-0.333,0.112-0.672,0.15-0.96c0.258-1.985,0.368-4.028,0.474-6.003l0.013-0.223c0.187-3.462,0.306-6.874,0.396-9.756
   c0.116-3.675,0.216-7.599,0.314-12.352c0.067-3.181,0.127-6.527,0.183-10.141C820.125,336.654,805.268,336.362,797.815,336.08z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M918.902,27.054l-0.479,19.78l-0.016,0.611l-0.227,9.371c-0.007,0.31-0.256,0.562-0.566,0.571l-13.254,0.428
   c-0.27,0.008-0.522-0.092-0.711-0.282c-0.191-0.191-0.289-0.444-0.279-0.713l0.341-8.976l0.023-0.611l0.691-18.193
   c0.016-0.003,0.031-0.005,0.047-0.007c0.085-0.013,0.17-0.024,0.257-0.038c0.027-0.004,0.055-0.008,0.084-0.012
   c0.058-0.009,0.116-0.017,0.175-0.026c0.136-0.021,0.274-0.041,0.415-0.061c0.057-0.008,0.114-0.016,0.172-0.025
   c0.047-0.006,0.093-0.014,0.14-0.021c0.304-0.044,0.617-0.089,0.94-0.136c0.414-0.059,0.843-0.12,1.289-0.184
   c0.072-0.011,0.145-0.022,0.218-0.031c0.105-0.015,0.211-0.03,0.319-0.046c0.19-0.026,0.385-0.054,0.581-0.083
   c0.536-0.075,1.092-0.152,1.668-0.232c0.411-0.056,0.833-0.114,1.263-0.173c0.185-0.026,0.372-0.051,0.56-0.076
   c0.15-0.021,0.301-0.041,0.453-0.062c0.012-0.001,0.025-0.003,0.037-0.005c0.178-0.023,0.357-0.047,0.539-0.072
   c0.09-0.012,0.18-0.024,0.272-0.037c0.224-0.03,0.448-0.06,0.676-0.09c0.051-0.007,0.103-0.013,0.153-0.02
   c0.234-0.031,0.469-0.062,0.706-0.094c0.238-0.031,0.476-0.062,0.719-0.095c0.096-0.011,0.193-0.025,0.29-0.037
   c0.194-0.025,0.39-0.051,0.587-0.077c0.591-0.076,1.193-0.154,1.806-0.232C918.828,27.064,918.864,27.058,918.902,27.054"
      />
      <path
        fill={patchColor}
        onClick={() => handleClick("patch")}
        onMouseEnter={() => setPatchActive(true)}
        onMouseLeave={() => setPatchActive(false)}
        style={
          patchActive && !preview ? {fill: adjust(patchColor, 55)} : {fill: patchColor}
        }
        d="M837.201,270.396c-0.01,0.74-0.021,1.507-0.022,2.262c-0.004,1.561-0.008,3.123-0.012,4.685
   c-0.012,3.795-0.028,7.653-0.046,11.466c-0.022,4.583-0.049,9.122-0.079,13.49c-0.037,5.126-0.076,9.899-0.124,14.591
   c-0.054,5.298-0.112,10.129-0.178,14.767c-0.02,1.329-0.038,2.621-0.059,3.881c-21.52,1.497-40.17,0.555-43.43,0.368
   c-0.161-1.578-0.337-3.043-0.526-4.376c-4.037-28.479-4.51-53.391-4.515-53.639l-0.002-0.034c-0.018-0.143-1.865-14.43-4.923-31.358
   c-0.559-3.091-1.181-6.398-1.861-9.807c2.81-0.051,25.302-0.587,47.81-5.034c0.427,1.319,0.841,2.627,1.242,3.927
   c1.523,4.936,2.784,9.495,3.857,13.933l0.143,0.593c1.063,4.392,2.163,8.934,2.577,13.415
   C837.263,265.813,837.232,268.144,837.201,270.396"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M674.057,25.056c-0.02,0.049-0.034,0.102-0.043,0.156c-0.038,0.209-0.077,0.417-0.115,0.624l-1.341,0.003
   c-0.485-0.048-0.93,0.287-1.018,0.771c-3.203,17.586-8.312,27.731-8.364,27.832l-0.005,0.01c-0.041,0.09-0.369,0.905,0.65,2.21
   c-0.143,0.273-0.285,0.546-0.427,0.82c-0.843-0.604-1.183-1.093-1.187-1.097l-0.014-0.02c-0.802-1.006-0.616-1.591-0.607-1.618
   c0.19-0.381,5.879-11.916,9.061-29.388c0.013-0.074,0.048-0.271,0.402-0.271l1.759-0.004h0.011
   C672.828,25.084,673.386,25.062,674.057,25.056"
      />
      <path
        fill="#C6C6C6"
        d="M683.8,83.602l-0.298,1.203c-0.021,0.082-0.071,0.151-0.143,0.193c-0.072,0.043-0.157,0.055-0.238,0.035
   c-3.606-0.919-21.619-5.47-27.989-6.336c0.169-0.515,0.341-1.031,0.518-1.545C657.591,77.535,670.568,80.127,683.8,83.602"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M746.96,140.847c-2.066,9.517-4.648,20.508-5.5,22.881c-1.558,3.344-2.317,4.263-3.432,5.059
   c-1.086,0.775-14.224,3.367-16.888,3.139c-0.876-0.076-1.763-0.265-2.621-0.446l-0.369-0.077c-1.556-0.325-3.071-0.678-4.346-0.98
   c-1.3-0.307-2.66-0.639-4.16-1.01c-1.356-0.337-2.755-0.656-4.161-0.949c-1.031-0.214-2.063-0.425-3.094-0.635
   c-1.811-0.368-3.68-0.748-5.512-1.149c-0.584-0.127-1.189-0.252-1.772-0.372c-2.304-0.477-4.684-0.97-6.842-1.818
   c-2.272-0.893-4.415-2.562-6.486-4.174c-0.509-0.395-0.989-0.768-1.474-1.133c-1.027-0.774-2.377-1.804-3.69-2.905
   c-0.14-0.121-0.292-0.239-0.451-0.364c-0.511-0.399-1.092-0.853-1.38-1.379c-0.648-1.18-0.935-2.319-0.925-5.947
   c0.228-2.439,2.374-13.383,4.29-22.406l18.749,3.977L746.96,140.847z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M752.537,46.525c-0.039,1.556-0.263,10.489-0.458,18.245c-0.005,0.21-0.011,0.419-0.015,0.626
   c-0.133,5.29-0.251,9.913-0.28,11.078c-4.141,0.144-11.893-1.745-13.341-2.109l0.364-12.428l0.018-0.623l0.545-18.619
   L752.537,46.525z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M703.974,32.268c-0.203,1.784-1.429,12.576-2.382,20.957c-0.024,0.203-0.047,0.405-0.069,0.605
   c-0.518,4.551-0.943,8.283-1.057,9.289c-4.601-0.003-13.092-2.212-14.654-2.63l0.735-7.053l0.063-0.61l2.61-25.056L703.974,32.268z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M751.162,80.761l-0.675,19.873c-5.325,0.998-25.244,5.654-33.335,8.654l-13.928,4.848
   c0.393-4.383,0.768-8.616,1.121-12.666l12.146-5.023c1.366-0.566,2.749-1.191,4.108-1.858
   C729.77,90.086,748.083,82.1,751.162,80.761"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M692.808,86.116l-2.209,12.747c-0.171,0.547-0.757,0.892-1.368,0.802l-38.176-5.591
   c1.008-4.975,2.303-9.907,3.884-14.788c6.229,0.821,24.409,5.415,28.031,6.338c0.076,0.019,0.152,0.028,0.229,0.028
   c0.164,0,0.327-0.044,0.472-0.13c0.212-0.128,0.363-0.33,0.422-0.571l0.296-1.194C687.226,84.509,690.068,85.298,692.808,86.116"
      />
      <path
        fill={patchColor}
        onClick={() => handleClick("patch")}
        onMouseEnter={() => setPatchActive(true)}
        onMouseLeave={() => setPatchActive(false)}
        style={
          patchActive && !preview ? {fill: adjust(patchColor, 55)} : {fill: patchColor}
        }
        d="M743.972,247.721l-2.385,9.346l-0.017-0.005c-0.023,0.092-0.103,0.431-0.229,0.969
   c-0.001,0.004-0.002,0.008-0.004,0.014l-0.049,0.19l0.004,0.002c-0.988,4.239-4.204,18.583-3.925,24.513
   c0.317,6.784-0.945,42.49-1.934,50.182c-0.309,2.404-2.139,9.275-4.477,17.486c-26.964,0.175-55.36-4.653-58.597-5.218
   c2.91-17.417,5.899-33.457,8.633-44.78c2.668-11.054,5.793-31.238,9.297-60.051C692.921,240.971,719.055,246.827,743.972,247.721"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M1077.232,186.937c-5.036-0.199-11.63-0.834-15.024-2.71c-5.675-3.137-12.283-9.603-12.871-11.206
   c-0.42-1.147,2.055-14.643,3.855-23.613l22.738,2.522C1076.485,164.193,1076.909,176.053,1077.232,186.937"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M910.934,173.022c-0.588,1.603-7.197,8.069-12.871,11.206c-3.367,1.86-9.881,2.5-14.902,2.705
   c0.033-1.092,0.066-2.191,0.101-3.301c0.297-9.584,0.648-19.031,1.043-28.08c0.025-0.579,0.05-1.159,0.076-1.739
   c0.028-0.631,0.056-1.264,0.085-1.896l22.613-2.509C908.879,158.379,911.354,171.875,910.934,173.022"
      />
      <path
        fill="#C6C6C6"
        d="M953.215,72.969v1.535c0,0.424-0.297,0.779-0.662,0.792l-45.623,1.655c-0.231,0.009-0.435-0.199-0.463-0.472
   l-0.152-1.497c9.806-0.616,23.77-1.351,40.414-1.84C948.819,73.081,950.984,73.023,953.215,72.969"
      />
      <path
        fill="#C6C6C6"
        d="M1053.835,74.866l-0.162,1.585c-0.028,0.274-0.233,0.482-0.463,0.473l-45.623-1.656
   c-0.364-0.012-0.661-0.367-0.661-0.79v-1.636C1021.903,73.146,1037.761,73.769,1053.835,74.866"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M1062.514,75.505l-1.208,14.688c-0.061,0.741-0.73,1.336-1.556,1.387l-57.829,3.503
   c-0.932,0.057-1.733-0.578-1.784-1.415l-1.301-20.961c2.456,0.032,4.939,0.072,7.448,0.121v1.65c0,0.776,0.563,1.406,1.28,1.432
   l45.624,1.656h0.036c0.553,0,1.027-0.453,1.088-1.049l0.163-1.595l-0.336-0.035C1056.925,75.078,1059.719,75.284,1062.514,75.505"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M961.901,72.789l-1.295,20.878c-0.052,0.837-0.853,1.471-1.785,1.415l-57.827-3.502
   c-0.827-0.051-1.496-0.647-1.557-1.388l-1.206-14.671c2.082-0.148,4.577-0.318,7.442-0.499l0.156,1.522
   c0.061,0.595,0.535,1.049,1.088,1.049h0.036l45.624-1.657c0.718-0.025,1.28-0.654,1.28-1.432v-1.55
   C956.452,72.893,959.135,72.836,961.901,72.789"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M1041.927,27.108l0.479,19.744l-0.61-0.016l-0.481-19.806C1041.521,27.055,1041.724,27.082,1041.927,27.108"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M1048.147,27.929c0.07,0.01,0.14,0.02,0.21,0.029c-0.082-0.011-0.165-0.023-0.247-0.033
   c-0.074-0.011-0.149-0.02-0.224-0.031C1047.973,27.906,1048.06,27.917,1048.147,27.929"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M1049.421,28.103c0.045,0.006,0.091,0.013,0.137,0.02c-0.079-0.011-0.158-0.022-0.237-0.033
   c-0.051-0.008-0.1-0.014-0.151-0.021C1049.254,28.081,1049.338,28.091,1049.421,28.103"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M1050.636,28.272c0.061,0.009,0.121,0.017,0.18,0.026c-0.037-0.005-0.075-0.01-0.111-0.015
   c-0.074-0.011-0.15-0.022-0.225-0.032C1050.533,28.258,1050.584,28.266,1050.636,28.272"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M1050.872,28.306c0.078,0.011,0.156,0.021,0.233,0.032c-0.058-0.007-0.117-0.016-0.176-0.023l-0.113-0.016
   C1050.834,28.301,1050.853,28.304,1050.872,28.306"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M1057.695,47.262l-0.611-0.016l-0.709-18.146c0.214,0.031,0.418,0.062,0.613,0.091L1057.695,47.262z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M1003.057,23.326l-6.807,27.35c-0.089,0.361-0.413,0.614-0.785,0.614h-31.619
   c-0.374,0-0.698-0.254-0.787-0.617l-6.674-27.288c7.543-0.471,15.161-0.743,22.108-0.634l0.002,0.086
   c0.563-0.021,1.131-0.038,1.705-0.052c0.572,0.014,1.141,0.031,1.702,0.052l0.004-0.086
   C988.56,22.647,995.828,22.891,1003.057,23.326"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M911.992,27.965c-0.43,0.059-0.852,0.117-1.263,0.173C911.14,28.081,911.561,28.023,911.992,27.965"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M918.791,27.068c-0.613,0.078-1.215,0.156-1.806,0.232C917.576,27.223,918.178,27.145,918.791,27.068"
      />
      <path
        d="M994.22,31.677c0,0.564-0.419,1.007-0.964,1.007c-0.54,0-0.97-0.443-0.97-1.007c0-0.551,0.43-0.994,0.97-0.994
   C993.801,30.683,994.22,31.126,994.22,31.677 M992.527,31.677c0,0.443,0.31,0.794,0.734,0.794c0.413,0,0.718-0.351,0.718-0.788
   c0-0.442-0.305-0.8-0.723-0.8C992.837,30.883,992.527,31.241,992.527,31.677 M993.106,32.199h-0.218v-0.995
   c0.086-0.018,0.207-0.03,0.362-0.03c0.178,0,0.258,0.03,0.327,0.073c0.052,0.042,0.092,0.121,0.092,0.218
   c0,0.109-0.08,0.194-0.195,0.231v0.012c0.092,0.036,0.143,0.109,0.172,0.242c0.028,0.152,0.046,0.212,0.069,0.249h-0.236
   c-0.028-0.037-0.046-0.127-0.075-0.243c-0.017-0.109-0.074-0.157-0.194-0.157h-0.104V32.199z M993.112,31.635h0.104
   c0.12,0,0.217-0.042,0.217-0.146c0-0.09-0.063-0.151-0.2-0.151c-0.058,0-0.098,0.006-0.121,0.012V31.635z"
      />
      <path
        d="M983.777,34.11l-1.583-3.099l-1.597,4.942l0.849,0.281l0.896-3.031l1.339,2.605l0.383-0.639
   c0.181-0.304,0.353-0.591,0.524-0.879c0.178-0.302,0.355-0.604,0.549-0.937l0.109-0.187l1.065,3.087l0.84-0.367l-1.712-4.653
   L983.777,34.11z"
      />
      <path
        d="M978.088,31.275h-0.009c-0.655,0.002-1.257,0.259-1.694,0.726c-0.431,0.46-0.665,1.086-0.66,1.763
   c0.011,1.343,0.996,2.36,2.292,2.366h0.011c0.659,0,1.259-0.251,1.691-0.706c0.429-0.451,0.665-1.076,0.665-1.76
   c-0.001-0.671-0.227-1.279-0.637-1.71C979.33,31.515,978.741,31.275,978.088,31.275 M979.468,33.676
   c0.022,0.886-0.615,1.656-1.391,1.681c-0.329,0.01-0.653-0.129-0.913-0.394c-0.314-0.319-0.495-0.776-0.498-1.255
   c-0.005-0.927,0.597-1.633,1.4-1.641h0.012C978.822,32.067,979.445,32.786,979.468,33.676"
      />
      <path
        d="M991.393,31.977c-0.414-0.448-0.996-0.697-1.639-0.702h-0.021c-1.354,0-2.347,1.001-2.363,2.387
   c-0.008,0.701,0.217,1.333,0.632,1.78c0.411,0.441,0.996,0.685,1.648,0.688h0.01c1.324,0,2.337-1.036,2.357-2.415
   C992.027,33.04,991.805,32.422,991.393,31.977 M989.672,35.36h-0.002c-0.323,0-0.648-0.159-0.916-0.445
   c-0.31-0.333-0.492-0.797-0.486-1.241c0.007-0.452,0.179-0.885,0.474-1.188c0.264-0.271,0.605-0.418,0.961-0.418h0.021
   c0.76,0.012,1.356,0.734,1.355,1.643c-0.001,0.448-0.148,0.866-0.416,1.176C990.4,35.192,990.048,35.36,989.672,35.36"
      />
      <polygon points="967.934,30.123 965.166,35.699 965.985,36.239 967.923,31.99 970.058,36.233 970.884,35.654 " />
      <polygon
        points="971.666,31.352 971.666,32.128 973.939,32.128 971.15,36.042 975.139,36.042 975.208,35.252 972.784,35.252 
   975.548,31.352 "
      />
      <polygon
        points="969.683,38.691 970.055,38.691 970.794,40.34 971.529,38.691 971.898,38.691 971.898,40.794 971.553,40.794 
   971.553,39.354 970.912,40.794 970.673,40.794 970.028,39.354 970.028,40.794 969.683,40.794 "
      />
      <path
        d="M973.023,39.099c0.282,0,0.476,0.133,0.578,0.27v-0.242h0.349v1.667h-0.349v-0.248c-0.106,0.142-0.305,0.275-0.584,0.275
   c-0.432,0-0.78-0.354-0.78-0.868S972.585,39.099,973.023,39.099 M973.096,39.399c-0.257,0-0.505,0.194-0.505,0.554
   c0,0.36,0.248,0.569,0.505,0.569c0.26,0,0.505-0.203,0.505-0.563C973.601,39.602,973.356,39.399,973.096,39.399"
      />
      <path
        d="M975.078,39.099c0.218,0,0.448,0.103,0.575,0.26v-0.804h0.349v2.239h-0.349v-0.251c-0.106,0.151-0.305,0.278-0.578,0.278
   c-0.439,0-0.787-0.354-0.787-0.868S974.636,39.099,975.078,39.099 M975.148,39.399c-0.257,0-0.505,0.194-0.505,0.554
   c0,0.36,0.248,0.569,0.505,0.569c0.26,0,0.505-0.203,0.505-0.563C975.653,39.602,975.408,39.399,975.148,39.399"
      />
      <path
        d="M977.172,40.822c-0.478,0-0.832-0.339-0.832-0.863c0-0.523,0.339-0.859,0.832-0.859c0.475,0,0.811,0.33,0.811,0.82
   c0,0.058-0.003,0.112-0.012,0.169h-1.274c0.024,0.276,0.221,0.442,0.475,0.442c0.212,0,0.33-0.103,0.394-0.233h0.372
   C977.844,40.589,977.581,40.822,977.172,40.822 M976.7,39.81h0.923c-0.006-0.257-0.209-0.421-0.466-0.421
   C976.924,39.389,976.737,39.548,976.7,39.81"
      />
      <path
        d="M980.035,39.099c0.442,0,0.783,0.34,0.783,0.854s-0.345,0.868-0.783,0.868c-0.276,0-0.472-0.124-0.581-0.269v0.242h-0.346
   v-2.239h0.346v0.82C979.563,39.224,979.771,39.099,980.035,39.099 M979.959,39.399c-0.257,0-0.505,0.203-0.505,0.56
   c0,0.36,0.248,0.563,0.505,0.563c0.26,0,0.508-0.209,0.508-0.569C980.467,39.593,980.219,39.399,979.959,39.399"
      />
      <polygon
        points="982.304,39.126 982.661,39.126 981.638,41.578 981.281,41.578 981.62,40.767 980.964,39.126 981.348,39.126 
   981.817,40.397 "
      />
      <path
        d="M984.401,40.815c-0.421,0-0.745-0.23-0.745-0.603h0.37c0.015,0.173,0.136,0.312,0.375,0.312c0.242,0,0.378-0.13,0.378-0.308
   c0-0.509-1.117-0.179-1.117-0.954c0-0.369,0.294-0.599,0.724-0.599c0.402,0,0.687,0.212,0.717,0.572h-0.381
   c-0.012-0.142-0.136-0.273-0.355-0.278c-0.199-0.006-0.354,0.09-0.354,0.293c0,0.476,1.114,0.179,1.114,0.947
   C985.127,40.512,984.87,40.815,984.401,40.815"
      />
      <polygon
        points="985.427,38.691 986.895,38.691 986.895,38.972 986.335,38.972 986.335,40.794 985.99,40.794 985.99,38.972 
   985.427,38.972 "
      />
      <rect x="987.242" y="38.691" width="0.345" height="2.103" />
      <polygon
        points="988.041,38.691 988.413,38.691 989.152,40.34 989.887,38.691 990.256,38.691 990.256,40.794 989.911,40.794 
   989.911,39.354 989.27,40.794 989.031,40.794 988.386,39.354 988.386,40.794 988.041,40.794 "
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.61"
        strokeMiterlimit="10"
        d="M653.38,476.929
   c0,0,15.87-129.012,27.344-176.529c3.188-13.202,6.711-38.059,10.137-67.074"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="751.167"
        y1="83.291"
        x2="751.583"
        y2="83.1"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="752.415"
        y1="82.716"
        x2="752.416"
        y2="82.716"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.918,0.917"
        d="M752.416,82.716
   l1.448-0.667c0.928-0.363,3.449-1.918,4.142-2.688c0.311-0.345,0.713-0.741,0.928-1.171c0.651-1.303,1.303-8.328,1.466-10.194"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M760.401,67.995
   c0.025-0.29,0.039-0.455,0.039-0.455"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M758.988,67.379
   c-0.012,0.151-0.025,0.303-0.039,0.456"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.877,0.876"
        d="M758.867,68.707
   c-0.379,3.856-1.032,8-1.38,8.768c-0.073,0.146-0.321,0.414-0.502,0.61c-0.061,0.067-0.121,0.132-0.178,0.196
   c-0.483,0.536-2.758,1.962-3.529,2.263l-0.038,0.015l-0.037,0.016l-1.432,0.609"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="751.771"
        y1="81.184"
        x2="751.35"
        y2="81.364"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="703.926"
        y1="103.875"
        x2="704.351"
        y2="103.707"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="705.189"
        y1="103.374"
        x2="705.19"
        y2="103.374"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.903,0.902"
        d="M705.19,103.374
   l13.065-5.18c2.67-1.393,5.933-3.019,9.817-4.84c4.597-2.154,16.252-7.308,20.015-8.979"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M748.087,84.375
   c0.153-0.067,0.292-0.13,0.418-0.186l0.003,0.458"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="748.515"
        y1="85.587"
        x2="748.515"
        y2="85.588"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.941,0.94"
        x1="748.515"
        y1="85.588"
        x2="748.614"
        y2="98.763"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M748.615,98.763l0.003,0.458
   c-0.139,0.025-0.289,0.053-0.449,0.083"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="747.274"
        y1="99.476"
        x2="747.274"
        y2="99.476"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.913,0.912"
        d="M747.273,99.476
   c-6.395,1.261-22.733,4.935-29.815,7.591l-13.956,5.062"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="703.501"
        y1="112.129"
        x2="703.071"
        y2="112.285"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="703.926"
        y1="102.657"
        x2="704.345"
        y2="102.475"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="705.18"
        y1="102.113"
        x2="705.181"
        y2="102.113"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.911,0.91"
        d="M705.181,102.113
   l13.275-5.751c2.362-1.214,5.297-2.657,8.934-4.36c6.045-2.831,19.085-8.573,22.603-10.121"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M749.992,81.881
   c0.16-0.07,0.3-0.132,0.418-0.184l-0.012,0.457"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="750.374"
        y1="83.083"
        x2="750.374"
        y2="83.084"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.931,0.93"
        x1="750.373"
        y1="83.084"
        x2="749.921"
        y2="99.838"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M749.921,99.838l-0.012,0.458
   c-0.141,0.017-0.292,0.038-0.453,0.063"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="748.563"
        y1="100.504"
        x2="748.562"
        y2="100.504"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.906,0.905"
        d="
   M748.562,100.505c-6.552,1.144-23.792,5.505-31.225,8.274c0,0-9.951,3.347-13.976,4.872"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M703.361,113.651
   c-0.151,0.057-0.293,0.112-0.427,0.164"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M701.054,87.359
   c-0.188-0.067-0.377-0.133-0.568-0.2"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.235,1.233"
        d="M699.319,86.759
   c-15.92-5.391-39.092-10.083-43.068-10.872"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M656.249,75.887
   c-0.385-0.076-0.59-0.116-0.59-0.116"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M701.339,85.069
   c-0.188-0.067-0.377-0.134-0.568-0.2"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.218,1.217"
        d="M699.62,84.473
   c-15.793-5.36-38.569-9.87-42.509-10.632"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M657.111,73.841
   c-0.386-0.075-0.591-0.113-0.591-0.113"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M700.412,130.429c0.018-0.2,0.036-0.4,0.054-0.6
   "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="700.574"
        y1="128.643"
        x2="700.574"
        y2="128.642"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.192,1.191"
        d="
   M700.574,128.642c3.253-35.823,5.925-68.82,6.312-73.626"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M706.887,55.016
   c0.032-0.395,0.048-0.6,0.048-0.6l-0.05,0.6"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="706.785"
        y1="56.202"
        x2="706.785"
        y2="56.203"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.19,1.189"
        x1="706.785"
        y1="56.203"
        x2="704.004"
        y2="89.413"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="704.004"
        y1="89.413"
        x2="703.954"
        y2="90.013"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M652.304,476.929c0,0,0.025-0.204,0.074-0.597"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="652.527"
        y1="475.133"
        x2="652.527"
        y2="475.133"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="
   M652.527,475.132c1.96-15.731,16.444-130.516,27.121-174.732c3.703-15.335,6.156-31.713,10.066-66.579"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M689.714,233.82
   c0.022-0.199,0.044-0.398,0.067-0.599"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M699.143,130.185c0.019-0.2,0.037-0.4,0.055-0.6
   "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="699.305"
        y1="128.404"
        x2="699.305"
        y2="128.403"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.188,1.187"
        d="
   M699.305,128.403c3.242-35.708,5.904-68.59,6.291-73.386"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M705.595,55.016
   c0.032-0.395,0.048-0.6,0.048-0.6l-0.05,0.6"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="705.494"
        y1="56.202"
        x2="705.494"
        y2="56.203"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.19,1.189"
        x1="705.494"
        y1="56.203"
        x2="702.713"
        y2="89.413"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="702.713"
        y1="89.413"
        x2="702.663"
        y2="90.013"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M651.013,476.929c0,0,0.025-0.204,0.074-0.597"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="651.236"
        y1="475.132"
        x2="651.236"
        y2="475.131"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.21,1.209"
        d="M651.236,475.131
   c1.96-15.734,16.444-130.516,27.121-174.731c3.708-15.357,6.168-31.805,10.083-66.734"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M688.44,233.665
   c0.022-0.199,0.045-0.398,0.067-0.599"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M697.966,130.119c0.018-0.2,0.036-0.4,0.054-0.6
   "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="698.128"
        y1="128.338"
        x2="698.128"
        y2="128.337"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.187,1.186"
        d="
   M698.128,128.336c3.239-35.676,5.898-68.526,6.285-73.32"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M704.412,55.016
   c0.032-0.395,0.048-0.6,0.048-0.6l-0.05,0.6"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="704.311"
        y1="56.202"
        x2="704.311"
        y2="56.203"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.19,1.189"
        x1="704.311"
        y1="56.203"
        x2="701.53"
        y2="89.413"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="701.53"
        y1="89.413"
        x2="701.48"
        y2="90.013"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M649.83,476.929c0,0,0.025-0.204,0.074-0.597"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="650.051"
        y1="475.143"
        x2="650.051"
        y2="475.143"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.199,1.198"
        d="
   M650.052,475.142c1.955-15.692,16.443-130.517,27.122-174.743c3.713-15.378,6.18-31.889,10.1-66.878"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M687.273,233.521
   c0.022-0.199,0.045-0.398,0.067-0.598"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M763.93,170.707
   c0.007,0.171,0.018,0.37,0.034,0.601"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="764.073"
        y1="172.506"
        x2="764.073"
        y2="172.507"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.205,1.204"
        d="
   M764.073,172.507c0.378,3.517,1.631,11.233,5.575,27.667c10.112,23.127,17.426,80.032,17.426,80.032s0.431,24.848,4.518,53.677
   c3.654,25.771,2.253,99.832,1.915,115.25"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M793.507,449.135
   c-0.005,0.211-0.009,0.412-0.013,0.601"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M762.854,174.857
   c0.027,0.191,0.057,0.39,0.088,0.595"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="763.128"
        y1="176.644"
        x2="763.128"
        y2="176.645"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.208,1.207"
        d="
   M763.129,176.645c0.727,4.479,2.171,11.795,5.013,23.637c10.112,23.127,17.426,80.032,17.426,80.032s0.431,24.849,4.519,53.677
   c3.643,25.693,2.261,99.378,1.917,115.107"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M792.004,449.099
   c-0.004,0.211-0.009,0.412-0.013,0.602"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M762.124,177.611
   c0.033,0.193,0.067,0.391,0.102,0.593"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="762.438"
        y1="179.39"
        x2="762.438"
        y2="179.391"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.206,1.205"
        d="M762.438,179.39
   c0.829,4.551,2.215,11.178,4.521,20.784c10.111,23.127,17.426,80.031,17.426,80.031s0.43,24.849,4.518,53.678
   c3.645,25.712,2.259,99.491,1.917,115.143"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M790.82,449.027
   c-0.004,0.211-0.009,0.412-0.013,0.602"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.392"
        strokeMiterlimit="10"
        strokeDasharray="1.177,1.177"
        d="M692.403,85.773
   l-2.238,12.909c-0.109,0.368-0.518,0.597-0.951,0.533l-38.309-5.611"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.392"
        strokeMiterlimit="10"
        strokeDasharray="1.177,1.177"
        d="M690.555,85.291
   l-1.581,10.686c-0.189,0.639-0.802,1.043-1.439,0.95l-36.214-5.304"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M705.85,465.691c0,0-0.204,0.041-0.591,0.111"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="704.055"
        y1="466.012"
        x2="704.055"
        y2="466.012"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.223,1.222"
        d="
   M704.054,466.012c-6.555,1.096-29.785,4.315-48.526-1.377"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M655.527,464.635
   c-0.192-0.059-0.384-0.118-0.575-0.178"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M650.353,463.182c0,0-0.207-0.062-0.576-0.173"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="648.67"
        y1="462.674"
        x2="648.669"
        y2="462.674"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.158,1.157"
        d="
   M648.669,462.674c-3.632-1.107-12.13-3.763-15.312-5.302"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M633.356,457.372
   c-0.2-0.097-0.379-0.189-0.535-0.276"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        d="
   M834.042,435.385c0,0-18.747,6.871-39.527,4.103"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        d="
   M790.086,438.979c0,0-19.714-1.243-27.929-4.171"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.355"
        strokeMiterlimit="10"
        strokeDasharray="1.065,1.065"
        d="M719.513,168.86
   c0.66,0.137,1.359,0.276,2.009,0.331c2.014,0.17,13.392-2.003,15.437-2.805c0.447-0.34,0.955-0.896,2.221-3.605
   c0.685-2.035,2.684-10.36,4.705-19.564l-47.574-10.194l-16.334-3.478c-1.841,8.778-3.423,17.035-3.655,19.116
   c-0.004,3.245,0.261,3.8,0.547,4.323c0.127,0.16,0.522,0.469,0.762,0.655c0.148,0.116,0.337,0.263,0.522,0.42
   c1.244,1.044,2.515,2.016,3.594,2.829c0.472,0.354,0.933,0.712,1.42,1.091l0.081,0.063c1.952,1.519,3.969,3.088,5.954,3.868
   c1.807,0.709,3.818,1.155,5.894,1.586c0,0,1.132,0.234,1.397,0.289c0.338,0.07,0.677,0.141,1.009,0.214
   c0.691,0.15,1.436,0.308,2.278,0.484c1.002,0.208,2.003,0.411,2.987,0.611l0.226,0.045c1.034,0.21,2.07,0.42,3.105,0.634
   c1.446,0.3,2.875,0.625,4.251,0.967c1.593,0.393,2.909,0.711,4.141,1.001c1.342,0.317,2.792,0.653,4.298,0.966L719.513,168.86z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.355"
        strokeMiterlimit="10"
        strokeDasharray="1.065,1.065"
        d="
   M719.207,170.234c0.692,0.144,1.428,0.29,2.138,0.351c2.513,0.213,14.707-2.244,16.124-2.944c0.758-0.549,1.386-1.19,2.866-4.364
   c0.803-2.31,3.143-12.253,5.101-21.218l-48.819-10.442l-17.542-3.728c-1.797,8.518-3.729,18.385-3.972,20.758
   c-0.007,3.519,0.291,4.328,0.745,5.156c0.164,0.299,0.683,0.704,1.061,1c0.183,0.142,0.337,0.263,0.492,0.395
   c1.259,1.057,2.546,2.041,3.638,2.864c0.465,0.349,0.922,0.704,1.406,1.08l0.081,0.063c2.011,1.566,4.09,3.184,6.221,4.021
   c1.882,0.74,3.94,1.197,6.062,1.639c0,0,1.131,0.234,1.395,0.288c0.335,0.07,0.67,0.141,0.999,0.213
   c0.693,0.151,1.441,0.31,2.286,0.486c1.002,0.209,2.002,0.412,2.987,0.612l0.229,0.047c1.032,0.209,2.066,0.42,3.1,0.634
   c1.428,0.297,2.843,0.619,4.206,0.958c1.595,0.395,2.915,0.714,4.15,1.006c1.348,0.318,2.805,0.656,4.322,0.972l0.432,0.092
   L719.207,170.234z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.355"
        strokeMiterlimit="10"
        strokeDasharray="1.065,1.065"
        d="
   M673.313,151.087c-5.888,25.518-12.65,56.291-13.171,61.508c0.014,3.17,0.273,3.974,0.669,4.691
   c1.159,1.312,11.091,8.696,13.325,9.563c0.412,0.159,0.862,0.288,1.406,0.442c0.815,0.23,4.432,1.08,6.172,1.488
   c1.017,0.24,1.764,0.415,2.125,0.504c1.211,0.295,2.488,0.595,4.016,0.944l0.559,0.127c0.942,0.214,1.923,0.434,2.925,0.655
   c0.249,0.055,0.499,0.111,0.748,0.167c1.215,0.276,2.438,0.573,3.635,0.882c1.539,0.399,2.949,0.756,4.311,1.093
   c1.139,0.282,2.494,0.613,3.895,0.931c0.195,0.045,0.391,0.088,0.588,0.132l0.387,0.086c0.849,0.191,1.723,0.386,2.536,0.47
   c2.422,0.25,14.815-1.853,16.464-2.511c0.685-0.469,1.28-1.083,2.69-3.972c1.901-5.272,9.035-38.558,13.787-61.641"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.177"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        points="
   681.915,127.826 680.93,128.935 681.316,127.698 680.332,128.807 680.717,127.57 679.733,128.679 680.118,127.442 679.135,128.551 
   679.519,127.315 678.537,128.423 678.921,127.187 677.939,128.295 678.323,127.059 677.342,128.168 "
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.177"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        points="
   747.332,141.708 746.277,142.826 746.711,141.576 745.657,142.693 746.091,141.443 745.037,142.561 745.47,141.311 744.417,142.428 
   744.85,141.178 743.797,142.295 744.23,141.046 743.178,142.163 743.61,140.914 742.559,142.031 "
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.506"
        strokeMiterlimit="10"
        strokeDasharray="1.518,1.518"
        d="
   M649.404,103.067c1.138,1.059,2.21,2.145,3.214,3.264c9.961,11.104,6.246,37.172,3.277,53.419c-0.73,3.998-1.686,8.524-2.905,13.692
   "
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.506"
        strokeMiterlimit="10"
        strokeDasharray="1.518,1.518"
        d="
   M649.113,105.213c0.817,0.762,1.598,1.541,2.342,2.338c10.048,10.766,6,37.15,2.805,53.641c-0.419,2.166-0.906,4.481-1.466,6.963"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.405"
        strokeMiterlimit="10"
        strokeDasharray="1.215,1.215"
        d="M690.255,241.23
   c0,0,27.821,6.719,54.252,7.593"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.405"
        strokeMiterlimit="10"
        strokeDasharray="1.215,1.215"
        d="
   M689.617,243.029c0,0,27.821,6.719,54.251,7.594"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        d="
   M781.158,237.824c0,0,24.401-0.289,48.64-5.144"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        d="M781.588,239.76
   c0,0,24.304-0.331,48.754-5.323"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.268,1.268"
        d="
   M672.678,342.297c0,0,30.63,5.524,59.428,5.27"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.268,1.268"
        d="
   M672.082,344.121c0,0,30.63,5.524,59.428,5.27"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.422"
        strokeMiterlimit="10"
        strokeDasharray="1.266,1.266"
        d="M792.56,333.13
   c0,0,20.716,1.252,44.368-0.379"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.422"
        strokeMiterlimit="10"
        strokeDasharray="1.266,1.266"
        d="
   M792.775,334.959c0,0,20.321,1.317,44.101-0.349"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M751.117,76.662
   c0,0.001,0.005-0.211,0.016-0.602"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="751.164"
        y1="74.886"
        x2="751.164"
        y2="74.885"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.177,1.176"
        d="M751.164,74.885
   c0.155-5.895,0.648-24.633,0.743-28.235"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M751.907,46.649
   c0.01-0.389,0.016-0.602,0.016-0.602"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M748.843,76.309
   c0,0.001,0.006-0.211,0.018-0.601"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="748.895"
        y1="74.519"
        x2="748.895"
        y2="74.518"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.19,1.189"
        d="M748.895,74.518
   c0.173-5.957,0.724-24.933,0.83-28.559"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M749.725,45.959
   c0.011-0.389,0.017-0.601,0.017-0.601"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="740.192"
        y1="42.686"
        x2="740.175"
        y2="43.288"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="740.14"
        y1="44.525"
        x2="740.14"
        y2="44.526"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.238,1.237"
        x1="740.14"
        y1="44.526"
        x2="739.308"
        y2="74.226"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="739.309"
        y1="74.226"
        x2="739.292"
        y2="74.828"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="742.594"
        y1="43.442"
        x2="742.578"
        y2="44.044"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="742.548"
        y1="45.265"
        x2="742.548"
        y2="45.266"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.223,1.222"
        x1="742.548"
        y1="45.267"
        x2="741.81"
        y2="74.614"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="741.809"
        y1="74.614"
        x2="741.794"
        y2="75.216"
      />
      <path
        d="M741.018,43.647l-0.464,0.497l0.143-0.509c0.007-0.027-0.005-0.056-0.029-0.07c-0.025-0.013-0.055-0.008-0.075,0.012
   l-0.464,0.497l0.143-0.509c0.008-0.027-0.004-0.056-0.029-0.069c-0.024-0.014-0.055-0.01-0.074,0.011l-0.464,0.497l0.143-0.509
   c0.007-0.027-0.005-0.056-0.029-0.069c-0.025-0.014-0.056-0.009-0.075,0.011l-0.635,0.681l0.089,0.083l0.464-0.497l-0.143,0.508
   c-0.007,0.028,0.004,0.057,0.029,0.07c0.024,0.014,0.055,0.009,0.074-0.011l0.465-0.498l-0.143,0.51
   c-0.008,0.027,0.004,0.055,0.029,0.069c0.024,0.014,0.055,0.009,0.074-0.011l0.464-0.498l-0.142,0.51
   c-0.008,0.026,0.003,0.055,0.028,0.069c0.006,0.004,0.013,0.006,0.02,0.007c0.02,0.003,0.04-0.003,0.055-0.018l0.635-0.681
   L741.018,43.647z"
      />
      <path
        d="M743.385,44.292l-0.464,0.497l0.143-0.509c0.008-0.027-0.004-0.056-0.029-0.07c-0.025-0.013-0.055-0.009-0.074,0.012
   l-0.465,0.497l0.143-0.509c0.008-0.027-0.004-0.056-0.028-0.069c-0.025-0.014-0.056-0.01-0.075,0.011l-0.464,0.497l0.143-0.509
   c0.007-0.027-0.005-0.056-0.029-0.07c-0.025-0.013-0.055-0.008-0.074,0.012l-0.636,0.68l0.089,0.084l0.465-0.497l-0.144,0.508
   c-0.007,0.028,0.005,0.056,0.029,0.07c0.025,0.013,0.055,0.009,0.075-0.011l0.464-0.498l-0.143,0.509
   c-0.008,0.028,0.004,0.056,0.029,0.07c0.024,0.014,0.055,0.009,0.074-0.012l0.465-0.497l-0.143,0.51
   c-0.008,0.026,0.004,0.055,0.028,0.069c0.007,0.003,0.014,0.006,0.02,0.007c0.02,0.003,0.041-0.003,0.055-0.018l0.635-0.681
   L743.385,44.292z"
      />
      <path
        d="M740.158,73.336l-0.464,0.498l0.143-0.51c0.008-0.027-0.005-0.055-0.029-0.069c-0.025-0.014-0.055-0.009-0.074,0.011
   l-0.465,0.498l0.143-0.51c0.008-0.026-0.004-0.055-0.028-0.069c-0.025-0.014-0.056-0.009-0.075,0.011l-0.464,0.497l0.143-0.508
   c0.007-0.028-0.005-0.056-0.029-0.07c-0.025-0.014-0.055-0.009-0.074,0.012l-0.636,0.68l0.089,0.083l0.465-0.497l-0.144,0.509
   c-0.007,0.027,0.005,0.056,0.029,0.07c0.025,0.013,0.055,0.009,0.074-0.012l0.465-0.497l-0.143,0.509
   c-0.008,0.027,0.004,0.055,0.029,0.07c0.024,0.013,0.055,0.008,0.074-0.012l0.465-0.497l-0.143,0.509
   c-0.008,0.027,0.004,0.056,0.028,0.069c0.007,0.004,0.014,0.006,0.02,0.007c0.02,0.004,0.04-0.003,0.055-0.018l0.635-0.681
   L740.158,73.336z"
      />
      <path
        d="M742.632,73.659l-0.464,0.498l0.143-0.51c0.008-0.027-0.005-0.055-0.029-0.069c-0.025-0.014-0.055-0.009-0.074,0.011
   l-0.465,0.497l0.143-0.509c0.008-0.026-0.004-0.055-0.028-0.069c-0.025-0.014-0.056-0.009-0.075,0.011l-0.464,0.497l0.143-0.508
   c0.007-0.028-0.005-0.056-0.029-0.07c-0.025-0.014-0.055-0.009-0.074,0.012l-0.636,0.68l0.089,0.083l0.465-0.497l-0.144,0.509
   c-0.007,0.027,0.005,0.056,0.029,0.07c0.025,0.013,0.055,0.009,0.074-0.012l0.465-0.497l-0.143,0.509
   c-0.008,0.027,0.004,0.055,0.029,0.07c0.024,0.013,0.055,0.008,0.074-0.012l0.465-0.497l-0.143,0.509
   c-0.008,0.027,0.004,0.056,0.028,0.069c0.007,0.004,0.014,0.006,0.02,0.007c0.02,0.004,0.04-0.003,0.055-0.018l0.635-0.681
   L742.632,73.659z"
      />
      <path
        d="M749.731,74.842l-0.464,0.497l0.143-0.509c0.008-0.027-0.005-0.056-0.029-0.07c-0.025-0.013-0.055-0.009-0.074,0.012
   l-0.465,0.497l0.143-0.509c0.008-0.027-0.004-0.056-0.028-0.069c-0.025-0.014-0.056-0.01-0.075,0.011l-0.464,0.497l0.143-0.509
   c0.007-0.027-0.005-0.056-0.029-0.069c-0.025-0.014-0.055-0.009-0.074,0.011l-0.636,0.68l0.089,0.084l0.465-0.497l-0.144,0.508
   c-0.007,0.028,0.005,0.057,0.029,0.07c0.025,0.013,0.055,0.009,0.074-0.011l0.465-0.498l-0.143,0.509
   c-0.008,0.028,0.004,0.056,0.029,0.07c0.024,0.014,0.055,0.009,0.074-0.011l0.465-0.498l-0.143,0.51
   c-0.008,0.026,0.004,0.055,0.028,0.069c0.007,0.003,0.014,0.006,0.02,0.007c0.02,0.003,0.04-0.003,0.055-0.018l0.635-0.681
   L749.731,74.842z"
      />
      <path
        d="M751.883,75.165l-0.464,0.497l0.143-0.509c0.008-0.027-0.004-0.056-0.029-0.07c-0.025-0.013-0.055-0.009-0.074,0.012
   l-0.465,0.497l0.143-0.509c0.008-0.027-0.004-0.056-0.028-0.069c-0.025-0.015-0.056-0.01-0.075,0.011l-0.464,0.497l0.143-0.509
   c0.007-0.027-0.005-0.056-0.029-0.07c-0.025-0.013-0.055-0.008-0.074,0.012l-0.636,0.68l0.089,0.084l0.465-0.497l-0.144,0.508
   c-0.007,0.028,0.005,0.056,0.029,0.07c0.025,0.013,0.055,0.009,0.075-0.011l0.464-0.498l-0.143,0.509
   c-0.008,0.028,0.004,0.056,0.029,0.07c0.024,0.014,0.055,0.009,0.074-0.012l0.465-0.497l-0.143,0.51
   c-0.008,0.026,0.004,0.055,0.028,0.069c0.007,0.003,0.014,0.006,0.02,0.007c0.02,0.003,0.04-0.003,0.055-0.018l0.635-0.681
   L751.883,75.165z"
      />
      <path
        d="M750.484,46.228l-0.464,0.497l0.143-0.509c0.008-0.027-0.004-0.055-0.029-0.07c-0.025-0.013-0.055-0.008-0.074,0.012
   l-0.465,0.497l0.143-0.509c0.008-0.027-0.004-0.056-0.028-0.069c-0.025-0.014-0.056-0.009-0.075,0.011l-0.464,0.497l0.143-0.508
   c0.007-0.028-0.005-0.057-0.029-0.07c-0.025-0.014-0.055-0.009-0.074,0.011l-0.636,0.681l0.089,0.083l0.465-0.497l-0.144,0.509
   c-0.007,0.027,0.005,0.056,0.029,0.069c0.025,0.014,0.055,0.01,0.075-0.011l0.464-0.498l-0.143,0.51
   c-0.008,0.027,0.004,0.055,0.029,0.069c0.024,0.014,0.055,0.009,0.074-0.011l0.465-0.497l-0.143,0.509
   c-0.008,0.027,0.004,0.055,0.028,0.069c0.007,0.004,0.014,0.006,0.02,0.007c0.02,0.004,0.041-0.003,0.055-0.018l0.635-0.681
   L750.484,46.228z"
      />
      <path
        d="M752.635,46.766l-0.464,0.497l0.143-0.509c0.008-0.027-0.004-0.056-0.029-0.07c-0.025-0.013-0.055-0.009-0.074,0.012
   l-0.465,0.497l0.143-0.509c0.008-0.027-0.004-0.056-0.028-0.069c-0.025-0.015-0.056-0.01-0.075,0.011l-0.464,0.497l0.143-0.509
   c0.007-0.027-0.004-0.056-0.029-0.07c-0.025-0.013-0.055-0.008-0.074,0.012l-0.636,0.68l0.089,0.084l0.465-0.497l-0.144,0.508
   c-0.007,0.028,0.005,0.056,0.029,0.07c0.025,0.013,0.055,0.009,0.075-0.011l0.464-0.498l-0.143,0.509
   c-0.008,0.028,0.004,0.056,0.029,0.07c0.024,0.014,0.055,0.009,0.074-0.012l0.465-0.497l-0.143,0.51
   c-0.008,0.026,0.004,0.055,0.028,0.069c0.007,0.003,0.014,0.006,0.02,0.007c0.02,0.003,0.041-0.003,0.055-0.018l0.635-0.681
   L752.635,46.766z"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="772.23"
        y1="53.772"
        x2="771.661"
        y2="53.575"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="770.625"
        y1="53.216"
        x2="770.624"
        y2="53.216"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.096,1.095"
        x1="770.624"
        y1="53.216"
        x2="764.408"
        y2="51.064"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        points="764.408,51.064 763.839,50.867 
   763.828,51.469 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="763.807"
        y1="52.592"
        x2="763.807"
        y2="52.593"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.124,1.123"
        x1="763.807"
        y1="52.593"
        x2="763.559"
        y2="66.078"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        points="763.559,66.078 763.548,66.68 
   764.127,66.846 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="765.201"
        y1="67.153"
        x2="765.202"
        y2="67.153"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.118,1.117"
        x1="765.202"
        y1="67.154"
        x2="771.651"
        y2="69.001"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="771.651"
        y1="69"
        x2="772.23"
        y2="69.166"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        x1="763.548"
        y1="66.68"
        x2="772.23"
        y2="61.708"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        x1="763.839"
        y1="50.867"
        x2="772.23"
        y2="60.656"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        x1="762.836"
        y1="50.457"
        x2="752.847"
        y2="47.505"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        x1="762.454"
        y1="66.457"
        x2="752.44"
        y2="63.714"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        d="M738.573,60.561
   c0,0-26.718-7.863-33.897-8.295l-2.366-0.108"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        d="M739.074,43.442
   c0,0-28.174-7.181-32.9-9.129l-2.013-0.69"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        d="M686.604,51.082
   c0,0-16.117-0.019-20.375,1.55"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        d="M688.755,29.568
   c0,0-8.896-2.344-14.667-2.893"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M699.679,63.281c0,0.001,0.024-0.21,0.068-0.598
   "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="699.885"
        y1="61.471"
        x2="699.885"
        y2="61.47"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.221,1.22"
        d="M699.885,61.47
   c0.691-6.06,2.903-25.459,3.32-29.118"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M703.205,32.35
   c0.044-0.387,0.068-0.598,0.068-0.598"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M697.189,62.839c0,0.001,0.024-0.21,0.069-0.598
   "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="697.398"
        y1="61.015"
        x2="697.398"
        y2="61.014"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.236,1.235"
        d="M697.398,61.014
   c0.703-6.126,2.958-25.778,3.381-29.463"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M700.779,31.55
   c0.044-0.387,0.068-0.598,0.068-0.598"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="690.192"
        y1="27.82"
        x2="690.13"
        y2="28.419"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="690.007"
        y1="29.602"
        x2="690.007"
        y2="29.603"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.19,1.189"
        x1="690.007"
        y1="29.603"
        x2="686.809"
        y2="60.389"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="686.809"
        y1="60.389"
        x2="686.747"
        y2="60.988"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="692.666"
        y1="28.573"
        x2="692.604"
        y2="29.172"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="692.481"
        y1="30.355"
        x2="692.481"
        y2="30.356"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.19,1.189"
        x1="692.481"
        y1="30.356"
        x2="689.283"
        y2="61.142"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="689.283"
        y1="61.142"
        x2="689.221"
        y2="61.741"
      />
      <path
        d="M691.119,28.82l-0.508,0.452l0.189-0.494c0.01-0.026,0.001-0.056-0.022-0.071c-0.023-0.016-0.054-0.014-0.075,0.004
   l-0.508,0.452l0.189-0.493c0.01-0.027,0.001-0.056-0.022-0.072s-0.055-0.014-0.076,0.004l-0.508,0.452l0.19-0.493
   c0.01-0.027,0.001-0.056-0.023-0.072c-0.023-0.016-0.054-0.014-0.075,0.004l-0.695,0.619l0.081,0.091l0.508-0.452l-0.189,0.494
   c-0.011,0.026-0.001,0.056,0.022,0.072s0.054,0.014,0.075-0.005l0.509-0.452l-0.19,0.494c-0.01,0.026-0.001,0.055,0.022,0.071
   s0.054,0.015,0.075-0.004l0.509-0.452l-0.19,0.494c-0.01,0.026-0.001,0.055,0.023,0.071c0.005,0.005,0.012,0.008,0.019,0.009
   c0.019,0.006,0.04,0.001,0.056-0.013l0.695-0.619L691.119,28.82z"
      />
      <path
        d="M693.594,29.68l-0.508,0.452l0.189-0.493c0.01-0.026,0.001-0.056-0.022-0.072c-0.023-0.016-0.054-0.014-0.075,0.004
   l-0.508,0.452l0.189-0.493c0.01-0.026,0.001-0.056-0.022-0.072c-0.023-0.016-0.055-0.014-0.076,0.004l-0.508,0.453l0.19-0.494
   c0.01-0.026,0.001-0.056-0.023-0.072c-0.023-0.016-0.054-0.014-0.075,0.005l-0.695,0.618l0.081,0.092l0.508-0.453l-0.189,0.494
   c-0.011,0.026-0.001,0.056,0.022,0.072s0.054,0.014,0.075-0.004l0.508-0.453l-0.189,0.494c-0.01,0.026-0.001,0.056,0.022,0.072
   c0.023,0.016,0.054,0.014,0.075-0.005l0.509-0.452l-0.19,0.494c-0.01,0.026-0.001,0.056,0.023,0.072
   c0.005,0.004,0.012,0.007,0.019,0.009c0.019,0.005,0.04,0,0.056-0.014l0.695-0.619L693.594,29.68z"
      />
      <path
        d="M687.666,59.538l-0.485,0.477l0.165-0.502c0.008-0.027-0.002-0.056-0.026-0.071c-0.024-0.015-0.055-0.011-0.075,0.008
   l-0.485,0.478l0.164-0.503c0.009-0.027-0.002-0.056-0.026-0.071c-0.024-0.015-0.054-0.011-0.074,0.009l-0.485,0.477l0.164-0.503
   c0.009-0.027-0.002-0.056-0.026-0.07c-0.024-0.016-0.055-0.012-0.075,0.008l-0.663,0.653l0.086,0.087l0.484-0.477l-0.164,0.502
   c-0.009,0.027,0.002,0.056,0.026,0.071c0.024,0.014,0.055,0.011,0.075-0.009l0.484-0.477l-0.164,0.503
   c-0.008,0.027,0.002,0.056,0.026,0.071c0.024,0.014,0.055,0.011,0.075-0.009l0.485-0.477l-0.164,0.503
   c-0.009,0.026,0.001,0.055,0.025,0.071c0.007,0.003,0.013,0.006,0.02,0.007c0.02,0.004,0.04-0.002,0.055-0.016l0.664-0.653
   L687.666,59.538z"
      />
      <path
        d="M690.463,59.968l-0.485,0.477l0.165-0.502c0.008-0.027-0.002-0.056-0.026-0.071c-0.024-0.015-0.055-0.011-0.075,0.008
   l-0.485,0.478l0.164-0.503c0.009-0.027-0.002-0.056-0.026-0.071c-0.024-0.015-0.054-0.011-0.074,0.009l-0.485,0.477l0.164-0.503
   c0.009-0.027-0.002-0.056-0.026-0.07c-0.024-0.015-0.055-0.012-0.075,0.008l-0.663,0.653l0.085,0.087l0.485-0.477l-0.164,0.502
   c-0.009,0.027,0.002,0.056,0.026,0.071c0.024,0.014,0.055,0.011,0.075-0.009l0.484-0.477l-0.164,0.503
   c-0.008,0.027,0.002,0.056,0.026,0.071c0.024,0.014,0.055,0.011,0.075-0.009l0.485-0.477l-0.165,0.503
   c-0.008,0.027,0.002,0.055,0.026,0.071c0.007,0.003,0.013,0.006,0.02,0.007c0.02,0.004,0.04-0.001,0.055-0.016l0.663-0.653
   L690.463,59.968z"
      />
      <path
        d="M698.208,61.367l-0.485,0.477l0.165-0.502c0.008-0.027-0.002-0.056-0.026-0.071c-0.024-0.015-0.055-0.011-0.075,0.008
   l-0.485,0.478l0.164-0.503c0.009-0.027-0.002-0.056-0.026-0.071c-0.024-0.015-0.054-0.011-0.075,0.009l-0.484,0.477l0.164-0.503
   c0.009-0.027-0.002-0.056-0.026-0.07c-0.024-0.015-0.055-0.012-0.075,0.008l-0.663,0.653l0.085,0.087l0.485-0.477l-0.164,0.502
   c-0.009,0.027,0.002,0.056,0.026,0.071c0.023,0.014,0.055,0.011,0.075-0.009l0.484-0.477l-0.164,0.503
   c-0.008,0.027,0.002,0.056,0.026,0.071c0.024,0.014,0.055,0.011,0.075-0.009l0.485-0.477l-0.165,0.503
   c-0.008,0.027,0.002,0.055,0.026,0.071c0.007,0.003,0.013,0.006,0.02,0.007c0.019,0.004,0.04-0.001,0.055-0.016l0.663-0.653
   L698.208,61.367z"
      />
      <path
        d="M700.682,61.797l-0.485,0.478l0.165-0.503c0.008-0.027-0.002-0.056-0.026-0.071c-0.024-0.015-0.055-0.011-0.075,0.009
   l-0.485,0.477l0.164-0.503c0.009-0.027-0.002-0.056-0.026-0.071c-0.024-0.014-0.054-0.011-0.075,0.009l-0.484,0.477l0.164-0.503
   c0.009-0.027-0.002-0.055-0.026-0.07c-0.024-0.015-0.055-0.012-0.075,0.008l-0.663,0.653l0.085,0.087l0.485-0.477l-0.164,0.502
   c-0.009,0.027,0.002,0.056,0.026,0.071c0.023,0.014,0.055,0.011,0.075-0.009l0.484-0.477l-0.164,0.503
   c-0.009,0.027,0.002,0.056,0.026,0.071c0.024,0.014,0.055,0.011,0.075-0.009l0.485-0.477l-0.165,0.503
   c-0.008,0.027,0.002,0.056,0.026,0.071c0.007,0.003,0.013,0.006,0.02,0.007c0.019,0.004,0.04-0.001,0.055-0.016l0.663-0.653
   L700.682,61.797z"
      />
      <path
        d="M701.661,32.047l-0.508,0.452l0.189-0.494c0.01-0.026,0.001-0.055-0.022-0.071c-0.023-0.016-0.055-0.014-0.076,0.004
   l-0.508,0.452l0.19-0.493c0.01-0.027,0.001-0.056-0.022-0.072c-0.024-0.016-0.055-0.014-0.076,0.004l-0.508,0.452l0.19-0.493
   c0.009-0.026,0.001-0.056-0.023-0.072c-0.023-0.016-0.054-0.014-0.075,0.004l-0.695,0.619l0.081,0.091l0.508-0.452l-0.189,0.494
   c-0.011,0.026-0.001,0.056,0.022,0.072c0.023,0.016,0.054,0.014,0.075-0.005l0.508-0.452l-0.189,0.494
   c-0.01,0.026-0.001,0.056,0.022,0.071c0.023,0.017,0.054,0.015,0.075-0.004l0.509-0.452l-0.19,0.494
   c-0.01,0.026-0.001,0.055,0.022,0.071c0.006,0.005,0.013,0.008,0.02,0.009c0.019,0.006,0.04,0.001,0.056-0.013l0.695-0.619
   L701.661,32.047z"
      />
      <path
        d="M704.028,32.8l-0.508,0.452l0.189-0.494c0.01-0.026,0.001-0.055-0.022-0.071c-0.023-0.016-0.055-0.014-0.076,0.004
   l-0.508,0.452l0.19-0.493c0.01-0.026,0.001-0.056-0.023-0.072c-0.023-0.016-0.054-0.014-0.075,0.004l-0.508,0.452l0.189-0.493
   c0.01-0.026,0.001-0.056-0.022-0.072c-0.023-0.016-0.054-0.014-0.075,0.004l-0.696,0.619l0.081,0.091l0.509-0.452l-0.19,0.494
   c-0.01,0.026,0,0.056,0.023,0.072c0.022,0.016,0.054,0.014,0.075-0.005l0.508-0.452l-0.189,0.494
   c-0.011,0.026-0.001,0.056,0.022,0.072s0.054,0.014,0.075-0.005l0.508-0.452l-0.189,0.494c-0.01,0.026-0.001,0.056,0.022,0.071
   c0.006,0.005,0.013,0.008,0.02,0.01c0.019,0.005,0.04,0,0.055-0.014l0.696-0.619L704.028,32.8z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.405"
        strokeMiterlimit="10"
        strokeDasharray="1.215,1.215"
        d="M690.1,240.37
   c0,0,28,6.547,54.43,7.422"
      />
      <path
        d="M910.73,28.138c0.41-0.056,0.832-0.114,1.262-0.173C911.561,28.023,911.14,28.081,910.73,28.138 M916.985,27.3
   c0.59-0.076,1.193-0.154,1.806-0.232C918.178,27.145,917.575,27.223,916.985,27.3"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M1057.458,56.819c0.01,0.269-0.089,0.522-0.279,0.713c-0.189,0.191-0.441,0.289-0.711,0.282l-13.255-0.427
   c-0.309-0.01-0.559-0.261-0.567-0.571l-0.227-9.353l-0.013-0.611l-0.479-19.744c0.198,0.026,0.396,0.051,0.592,0.076
   c0.201,0.025,0.4,0.051,0.598,0.077c0.043,0.005,0.087,0.011,0.13,0.017c0.034,0.004,0.07,0.009,0.104,0.013
   c0.03,0.005,0.062,0.008,0.092,0.012c0.063,0.009,0.125,0.017,0.188,0.025c0.026,0.003,0.052,0.006,0.077,0.01
   c0.098,0.012,0.196,0.025,0.293,0.038h0.003c0.006,0.001,0.011,0.001,0.016,0.002c0.006,0.002,0.012,0.003,0.019,0.004
   c0.044,0.005,0.089,0.01,0.133,0.016c0.004,0.001,0.009,0.002,0.013,0.002c0.035,0.004,0.071,0.009,0.106,0.014
   c0.097,0.012,0.193,0.026,0.289,0.037c0.119,0.016,0.239,0.032,0.358,0.048c0.021,0.003,0.044,0.005,0.065,0.008
   c0.05,0.007,0.1,0.013,0.149,0.02c0.04,0.006,0.08,0.01,0.12,0.016c0.054,0.007,0.108,0.015,0.162,0.021
   c0.035,0.005,0.071,0.01,0.106,0.014c0.152,0.021,0.304,0.041,0.453,0.06c0.092,0.014,0.185,0.025,0.277,0.037
   c0.194,0.027,0.387,0.053,0.58,0.079c0.17,0.022,0.337,0.045,0.505,0.067c0.001,0,0.003,0.001,0.004,0.001
   c0.169,0.023,0.337,0.046,0.503,0.068c0.007,0.001,0.016,0.002,0.023,0.004c0.075,0.01,0.151,0.02,0.225,0.03
   c0.082,0.011,0.165,0.022,0.246,0.034c0.017,0.002,0.033,0.005,0.05,0.007c0.172,0.023,0.343,0.047,0.512,0.069
   c0.085,0.012,0.169,0.024,0.251,0.035c0.051,0.007,0.101,0.014,0.151,0.021c0.08,0.011,0.159,0.022,0.237,0.033
   c0.156,0.021,0.312,0.043,0.465,0.064c0.126,0.017,0.251,0.035,0.375,0.052c0.028,0.004,0.055,0.008,0.083,0.012
   c0.075,0.01,0.15,0.021,0.225,0.032c0.036,0.005,0.074,0.01,0.11,0.015l0.113,0.016c0.06,0.007,0.119,0.016,0.177,0.024
   c0.015,0.003,0.029,0.005,0.044,0.006c0.14,0.021,0.279,0.04,0.416,0.058c0.227,0.034,0.451,0.065,0.67,0.096
   c0.074,0.011,0.147,0.021,0.219,0.031c0.02,0.003,0.041,0.006,0.061,0.009c0.003,0,0.006,0.001,0.009,0.001
   c0.056,0.009,0.113,0.016,0.167,0.024c0.026,0.003,0.052,0.007,0.078,0.01c0.022,0.005,0.044,0.008,0.066,0.01
   c0.067,0.01,0.134,0.019,0.201,0.029c0.09,0.013,0.178,0.026,0.267,0.038c0.069,0.01,0.136,0.02,0.204,0.03
   c0.09,0.013,0.179,0.026,0.266,0.038c0.078,0.011,0.153,0.022,0.228,0.033c0.102,0.015,0.202,0.03,0.301,0.044
   c0.064,0.01,0.128,0.018,0.191,0.028c0.016,0.002,0.032,0.004,0.048,0.006c0.093,0.014,0.184,0.027,0.274,0.04
   c0.026,0.005,0.052,0.008,0.078,0.012c0.009,0.001,0.018,0.003,0.027,0.004c0.044,0.007,0.089,0.013,0.133,0.018
   c0.008,0.003,0.018,0.004,0.028,0.005c0.051,0.007,0.102,0.015,0.152,0.022c0.12,0.019,0.237,0.036,0.352,0.052
   c0.058,0.009,0.115,0.017,0.172,0.026c0.057,0.007,0.113,0.016,0.169,0.025c0.056,0.008,0.112,0.016,0.167,0.024
   c0.053,0.008,0.107,0.016,0.161,0.024c0.007,0.001,0.014,0.002,0.02,0.003c0.03,0.005,0.059,0.009,0.087,0.013
   c0.004,0.001,0.01,0.001,0.014,0.002l0.708,18.146l0.024,0.611L1057.458,56.819z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="1.22,0.915"
        d="
   M1074.497,469.808c-4.793,0.819-9.526,2.325-14.367,2.541c-1.613,0.537-3.227,0.43-4.948,0.752h-1.076
   c-8.82,0.861-17.533,0.753-26.354,0.216c-1.399-0.108-2.797-0.216-4.195-0.323c-1.184-0.108-2.259-0.215-3.442-0.323
   c-3.013-0.538-5.809-0.861-8.821-1.398c-2.582-0.43-4.948-1.076-7.37-1.504"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M890.929,74.633
   c28.5-2.336,57.005-3.305,85.619-3.52c27.86-0.107,55.614,0.538,83.582,2.797h1.075c0.538,0.108,1.076,0.108,1.614,0.215
   c2.259,0.108,4.518,0.323,6.777,0.515"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M891.344,72.047
   c28.408-2.439,56.914-3.3,85.42-3.623c11.94-0.107,23.988,0.108,35.929,0.431c14.844,0.322,29.474,1.076,44.318,2.044
   c1.399,0.107,2.797,0.215,4.195,0.322c0.538,0.108,1.076,0.108,1.614,0.216c0.323,0,0.753-0.108,1.076,0
   c0.538,0.107,0.968,0.107,1.506,0.214c0.322,0,0.753-0.107,1.075,0c0.538,0.108,0.969,0.108,1.507,0.216
   c0.322,0,0.645,0,1.004,0.045"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="957.18"
        y1="23.01"
        x2="957.288"
        y2="23.454"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="957.506"
        y1="24.345"
        x2="957.506"
        y2="24.346"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.917,0.916"
        x1="957.506"
        y1="24.346"
        x2="964.029"
        y2="51.083"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="964.029"
        y1="51.082"
        x2="964.137"
        y2="51.526"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="959.761"
        y1="23.01"
        x2="959.87"
        y2="23.454"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="960.086"
        y1="24.345"
        x2="960.086"
        y2="24.346"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.917,0.916"
        x1="960.087"
        y1="24.346"
        x2="966.61"
        y2="51.083"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="966.61"
        y1="51.082"
        x2="966.718"
        y2="51.526"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="1002.327"
        y1="23.01"
        x2="1002.219"
        y2="23.454"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="1002.002"
        y1="24.345"
        x2="1002.002"
        y2="24.346"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.917,0.916"
        x1="1002.001"
        y1="24.346"
        x2="995.478"
        y2="51.083"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="995.478"
        y1="51.082"
        x2="995.37"
        y2="51.526"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="999.747"
        y1="23.01"
        x2="999.639"
        y2="23.454"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="999.421"
        y1="24.345"
        x2="999.421"
        y2="24.346"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.917,0.916"
        x1="999.421"
        y1="24.346"
        x2="992.899"
        y2="51.083"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="992.898"
        y1="51.082"
        x2="992.79"
        y2="51.526"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M881.626,255.76
   c11.719-1.832,24.3-4.523,24.3-4.523c7.437-3.513,17.97-8.944,20.291-11.554c0.101-0.559,0.301-3.342-1.954-14.661
   c-1.545-7.756-3.965-18.24-7.192-31.16c-1.591-6.369-3.218-12.69-4.721-18.431c-2.277,3.058-8.28,8.368-13.078,11.02
   c-0.234,0.13-0.489,0.259-0.757,0.383c-3.567,1.652-10.494,2.451-15.681,2.761"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
   M884.099,153.856l21.063-2.343c2.055,10.363,3.604,19.572,3.572,21.258c-0.809,1.409-6.716,7.26-12.045,10.206
   c-0.155,0.086-0.324,0.171-0.503,0.254c-2.968,1.375-8.79,1.947-13.404,2.181"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
   M884.023,155.596l19.758-2.198c1.858,9.498,3.039,16.711,3.212,18.865c-1.253,1.566-6.298,6.535-11.135,9.209
   c-0.12,0.066-0.252,0.133-0.395,0.199c-2.44,1.13-7.571,1.749-12.604,2.016"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M1078.69,255.76
   c-11.719-1.832-24.3-4.523-24.3-4.523c-7.437-3.513-17.969-8.944-20.291-11.554c-0.101-0.559-0.301-3.342,1.954-14.661
   c1.546-7.756,3.965-18.24,7.192-31.16c1.591-6.369,3.219-12.69,4.721-18.431c2.278,3.058,8.28,8.368,13.078,11.02
   c0.234,0.13,0.489,0.259,0.757,0.383c3.568,1.652,10.494,2.451,15.681,2.761"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
   M1076.217,153.856l-21.063-2.343c-2.055,10.363-3.604,19.572-3.573,21.258c0.809,1.409,6.717,7.26,12.046,10.206
   c0.155,0.086,0.324,0.171,0.503,0.254c2.968,1.375,8.789,1.947,13.404,2.181"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
   M1076.293,155.596l-19.757-2.198c-1.859,9.498-3.039,16.711-3.213,18.865c1.253,1.566,6.298,6.535,11.135,9.209
   c0.12,0.066,0.252,0.133,0.395,0.199c2.441,1.13,7.572,1.749,12.604,2.016"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M898.765,75.04
   l1.248,15.165c0.038,0.467,0.484,0.845,1.037,0.878l57.828,3.503c0.026,0.001,0.052,0.002,0.078,0.002
   c0.584,0,1.088-0.397,1.119-0.896l1.312-21.155"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M901.337,74.828
   l1.015,12.342c0.067,0.811,0.719,1.45,1.532,1.499l52.084,3.155c0.901,0.054,1.677-0.631,1.732-1.532l1.112-17.916"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M1062.021,75.04
   l-1.247,15.165c-0.039,0.467-0.484,0.845-1.037,0.878l-57.828,3.503c-0.027,0.001-0.053,0.002-0.078,0.002
   c-0.584,0-1.088-0.397-1.119-0.896l-1.313-21.155"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M1059.45,74.828
   l-1.015,12.342c-0.067,0.811-0.72,1.45-1.532,1.499l-52.084,3.155c-0.902,0.054-1.677-0.631-1.732-1.532l-1.112-17.916"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
   M987.306,198.512c6.884,1.793,13.553-0.789,19.577-4.554c7.745-4.948,14.091-10.649,18.824-18.502
   c2.582-4.518,4.196-9.036,5.487-13.984c0-0.107,0.215-0.323,0.215-0.43c1.829-7.637,2.474-15.383,0-22.805
   c-0.323-0.753-0.538-1.614-0.861-2.367c-1.398-3.119-3.227-6.024-5.594-8.605c-0.967-0.86-1.721-1.829-2.689-2.69
   c-5.916-5.485-12.478-9.358-19.685-12.478c-0.215-0.107-0.323,0-0.538-0.107c-5.055-2.151-10.111-3.55-15.597-4.518
   c-2.905-0.43-5.487-0.968-8.391-0.646c-0.323,0.108-0.645,0.216-0.968,0.216c-16.351,2.044-31.626,8.821-42.813,21.299
   c-0.107,0.107-0.107,0.322-0.215,0.43c-6.669,7.422-7.853,17.534-6.347,27.108c0.646,3.442,1.291,6.777,2.474,10.004
   c1.076,3.011,2.152,5.916,3.766,8.712c4.625,8.176,11.187,13.985,19.147,19.256c0.323,0.215,0.538,0.215,0.86,0.43
   c1.722,1.183,3.443,1.936,5.271,2.797c0.861,0.43,1.829,0.645,2.69,0.968c3.657,1.075,7.53,1.398,11.136,0.412"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
   M987.563,196.909c1.317,0.355,2.702,0.535,4.118,0.535c5.519,0,11.822-2.689,18.733-7.993c7.547-5.792,12.846-12.042,15.749-18.576
   c3.575-8.046,10.508-28.268-2.287-42.237c-9.124-9.961-20.628-14.96-28.672-17.4c-7.669-2.326-13.733-2.831-15.125-2.921
   c-1.393,0.09-7.456,0.595-15.125,2.921c-8.044,2.44-19.548,7.439-28.672,17.4c-12.795,13.969-5.862,34.191-2.287,42.237
   c2.903,6.534,8.201,12.784,15.749,18.576c6.911,5.304,13.213,7.993,18.733,7.993c1.416,0,2.801-0.18,4.118-0.535"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M919.583,28.392
   c13.036-1.583,29.142-3.361,36.862-3.512"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M900.019,30.892
   c0,0,1.351-0.184,3.651-0.486"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="919.112"
        y1="45.52"
        x2="961.216"
        y2="44.211"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="898.765"
        y1="46.152"
        x2="903.064"
        y2="46.019"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
   M1041.168,28.513c-13.201-1.612-29.939-3.478-37.858-3.633"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
   M1059.736,30.892c0,0-0.911-0.124-2.509-0.335"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="1041.614"
        y1="45.55"
        x2="998.54"
        y2="44.211"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="1060.99"
        y1="46.152"
        x2="1057.764"
        y2="46.052"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M986.02,192.082
   c0,0,1.469-29.314,1.114-32.625c-0.356-3.31-4.843-5.425-6.933-4.801h-0.091c-2.091-0.624-6.577,1.491-6.933,4.801
   c-0.356,3.311,1.114,32.625,1.114,32.625"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="1.22,0.915"
        d="M885.765,469.861
   c8.277,1.95,16.775,3.133,25.273,3.671c15.167,0.861,30.442-0.323,45.327-3.699"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="981.359"
        y1="72.349"
        x2="981.359"
        y2="105.887"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="982.563"
        y1="72.349"
        x2="982.563"
        y2="105.887"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="983.94"
        y1="72.349"
        x2="983.94"
        y2="105.887"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
   M975.187,174.588v-12.386c0-1.592,0.593-3.144,1.717-4.272c0.772-0.776,1.743-1.195,3.146-1.21"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
   M985.211,174.697l-0.172-12.559c0-1.591-0.593-3.143-1.717-4.271c-0.772-0.775-1.743-1.195-3.146-1.21"
      />
      <path
        d="M958.735,23.973l-0.37,0.571l0.052-0.526c0.003-0.028-0.015-0.054-0.041-0.064c-0.026-0.009-0.056,0.001-0.071,0.024
   l-0.37,0.571l0.051-0.526c0.003-0.028-0.013-0.054-0.04-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.051-0.526
   c0.003-0.028-0.013-0.054-0.04-0.063c-0.027-0.01-0.056,0.001-0.071,0.024l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526
   c-0.003,0.029,0.014,0.055,0.04,0.064c0.027,0.009,0.056-0.001,0.071-0.024l0.37-0.57l-0.051,0.525
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.37-0.571l-0.052,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.007,0.002,0.014,0.003,0.021,0.003c0.02,0,0.039-0.01,0.051-0.028l0.506-0.78
   L958.735,23.973z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M958.735,23.973l-0.37,0.571l0.052-0.526
   c0.003-0.028-0.015-0.054-0.041-0.064c-0.026-0.009-0.056,0.001-0.071,0.024l-0.37,0.571l0.051-0.526
   c0.003-0.028-0.013-0.054-0.04-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.051-0.526
   c0.003-0.028-0.013-0.054-0.04-0.063c-0.027-0.01-0.056,0.001-0.071,0.024l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526
   c-0.003,0.029,0.014,0.055,0.04,0.064c0.027,0.009,0.056-0.001,0.071-0.024l0.37-0.57l-0.051,0.525
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.37-0.571l-0.052,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.007,0.002,0.014,0.003,0.021,0.003c0.02,0,0.039-0.01,0.051-0.028l0.506-0.78
   L958.735,23.973z"
      />
      <path
        d="M960.971,23.973l-0.37,0.571l0.052-0.526c0.003-0.028-0.015-0.054-0.041-0.064c-0.026-0.009-0.056,0.001-0.071,0.024
   l-0.37,0.571l0.051-0.526c0.003-0.028-0.013-0.054-0.04-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.051-0.526
   c0.003-0.028-0.013-0.054-0.04-0.063c-0.027-0.01-0.056,0.001-0.071,0.024l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526
   c-0.003,0.029,0.014,0.055,0.04,0.064c0.027,0.009,0.056-0.001,0.071-0.024l0.37-0.57l-0.051,0.525
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.37-0.571l-0.052,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.007,0.002,0.014,0.003,0.021,0.003c0.02,0,0.039-0.01,0.051-0.028l0.506-0.78
   L960.971,23.973z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M960.971,23.973l-0.37,0.571l0.052-0.526
   c0.003-0.028-0.015-0.054-0.041-0.064c-0.026-0.009-0.056,0.001-0.071,0.024l-0.37,0.571l0.051-0.526
   c0.003-0.028-0.013-0.054-0.04-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.051-0.526
   c0.003-0.028-0.013-0.054-0.04-0.063c-0.027-0.01-0.056,0.001-0.071,0.024l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526
   c-0.003,0.029,0.014,0.055,0.04,0.064c0.027,0.009,0.056-0.001,0.071-0.024l0.37-0.57l-0.051,0.525
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.37-0.571l-0.052,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.007,0.002,0.014,0.003,0.021,0.003c0.02,0,0.039-0.01,0.051-0.028l0.506-0.78
   L960.971,23.973z"
      />
      <path
        d="M1000.193,23.973l-0.37,0.571l0.052-0.526c0.003-0.028-0.015-0.054-0.041-0.064c-0.026-0.009-0.056,0.001-0.071,0.024
   l-0.37,0.571l0.051-0.526c0.003-0.028-0.013-0.054-0.04-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.052-0.526
   c0.002-0.028-0.014-0.054-0.041-0.063c-0.027-0.01-0.056,0.001-0.071,0.024l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526
   c-0.003,0.029,0.014,0.055,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.369-0.57l-0.051,0.525
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.37-0.571l-0.052,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.007,0.002,0.014,0.003,0.021,0.003c0.02,0,0.039-0.01,0.051-0.028l0.506-0.78
   L1000.193,23.973z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M1000.193,23.973l-0.37,0.571l0.052-0.526
   c0.003-0.028-0.015-0.054-0.041-0.064c-0.026-0.009-0.056,0.001-0.071,0.024l-0.37,0.571l0.051-0.526
   c0.003-0.028-0.013-0.054-0.04-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.052-0.526
   c0.002-0.028-0.014-0.054-0.041-0.063c-0.027-0.01-0.056,0.001-0.071,0.024l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526
   c-0.003,0.029,0.014,0.055,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.369-0.57l-0.051,0.525
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.37-0.571l-0.052,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.007,0.002,0.014,0.003,0.021,0.003c0.02,0,0.039-0.01,0.051-0.028l0.506-0.78
   L1000.193,23.973z"
      />
      <path
        d="M1002.429,23.973l-0.37,0.571l0.052-0.526c0.003-0.028-0.015-0.054-0.041-0.064c-0.026-0.009-0.056,0.001-0.071,0.024
   l-0.37,0.571l0.051-0.526c0.003-0.028-0.013-0.054-0.04-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.052-0.526
   c0.002-0.028-0.014-0.054-0.041-0.063c-0.027-0.01-0.056,0.001-0.071,0.024l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526
   c-0.003,0.029,0.014,0.055,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.369-0.57l-0.051,0.525
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.37-0.571l-0.052,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.007,0.002,0.014,0.003,0.021,0.003c0.02,0,0.039-0.01,0.051-0.028l0.506-0.78
   L1002.429,23.973z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M1002.429,23.973l-0.37,0.571l0.052-0.526
   c0.003-0.028-0.015-0.054-0.041-0.064c-0.026-0.009-0.056,0.001-0.071,0.024l-0.37,0.571l0.051-0.526
   c0.003-0.028-0.013-0.054-0.04-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.052-0.526
   c0.002-0.028-0.014-0.054-0.041-0.063c-0.027-0.01-0.056,0.001-0.071,0.024l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526
   c-0.003,0.029,0.014,0.055,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.369-0.57l-0.051,0.525
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.37-0.571l-0.052,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.007,0.002,0.014,0.003,0.021,0.003c0.02,0,0.039-0.01,0.051-0.028l0.506-0.78
   L1002.429,23.973z"
      />
      <path
        d="M994,49.604l-0.37,0.57l0.052-0.526c0.003-0.027-0.015-0.054-0.041-0.063s-0.056,0.001-0.071,0.024l-0.37,0.571l0.051-0.526
   c0.003-0.028-0.013-0.054-0.04-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.051-0.526
   c0.003-0.028-0.013-0.054-0.04-0.063c-0.027-0.01-0.056,0.001-0.071,0.024l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526
   c-0.003,0.028,0.014,0.055,0.04,0.064c0.027,0.009,0.056-0.001,0.071-0.025l0.37-0.57l-0.051,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.063c0.027,0.01,0.056,0,0.072-0.023l0.37-0.571l-0.052,0.526c-0.003,0.028,0.014,0.054,0.04,0.063
   c0.007,0.003,0.014,0.004,0.021,0.004c0.02,0,0.039-0.011,0.051-0.028l0.506-0.781L994,49.604z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M994,49.604l-0.37,0.57l0.052-0.526
   c0.003-0.027-0.015-0.054-0.041-0.063s-0.056,0.001-0.071,0.024l-0.37,0.571l0.051-0.526c0.003-0.028-0.013-0.054-0.04-0.064
   c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.051-0.526c0.003-0.028-0.013-0.054-0.04-0.063
   c-0.027-0.01-0.056,0.001-0.071,0.024l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526c-0.003,0.028,0.014,0.055,0.04,0.064
   c0.027,0.009,0.056-0.001,0.071-0.025l0.37-0.57l-0.051,0.526c-0.003,0.028,0.014,0.054,0.04,0.063c0.027,0.01,0.056,0,0.072-0.023
   l0.37-0.571l-0.052,0.526c-0.003,0.028,0.014,0.054,0.04,0.063c0.007,0.003,0.014,0.004,0.021,0.004c0.02,0,0.039-0.011,0.051-0.028
   l0.506-0.781L994,49.604z"
      />
      <path
        d="M996.236,49.604l-0.37,0.57l0.052-0.526c0.003-0.027-0.015-0.054-0.041-0.063s-0.056,0.001-0.071,0.024l-0.37,0.571
   l0.051-0.526c0.003-0.028-0.013-0.054-0.04-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.051-0.526
   c0.003-0.028-0.013-0.054-0.04-0.063c-0.027-0.01-0.056,0.001-0.071,0.024l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526
   c-0.003,0.028,0.014,0.055,0.04,0.064c0.027,0.009,0.056-0.001,0.071-0.025l0.37-0.57l-0.051,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.063c0.027,0.01,0.056,0,0.072-0.023l0.37-0.571l-0.052,0.526c-0.003,0.028,0.014,0.054,0.04,0.063
   c0.007,0.003,0.014,0.004,0.021,0.004c0.02,0,0.039-0.011,0.051-0.028l0.506-0.781L996.236,49.604z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M996.236,49.604l-0.37,0.57l0.052-0.526
   c0.003-0.027-0.015-0.054-0.041-0.063s-0.056,0.001-0.071,0.024l-0.37,0.571l0.051-0.526c0.003-0.028-0.013-0.054-0.04-0.064
   c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.051-0.526c0.003-0.028-0.013-0.054-0.04-0.063
   c-0.027-0.01-0.056,0.001-0.071,0.024l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526c-0.003,0.028,0.014,0.055,0.04,0.064
   c0.027,0.009,0.056-0.001,0.071-0.025l0.37-0.57l-0.051,0.526c-0.003,0.028,0.014,0.054,0.04,0.063c0.027,0.01,0.056,0,0.072-0.023
   l0.37-0.571l-0.052,0.526c-0.003,0.028,0.014,0.054,0.04,0.063c0.007,0.003,0.014,0.004,0.021,0.004c0.02,0,0.039-0.011,0.051-0.028
   l0.506-0.781L996.236,49.604z"
      />
      <path
        d="M965.099,49.604l-0.37,0.57l0.052-0.526c0.003-0.027-0.014-0.054-0.041-0.063c-0.026-0.009-0.056,0.001-0.071,0.024
   l-0.37,0.571l0.052-0.526c0.002-0.028-0.014-0.054-0.041-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.052-0.526
   c0.003-0.028-0.014-0.054-0.041-0.063c-0.026-0.01-0.056,0.001-0.071,0.024l-0.506,0.78l0.102,0.067l0.37-0.571l-0.052,0.526
   c-0.003,0.028,0.014,0.055,0.041,0.064c0.026,0.009,0.055-0.001,0.071-0.025l0.37-0.57l-0.052,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.063c0.027,0.01,0.056,0,0.072-0.023l0.37-0.571l-0.052,0.526c-0.003,0.028,0.014,0.054,0.04,0.063
   c0.007,0.003,0.015,0.004,0.021,0.004c0.02,0,0.039-0.011,0.051-0.028l0.507-0.781L965.099,49.604z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M965.099,49.604l-0.37,0.57l0.052-0.526
   c0.003-0.027-0.014-0.054-0.041-0.063c-0.026-0.009-0.056,0.001-0.071,0.024l-0.37,0.571l0.052-0.526
   c0.002-0.028-0.014-0.054-0.041-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.052-0.526
   c0.003-0.028-0.014-0.054-0.041-0.063c-0.026-0.01-0.056,0.001-0.071,0.024l-0.506,0.78l0.102,0.067l0.37-0.571l-0.052,0.526
   c-0.003,0.028,0.014,0.055,0.041,0.064c0.026,0.009,0.055-0.001,0.071-0.025l0.37-0.57l-0.052,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.063c0.027,0.01,0.056,0,0.072-0.023l0.37-0.571l-0.052,0.526c-0.003,0.028,0.014,0.054,0.04,0.063
   c0.007,0.003,0.015,0.004,0.021,0.004c0.02,0,0.039-0.011,0.051-0.028l0.507-0.781L965.099,49.604z"
      />
      <path
        d="M967.336,49.604l-0.37,0.57l0.052-0.526c0.003-0.027-0.014-0.054-0.041-0.063c-0.026-0.009-0.056,0.001-0.071,0.024
   l-0.37,0.571l0.052-0.526c0.002-0.028-0.014-0.054-0.041-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.052-0.526
   c0.003-0.028-0.014-0.054-0.041-0.063c-0.026-0.01-0.056,0.001-0.071,0.024l-0.506,0.78l0.102,0.067l0.37-0.571l-0.052,0.526
   c-0.003,0.028,0.014,0.055,0.041,0.064c0.026,0.009,0.055-0.001,0.071-0.025l0.37-0.57l-0.052,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.063c0.027,0.01,0.056,0,0.072-0.023l0.37-0.571l-0.052,0.526c-0.003,0.028,0.014,0.054,0.04,0.063
   c0.007,0.003,0.015,0.004,0.021,0.004c0.02,0,0.039-0.011,0.051-0.028l0.507-0.781L967.336,49.604z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M967.336,49.604l-0.37,0.57l0.052-0.526
   c0.003-0.027-0.014-0.054-0.041-0.063c-0.026-0.009-0.056,0.001-0.071,0.024l-0.37,0.571l0.052-0.526
   c0.002-0.028-0.014-0.054-0.041-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.052-0.526
   c0.003-0.028-0.014-0.054-0.041-0.063c-0.026-0.01-0.056,0.001-0.071,0.024l-0.506,0.78l0.102,0.067l0.37-0.571l-0.052,0.526
   c-0.003,0.028,0.014,0.055,0.041,0.064c0.026,0.009,0.055-0.001,0.071-0.025l0.37-0.57l-0.052,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.063c0.027,0.01,0.056,0,0.072-0.023l0.37-0.571l-0.052,0.526c-0.003,0.028,0.014,0.054,0.04,0.063
   c0.007,0.003,0.015,0.004,0.021,0.004c0.02,0,0.039-0.011,0.051-0.028l0.507-0.781L967.336,49.604z"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.152"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        points="
   1058.866,151.126 1057.667,152.549 1058.011,151.03 1056.812,152.453 1057.156,150.934 1055.958,152.357 1056.302,150.838 
   1055.103,152.261 1055.447,150.742 1054.248,152.165 1054.592,150.646 1053.393,152.069 1053.737,150.549 1052.539,151.973 "
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.152"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        points="
   901.495,151.176 902.716,152.58 902.348,151.066 903.569,152.47 903.201,150.957 904.422,152.361 904.055,150.847 905.275,152.252 
   904.908,150.738 906.128,152.142 905.761,150.629 906.981,152.032 906.614,150.519 907.834,151.923 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="905.534"
        y1="28.621"
        x2="904.628"
        y2="58.111"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="908.277"
        y1="28.244"
        x2="907.318"
        y2="58.111"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="915.216"
        y1="27.399"
        x2="914.31"
        y2="58.11"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="917.958"
        y1="27.007"
        x2="916.999"
        y2="58.111"
      />
      <path
        d="M904.761,29.672l0.345,0.423l-0.052-0.413c-0.002-0.022,0.013-0.044,0.038-0.053c0.024-0.01,0.051-0.004,0.065,0.013
   l0.346,0.424l-0.052-0.414c-0.003-0.022,0.013-0.044,0.037-0.053c0.024-0.01,0.052-0.004,0.066,0.013l0.346,0.424l-0.052-0.413
   c-0.003-0.022,0.012-0.045,0.037-0.054c0.024-0.009,0.051-0.004,0.065,0.014l0.475,0.58l-0.094,0.061l-0.347-0.425l0.053,0.415
   c0.002,0.021-0.013,0.044-0.037,0.053c-0.025,0.009-0.052,0.004-0.066-0.013l-0.347-0.425l0.052,0.414
   c0.003,0.022-0.012,0.044-0.037,0.054c-0.024,0.009-0.051,0.004-0.066-0.014l-0.345-0.424l0.051,0.414
   c0.002,0.022-0.013,0.044-0.037,0.054c-0.007,0.002-0.013,0.004-0.02,0.004c-0.018,0.002-0.036-0.005-0.046-0.018l-0.472-0.58
   L904.761,29.672z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M904.761,29.672l0.345,0.423l-0.052-0.413
   c-0.002-0.022,0.013-0.044,0.038-0.053c0.024-0.01,0.051-0.004,0.065,0.013l0.346,0.424l-0.052-0.414
   c-0.003-0.022,0.013-0.044,0.037-0.053c0.024-0.01,0.052-0.004,0.066,0.013l0.346,0.424l-0.052-0.413
   c-0.003-0.022,0.012-0.045,0.037-0.054c0.024-0.009,0.051-0.004,0.065,0.014l0.475,0.58l-0.094,0.061l-0.347-0.425l0.053,0.415
   c0.002,0.021-0.013,0.044-0.037,0.053c-0.025,0.009-0.052,0.004-0.066-0.013l-0.347-0.425l0.052,0.414
   c0.003,0.022-0.012,0.044-0.037,0.054c-0.024,0.009-0.051,0.004-0.066-0.014l-0.345-0.424l0.051,0.414
   c0.002,0.022-0.013,0.044-0.037,0.054c-0.007,0.002-0.013,0.004-0.02,0.004c-0.018,0.002-0.036-0.005-0.046-0.018l-0.472-0.58
   L904.761,29.672z"
      />
      <path
        d="M907.45,29.241l0.345,0.424l-0.051-0.414c-0.003-0.022,0.012-0.044,0.037-0.053c0.024-0.01,0.051-0.004,0.065,0.014
   l0.346,0.423l-0.052-0.414c-0.003-0.022,0.013-0.043,0.037-0.053c0.024-0.01,0.052-0.004,0.066,0.014l0.346,0.424l-0.052-0.414
   c-0.003-0.022,0.013-0.044,0.037-0.054c0.024-0.009,0.052-0.003,0.066,0.014l0.475,0.58l-0.095,0.061l-0.346-0.424l0.052,0.414
   c0.003,0.022-0.012,0.044-0.037,0.054c-0.024,0.009-0.052,0.004-0.066-0.014l-0.346-0.424l0.051,0.414
   c0.003,0.022-0.012,0.044-0.037,0.053c-0.024,0.01-0.051,0.004-0.066-0.013l-0.345-0.425l0.051,0.414
   c0.003,0.023-0.013,0.045-0.037,0.054c-0.007,0.003-0.013,0.004-0.019,0.005c-0.019,0.001-0.036-0.006-0.047-0.019l-0.472-0.58
   L907.45,29.241z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M907.45,29.241l0.345,0.424l-0.051-0.414
   c-0.003-0.022,0.012-0.044,0.037-0.053c0.024-0.01,0.051-0.004,0.065,0.014l0.346,0.423l-0.052-0.414
   c-0.003-0.022,0.013-0.043,0.037-0.053c0.024-0.01,0.052-0.004,0.066,0.014l0.346,0.424l-0.052-0.414
   c-0.003-0.022,0.013-0.044,0.037-0.054c0.024-0.009,0.052-0.003,0.066,0.014l0.475,0.58l-0.095,0.061l-0.346-0.424l0.052,0.414
   c0.003,0.022-0.012,0.044-0.037,0.054c-0.024,0.009-0.052,0.004-0.066-0.014l-0.346-0.424l0.051,0.414
   c0.003,0.022-0.012,0.044-0.037,0.053c-0.024,0.01-0.051,0.004-0.066-0.013l-0.345-0.425l0.051,0.414
   c0.003,0.023-0.013,0.045-0.037,0.054c-0.007,0.003-0.013,0.004-0.019,0.005c-0.019,0.001-0.036-0.006-0.047-0.019l-0.472-0.58
   L907.45,29.241z"
      />
      <path
        d="M914.442,28.488l0.345,0.424l-0.052-0.414c-0.002-0.022,0.013-0.044,0.038-0.053c0.024-0.01,0.051-0.004,0.065,0.013
   l0.346,0.424l-0.052-0.414c-0.003-0.022,0.013-0.043,0.037-0.053c0.024-0.01,0.052-0.004,0.066,0.014l0.346,0.423l-0.052-0.413
   c-0.003-0.022,0.012-0.044,0.037-0.054c0.024-0.009,0.051-0.003,0.066,0.014l0.475,0.58l-0.095,0.061l-0.346-0.424l0.052,0.414
   c0.002,0.022-0.013,0.044-0.037,0.054c-0.025,0.009-0.052,0.003-0.066-0.014l-0.346-0.424l0.051,0.414
   c0.003,0.022-0.012,0.044-0.037,0.053c-0.024,0.01-0.051,0.004-0.066-0.013l-0.345-0.425l0.051,0.414
   c0.002,0.023-0.013,0.045-0.037,0.054c-0.007,0.002-0.013,0.004-0.019,0.004c-0.019,0.002-0.036-0.005-0.047-0.018l-0.472-0.58
   L914.442,28.488z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M914.442,28.488l0.345,0.424l-0.052-0.414
   c-0.002-0.022,0.013-0.044,0.038-0.053c0.024-0.01,0.051-0.004,0.065,0.013l0.346,0.424l-0.052-0.414
   c-0.003-0.022,0.013-0.043,0.037-0.053c0.024-0.01,0.052-0.004,0.066,0.014l0.346,0.423l-0.052-0.413
   c-0.003-0.022,0.012-0.044,0.037-0.054c0.024-0.009,0.051-0.003,0.066,0.014l0.475,0.58l-0.095,0.061l-0.346-0.424l0.052,0.414
   c0.002,0.022-0.013,0.044-0.037,0.054c-0.025,0.009-0.052,0.003-0.066-0.014l-0.346-0.424l0.051,0.414
   c0.003,0.022-0.012,0.044-0.037,0.053c-0.024,0.01-0.051,0.004-0.066-0.013l-0.345-0.425l0.051,0.414
   c0.002,0.023-0.013,0.045-0.037,0.054c-0.007,0.002-0.013,0.004-0.019,0.004c-0.019,0.002-0.036-0.005-0.047-0.018l-0.472-0.58
   L914.442,28.488z"
      />
      <path
        d="M917.024,28.058l0.345,0.424l-0.051-0.414c-0.003-0.022,0.012-0.044,0.037-0.053c0.024-0.01,0.051-0.004,0.065,0.013
   l0.346,0.424l-0.052-0.414c-0.003-0.022,0.013-0.043,0.037-0.053c0.024-0.01,0.052-0.004,0.066,0.013l0.346,0.424l-0.052-0.413
   c-0.003-0.022,0.013-0.044,0.037-0.054c0.024-0.009,0.051-0.003,0.066,0.014l0.475,0.58l-0.095,0.061l-0.346-0.425L918.3,28.6
   c0.003,0.022-0.012,0.044-0.037,0.054c-0.024,0.009-0.052,0.003-0.066-0.014l-0.346-0.425l0.051,0.414
   c0.003,0.023-0.012,0.045-0.037,0.054c-0.024,0.009-0.051,0.004-0.066-0.014l-0.345-0.424l0.051,0.414
   c0.003,0.022-0.013,0.045-0.037,0.054c-0.007,0.002-0.013,0.004-0.019,0.004c-0.019,0.002-0.036-0.005-0.047-0.018l-0.472-0.58
   L917.024,28.058z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M917.024,28.058l0.345,0.424l-0.051-0.414
   c-0.003-0.022,0.012-0.044,0.037-0.053c0.024-0.01,0.051-0.004,0.065,0.013l0.346,0.424l-0.052-0.414
   c-0.003-0.022,0.013-0.043,0.037-0.053c0.024-0.01,0.052-0.004,0.066,0.013l0.346,0.424l-0.052-0.413
   c-0.003-0.022,0.013-0.044,0.037-0.054c0.024-0.009,0.051-0.003,0.066,0.014l0.475,0.58l-0.095,0.061l-0.346-0.425L918.3,28.6
   c0.003,0.022-0.012,0.044-0.037,0.054c-0.024,0.009-0.052,0.003-0.066-0.014l-0.346-0.425l0.051,0.414
   c0.003,0.023-0.012,0.045-0.037,0.054c-0.024,0.009-0.051,0.004-0.066-0.014l-0.345-0.424l0.051,0.414
   c0.003,0.022-0.013,0.045-0.037,0.054c-0.007,0.002-0.013,0.004-0.019,0.004c-0.019,0.002-0.036-0.005-0.047-0.018l-0.472-0.58
   L917.024,28.058z"
      />
      <path
        d="M903.994,56.662l0.312,0.448l-0.02-0.416c-0.001-0.022,0.016-0.043,0.041-0.051c0.025-0.007,0.052,0,0.064,0.019
   l0.314,0.447l-0.021-0.416c-0.002-0.022,0.016-0.043,0.04-0.051c0.025-0.007,0.052,0,0.065,0.019l0.314,0.448l-0.022-0.416
   c-0.001-0.023,0.016-0.043,0.041-0.051c0.025-0.008,0.052,0,0.065,0.019l0.431,0.613l-0.099,0.054l-0.314-0.449l0.021,0.417
   c0.002,0.022-0.015,0.043-0.04,0.051c-0.025,0.007-0.052,0-0.065-0.018l-0.315-0.449l0.022,0.416
   c0.001,0.023-0.016,0.044-0.041,0.051c-0.025,0.008-0.052,0-0.064-0.018l-0.314-0.449l0.021,0.417
   c0.001,0.022-0.016,0.043-0.041,0.051c-0.007,0.001-0.014,0.002-0.02,0.002c-0.019,0-0.036-0.007-0.045-0.021l-0.428-0.613
   L903.994,56.662z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M903.994,56.662l0.312,0.448l-0.02-0.416
   c-0.001-0.022,0.016-0.043,0.041-0.051c0.025-0.007,0.052,0,0.064,0.019l0.314,0.447l-0.021-0.416
   c-0.002-0.022,0.016-0.043,0.04-0.051c0.025-0.007,0.052,0,0.065,0.019l0.314,0.448l-0.022-0.416
   c-0.001-0.023,0.016-0.043,0.041-0.051c0.025-0.008,0.052,0,0.065,0.019l0.431,0.613l-0.099,0.054l-0.314-0.449l0.021,0.417
   c0.002,0.022-0.015,0.043-0.04,0.051c-0.025,0.007-0.052,0-0.065-0.018l-0.315-0.449l0.022,0.416
   c0.001,0.023-0.016,0.044-0.041,0.051c-0.025,0.008-0.052,0-0.064-0.018l-0.314-0.449l0.021,0.417
   c0.001,0.022-0.016,0.043-0.041,0.051c-0.007,0.001-0.014,0.002-0.02,0.002c-0.019,0-0.036-0.007-0.045-0.021l-0.428-0.613
   L903.994,56.662z"
      />
      <path
        d="M906.361,56.662l0.312,0.448l-0.02-0.416c-0.001-0.022,0.016-0.043,0.041-0.051c0.025-0.007,0.051,0,0.064,0.019
   l0.313,0.447l-0.021-0.416c-0.001-0.022,0.016-0.043,0.041-0.051c0.025-0.007,0.052,0,0.065,0.019l0.314,0.448l-0.022-0.416
   c-0.001-0.023,0.016-0.043,0.041-0.051c0.025-0.008,0.052,0,0.065,0.019l0.431,0.613l-0.099,0.054l-0.315-0.449l0.022,0.417
   c0.001,0.022-0.015,0.043-0.04,0.051c-0.025,0.007-0.052,0-0.065-0.018l-0.315-0.449l0.022,0.416
   c0.001,0.023-0.016,0.044-0.041,0.051c-0.025,0.008-0.052,0-0.065-0.018l-0.313-0.449l0.021,0.417
   c0.001,0.022-0.017,0.043-0.041,0.051c-0.007,0.001-0.014,0.002-0.02,0.002c-0.019,0-0.036-0.007-0.045-0.021l-0.429-0.613
   L906.361,56.662z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M906.361,56.662l0.312,0.448l-0.02-0.416
   c-0.001-0.022,0.016-0.043,0.041-0.051c0.025-0.007,0.051,0,0.064,0.019l0.313,0.447l-0.021-0.416
   c-0.001-0.022,0.016-0.043,0.041-0.051c0.025-0.007,0.052,0,0.065,0.019l0.314,0.448l-0.022-0.416
   c-0.001-0.023,0.016-0.043,0.041-0.051c0.025-0.008,0.052,0,0.065,0.019l0.431,0.613l-0.099,0.054l-0.315-0.449l0.022,0.417
   c0.001,0.022-0.015,0.043-0.04,0.051c-0.025,0.007-0.052,0-0.065-0.018l-0.315-0.449l0.022,0.416
   c0.001,0.023-0.016,0.044-0.041,0.051c-0.025,0.008-0.052,0-0.065-0.018l-0.313-0.449l0.021,0.417
   c0.001,0.022-0.017,0.043-0.041,0.051c-0.007,0.001-0.014,0.002-0.02,0.002c-0.019,0-0.036-0.007-0.045-0.021l-0.429-0.613
   L906.361,56.662z"
      />
      <path
        d="M913.676,56.34l0.313,0.448l-0.021-0.416c-0.001-0.022,0.016-0.043,0.041-0.051c0.025-0.007,0.052,0,0.064,0.019
   l0.314,0.448l-0.021-0.417c-0.001-0.022,0.016-0.043,0.04-0.051c0.026-0.007,0.052,0,0.065,0.019l0.314,0.448l-0.021-0.416
   c-0.002-0.022,0.016-0.043,0.04-0.051c0.025-0.008,0.052,0,0.065,0.019l0.431,0.613l-0.098,0.054l-0.315-0.449l0.022,0.417
   c0.001,0.022-0.016,0.043-0.041,0.051c-0.025,0.007-0.052,0-0.065-0.018l-0.314-0.449l0.021,0.416
   c0.001,0.023-0.016,0.044-0.041,0.052c-0.024,0.007-0.051-0.001-0.064-0.019l-0.314-0.449l0.021,0.417
   c0.001,0.022-0.016,0.043-0.041,0.051c-0.007,0.001-0.013,0.003-0.02,0.003c-0.018,0-0.036-0.008-0.045-0.022l-0.428-0.613
   L913.676,56.34z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M913.676,56.34l0.313,0.448l-0.021-0.416
   c-0.001-0.022,0.016-0.043,0.041-0.051c0.025-0.007,0.052,0,0.064,0.019l0.314,0.448l-0.021-0.417
   c-0.001-0.022,0.016-0.043,0.04-0.051c0.026-0.007,0.052,0,0.065,0.019l0.314,0.448l-0.021-0.416
   c-0.002-0.022,0.016-0.043,0.04-0.051c0.025-0.008,0.052,0,0.065,0.019l0.431,0.613l-0.098,0.054l-0.315-0.449l0.022,0.417
   c0.001,0.022-0.016,0.043-0.041,0.051c-0.025,0.007-0.052,0-0.065-0.018l-0.314-0.449l0.021,0.416
   c0.001,0.023-0.016,0.044-0.041,0.052c-0.024,0.007-0.051-0.001-0.064-0.019l-0.314-0.449l0.021,0.417
   c0.001,0.022-0.016,0.043-0.041,0.051c-0.007,0.001-0.013,0.003-0.02,0.003c-0.018,0-0.036-0.008-0.045-0.022l-0.428-0.613
   L913.676,56.34z"
      />
      <path
        d="M916.15,56.232l0.312,0.448l-0.02-0.416c-0.001-0.022,0.016-0.043,0.041-0.051c0.025-0.008,0.052,0,0.064,0.019l0.314,0.447
   l-0.021-0.416c-0.001-0.022,0.016-0.043,0.04-0.051c0.026-0.007,0.052,0,0.065,0.019l0.314,0.448l-0.021-0.416
   c-0.002-0.023,0.016-0.044,0.04-0.051c0.025-0.008,0.052,0,0.065,0.019l0.431,0.613l-0.098,0.054l-0.315-0.449l0.022,0.417
   c0.001,0.022-0.016,0.043-0.041,0.051c-0.025,0.007-0.052,0-0.065-0.019l-0.314-0.449l0.021,0.417
   c0.001,0.022-0.016,0.043-0.041,0.051c-0.024,0.007-0.051,0-0.064-0.018l-0.314-0.449l0.021,0.417
   c0.001,0.022-0.016,0.043-0.041,0.051c-0.007,0.001-0.013,0.002-0.02,0.002c-0.018,0-0.036-0.007-0.045-0.021l-0.428-0.613
   L916.15,56.232z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M916.15,56.232l0.312,0.448l-0.02-0.416
   c-0.001-0.022,0.016-0.043,0.041-0.051c0.025-0.008,0.052,0,0.064,0.019l0.314,0.447l-0.021-0.416
   c-0.001-0.022,0.016-0.043,0.04-0.051c0.026-0.007,0.052,0,0.065,0.019l0.314,0.448l-0.021-0.416
   c-0.002-0.023,0.016-0.044,0.04-0.051c0.025-0.008,0.052,0,0.065,0.019l0.431,0.613l-0.098,0.054l-0.315-0.449l0.022,0.417
   c0.001,0.022-0.016,0.043-0.041,0.051c-0.025,0.007-0.052,0-0.065-0.019l-0.314-0.449l0.021,0.417
   c0.001,0.022-0.016,0.043-0.041,0.051c-0.024,0.007-0.051,0-0.064-0.018l-0.314-0.449l0.021,0.417
   c0.001,0.022-0.016,0.043-0.041,0.051c-0.007,0.001-0.013,0.002-0.02,0.002c-0.018,0-0.036-0.007-0.045-0.021l-0.428-0.613
   L916.15,56.232z"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="1055.492"
        y1="28.621"
        x2="1056.398"
        y2="58.111"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="1052.75"
        y1="28.244"
        x2="1053.709"
        y2="58.111"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="1045.811"
        y1="27.399"
        x2="1046.717"
        y2="58.11"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="1043.068"
        y1="27.007"
        x2="1044.028"
        y2="58.111"
      />
      <path
        d="M1056.266,29.672l-0.345,0.423l0.052-0.413c0.002-0.022-0.013-0.044-0.038-0.053c-0.024-0.01-0.051-0.004-0.065,0.013
   l-0.346,0.424l0.052-0.414c0.003-0.022-0.013-0.044-0.037-0.053c-0.024-0.01-0.052-0.004-0.066,0.013l-0.346,0.424l0.052-0.413
   c0.003-0.022-0.013-0.045-0.037-0.054c-0.024-0.009-0.051-0.004-0.066,0.014l-0.475,0.58l0.095,0.061l0.346-0.425l-0.052,0.415
   c-0.003,0.021,0.013,0.044,0.037,0.053c0.025,0.009,0.052,0.004,0.066-0.013l0.346-0.425l-0.051,0.414
   c-0.003,0.022,0.012,0.044,0.037,0.054c0.024,0.009,0.051,0.004,0.066-0.014l0.345-0.424l-0.051,0.414
   c-0.003,0.022,0.013,0.044,0.037,0.054c0.007,0.002,0.013,0.004,0.019,0.004c0.019,0.002,0.036-0.005,0.047-0.018l0.472-0.58
   L1056.266,29.672z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M1056.266,29.672l-0.345,0.423l0.052-0.413
   c0.002-0.022-0.013-0.044-0.038-0.053c-0.024-0.01-0.051-0.004-0.065,0.013l-0.346,0.424l0.052-0.414
   c0.003-0.022-0.013-0.044-0.037-0.053c-0.024-0.01-0.052-0.004-0.066,0.013l-0.346,0.424l0.052-0.413
   c0.003-0.022-0.013-0.045-0.037-0.054c-0.024-0.009-0.051-0.004-0.066,0.014l-0.475,0.58l0.095,0.061l0.346-0.425l-0.052,0.415
   c-0.003,0.021,0.013,0.044,0.037,0.053c0.025,0.009,0.052,0.004,0.066-0.013l0.346-0.425l-0.051,0.414
   c-0.003,0.022,0.012,0.044,0.037,0.054c0.024,0.009,0.051,0.004,0.066-0.014l0.345-0.424l-0.051,0.414
   c-0.003,0.022,0.013,0.044,0.037,0.054c0.007,0.002,0.013,0.004,0.019,0.004c0.019,0.002,0.036-0.005,0.047-0.018l0.472-0.58
   L1056.266,29.672z"
      />
      <path
        d="M1053.576,29.241l-0.345,0.424l0.052-0.414c0.002-0.022-0.013-0.044-0.038-0.053c-0.024-0.01-0.051-0.004-0.065,0.014
   l-0.346,0.423l0.052-0.414c0.003-0.022-0.013-0.043-0.037-0.053c-0.024-0.01-0.052-0.004-0.066,0.014l-0.346,0.424l0.052-0.414
   c0.003-0.022-0.012-0.044-0.037-0.054c-0.024-0.009-0.051-0.003-0.065,0.014l-0.475,0.58l0.094,0.061l0.347-0.424l-0.052,0.414
   c-0.003,0.022,0.012,0.044,0.036,0.054c0.025,0.009,0.052,0.004,0.066-0.014l0.347-0.424l-0.052,0.414
   c-0.003,0.022,0.012,0.044,0.037,0.053c0.024,0.01,0.051,0.004,0.066-0.013l0.345-0.425l-0.051,0.414
   c-0.002,0.023,0.013,0.045,0.037,0.054c0.007,0.003,0.013,0.004,0.02,0.005c0.018,0.001,0.036-0.006,0.046-0.019l0.472-0.58
   L1053.576,29.241z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M1053.576,29.241l-0.345,0.424l0.052-0.414
   c0.002-0.022-0.013-0.044-0.038-0.053c-0.024-0.01-0.051-0.004-0.065,0.014l-0.346,0.423l0.052-0.414
   c0.003-0.022-0.013-0.043-0.037-0.053c-0.024-0.01-0.052-0.004-0.066,0.014l-0.346,0.424l0.052-0.414
   c0.003-0.022-0.012-0.044-0.037-0.054c-0.024-0.009-0.051-0.003-0.065,0.014l-0.475,0.58l0.094,0.061l0.347-0.424l-0.052,0.414
   c-0.003,0.022,0.012,0.044,0.036,0.054c0.025,0.009,0.052,0.004,0.066-0.014l0.347-0.424l-0.052,0.414
   c-0.003,0.022,0.012,0.044,0.037,0.053c0.024,0.01,0.051,0.004,0.066-0.013l0.345-0.425l-0.051,0.414
   c-0.002,0.023,0.013,0.045,0.037,0.054c0.007,0.003,0.013,0.004,0.02,0.005c0.018,0.001,0.036-0.006,0.046-0.019l0.472-0.58
   L1053.576,29.241z"
      />
      <path
        d="M1046.585,28.488l-0.345,0.424l0.051-0.414c0.003-0.022-0.012-0.044-0.037-0.053c-0.024-0.01-0.051-0.004-0.065,0.013
   l-0.346,0.424l0.052-0.414c0.003-0.022-0.013-0.043-0.037-0.053c-0.025-0.01-0.052-0.004-0.066,0.014l-0.346,0.423l0.052-0.413
   c0.003-0.022-0.013-0.044-0.037-0.054c-0.024-0.009-0.052-0.003-0.066,0.014l-0.475,0.58l0.094,0.061l0.347-0.424l-0.052,0.414
   c-0.003,0.022,0.012,0.044,0.037,0.054c0.024,0.009,0.052,0.003,0.066-0.014l0.346-0.424l-0.051,0.414
   c-0.003,0.022,0.012,0.044,0.037,0.053c0.024,0.01,0.051,0.004,0.066-0.013l0.345-0.425l-0.051,0.414
   c-0.003,0.023,0.012,0.045,0.037,0.054c0.006,0.002,0.013,0.004,0.019,0.004c0.019,0.002,0.036-0.005,0.047-0.018l0.472-0.58
   L1046.585,28.488z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M1046.585,28.488l-0.345,0.424l0.051-0.414
   c0.003-0.022-0.012-0.044-0.037-0.053c-0.024-0.01-0.051-0.004-0.065,0.013l-0.346,0.424l0.052-0.414
   c0.003-0.022-0.013-0.043-0.037-0.053c-0.025-0.01-0.052-0.004-0.066,0.014l-0.346,0.423l0.052-0.413
   c0.003-0.022-0.013-0.044-0.037-0.054c-0.024-0.009-0.052-0.003-0.066,0.014l-0.475,0.58l0.094,0.061l0.347-0.424l-0.052,0.414
   c-0.003,0.022,0.012,0.044,0.037,0.054c0.024,0.009,0.052,0.003,0.066-0.014l0.346-0.424l-0.051,0.414
   c-0.003,0.022,0.012,0.044,0.037,0.053c0.024,0.01,0.051,0.004,0.066-0.013l0.345-0.425l-0.051,0.414
   c-0.003,0.023,0.012,0.045,0.037,0.054c0.006,0.002,0.013,0.004,0.019,0.004c0.019,0.002,0.036-0.005,0.047-0.018l0.472-0.58
   L1046.585,28.488z"
      />
      <path
        d="M1044.003,28.058l-0.345,0.424l0.052-0.414c0.002-0.022-0.013-0.044-0.038-0.053c-0.024-0.01-0.051-0.004-0.065,0.013
   l-0.346,0.424l0.052-0.414c0.003-0.022-0.013-0.043-0.037-0.053c-0.024-0.01-0.051-0.004-0.066,0.013l-0.346,0.424l0.052-0.413
   c0.003-0.022-0.012-0.044-0.037-0.054c-0.024-0.009-0.051-0.003-0.065,0.014l-0.475,0.58l0.094,0.061l0.347-0.425l-0.052,0.415
   c-0.003,0.022,0.012,0.044,0.036,0.054c0.025,0.009,0.052,0.003,0.067-0.014l0.346-0.425l-0.052,0.414
   c-0.003,0.023,0.012,0.045,0.037,0.054c0.024,0.009,0.051,0.004,0.066-0.014l0.345-0.424l-0.051,0.414
   c-0.002,0.022,0.013,0.045,0.037,0.054c0.007,0.002,0.013,0.004,0.02,0.004c0.018,0.002,0.036-0.005,0.046-0.018l0.472-0.58
   L1044.003,28.058z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M1044.003,28.058l-0.345,0.424l0.052-0.414
   c0.002-0.022-0.013-0.044-0.038-0.053c-0.024-0.01-0.051-0.004-0.065,0.013l-0.346,0.424l0.052-0.414
   c0.003-0.022-0.013-0.043-0.037-0.053c-0.024-0.01-0.051-0.004-0.066,0.013l-0.346,0.424l0.052-0.413
   c0.003-0.022-0.012-0.044-0.037-0.054c-0.024-0.009-0.051-0.003-0.065,0.014l-0.475,0.58l0.094,0.061l0.347-0.425l-0.052,0.415
   c-0.003,0.022,0.012,0.044,0.036,0.054c0.025,0.009,0.052,0.003,0.067-0.014l0.346-0.425l-0.052,0.414
   c-0.003,0.023,0.012,0.045,0.037,0.054c0.024,0.009,0.051,0.004,0.066-0.014l0.345-0.424l-0.051,0.414
   c-0.002,0.022,0.013,0.045,0.037,0.054c0.007,0.002,0.013,0.004,0.02,0.004c0.018,0.002,0.036-0.005,0.046-0.018l0.472-0.58
   L1044.003,28.058z"
      />
      <path
        d="M1057.032,56.662l-0.313,0.448l0.021-0.416c0.001-0.022-0.016-0.043-0.041-0.051c-0.025-0.007-0.052,0-0.065,0.019
   l-0.313,0.447l0.021-0.416c0.001-0.022-0.016-0.043-0.04-0.051c-0.026-0.007-0.052,0-0.065,0.019l-0.314,0.448l0.021-0.416
   c0.002-0.023-0.016-0.043-0.04-0.051c-0.025-0.008-0.052,0-0.065,0.019l-0.431,0.613l0.098,0.054l0.315-0.449l-0.022,0.417
   c-0.001,0.022,0.016,0.043,0.041,0.051c0.025,0.007,0.052,0,0.065-0.018l0.314-0.449l-0.021,0.416
   c-0.001,0.023,0.016,0.044,0.041,0.051c0.024,0.008,0.051,0,0.064-0.018l0.314-0.449l-0.021,0.417
   c-0.001,0.022,0.016,0.043,0.041,0.051c0.007,0.001,0.013,0.002,0.02,0.002c0.018,0,0.035-0.007,0.045-0.021l0.428-0.613
   L1057.032,56.662z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M1057.032,56.662l-0.313,0.448l0.021-0.416
   c0.001-0.022-0.016-0.043-0.041-0.051c-0.025-0.007-0.052,0-0.065,0.019l-0.313,0.447l0.021-0.416
   c0.001-0.022-0.016-0.043-0.04-0.051c-0.026-0.007-0.052,0-0.065,0.019l-0.314,0.448l0.021-0.416
   c0.002-0.023-0.016-0.043-0.04-0.051c-0.025-0.008-0.052,0-0.065,0.019l-0.431,0.613l0.098,0.054l0.315-0.449l-0.022,0.417
   c-0.001,0.022,0.016,0.043,0.041,0.051c0.025,0.007,0.052,0,0.065-0.018l0.314-0.449l-0.021,0.416
   c-0.001,0.023,0.016,0.044,0.041,0.051c0.024,0.008,0.051,0,0.064-0.018l0.314-0.449l-0.021,0.417
   c-0.001,0.022,0.016,0.043,0.041,0.051c0.007,0.001,0.013,0.002,0.02,0.002c0.018,0,0.035-0.007,0.045-0.021l0.428-0.613
   L1057.032,56.662z"
      />
      <path
        d="M1054.666,56.662l-0.312,0.448l0.02-0.416c0.001-0.022-0.016-0.043-0.041-0.051c-0.025-0.007-0.052,0-0.064,0.019
   l-0.314,0.447l0.021-0.416c0.002-0.022-0.016-0.043-0.04-0.051c-0.025-0.007-0.052,0-0.065,0.019l-0.314,0.448l0.021-0.416
   c0.002-0.023-0.016-0.043-0.04-0.051c-0.025-0.008-0.052,0-0.065,0.019l-0.431,0.613l0.098,0.054l0.315-0.449l-0.021,0.417
   c-0.002,0.022,0.015,0.043,0.04,0.051c0.025,0.007,0.052,0,0.065-0.018l0.314-0.449l-0.021,0.416
   c-0.001,0.023,0.016,0.044,0.041,0.051c0.025,0.008,0.052,0,0.064-0.018l0.314-0.449l-0.021,0.417
   c-0.001,0.022,0.016,0.043,0.041,0.051c0.007,0.001,0.014,0.002,0.02,0.002c0.019,0,0.036-0.007,0.045-0.021l0.428-0.613
   L1054.666,56.662z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M1054.666,56.662l-0.312,0.448l0.02-0.416
   c0.001-0.022-0.016-0.043-0.041-0.051c-0.025-0.007-0.052,0-0.064,0.019l-0.314,0.447l0.021-0.416
   c0.002-0.022-0.016-0.043-0.04-0.051c-0.025-0.007-0.052,0-0.065,0.019l-0.314,0.448l0.021-0.416
   c0.002-0.023-0.016-0.043-0.04-0.051c-0.025-0.008-0.052,0-0.065,0.019l-0.431,0.613l0.098,0.054l0.315-0.449l-0.021,0.417
   c-0.002,0.022,0.015,0.043,0.04,0.051c0.025,0.007,0.052,0,0.065-0.018l0.314-0.449l-0.021,0.416
   c-0.001,0.023,0.016,0.044,0.041,0.051c0.025,0.008,0.052,0,0.064-0.018l0.314-0.449l-0.021,0.417
   c-0.001,0.022,0.016,0.043,0.041,0.051c0.007,0.001,0.014,0.002,0.02,0.002c0.019,0,0.036-0.007,0.045-0.021l0.428-0.613
   L1054.666,56.662z"
      />
      <path
        d="M1047.351,56.34l-0.312,0.448l0.02-0.416c0.001-0.022-0.016-0.043-0.041-0.051c-0.025-0.007-0.051,0-0.064,0.019
   l-0.314,0.448l0.022-0.417c0.001-0.022-0.016-0.043-0.041-0.051c-0.025-0.007-0.052,0-0.065,0.019l-0.314,0.448l0.022-0.416
   c0.001-0.022-0.016-0.043-0.041-0.051s-0.052,0-0.065,0.019l-0.431,0.613l0.099,0.054l0.315-0.449l-0.022,0.417
   c-0.001,0.022,0.015,0.043,0.04,0.051c0.025,0.007,0.052,0,0.065-0.018l0.315-0.449l-0.022,0.416
   c-0.001,0.023,0.016,0.044,0.041,0.052c0.025,0.007,0.052-0.001,0.065-0.019l0.313-0.449l-0.021,0.417
   c-0.001,0.022,0.017,0.043,0.041,0.051c0.007,0.001,0.014,0.003,0.02,0.003c0.019,0,0.036-0.008,0.045-0.022l0.429-0.613
   L1047.351,56.34z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M1047.351,56.34l-0.312,0.448l0.02-0.416
   c0.001-0.022-0.016-0.043-0.041-0.051c-0.025-0.007-0.051,0-0.064,0.019l-0.314,0.448l0.022-0.417
   c0.001-0.022-0.016-0.043-0.041-0.051c-0.025-0.007-0.052,0-0.065,0.019l-0.314,0.448l0.022-0.416
   c0.001-0.022-0.016-0.043-0.041-0.051s-0.052,0-0.065,0.019l-0.431,0.613l0.099,0.054l0.315-0.449l-0.022,0.417
   c-0.001,0.022,0.015,0.043,0.04,0.051c0.025,0.007,0.052,0,0.065-0.018l0.315-0.449l-0.022,0.416
   c-0.001,0.023,0.016,0.044,0.041,0.052c0.025,0.007,0.052-0.001,0.065-0.019l0.313-0.449l-0.021,0.417
   c-0.001,0.022,0.017,0.043,0.041,0.051c0.007,0.001,0.014,0.003,0.02,0.003c0.019,0,0.036-0.008,0.045-0.022l0.429-0.613
   L1047.351,56.34z"
      />
      <path
        d="M1044.877,56.232l-0.313,0.448l0.021-0.416c0-0.022-0.016-0.043-0.041-0.051c-0.025-0.008-0.052,0-0.065,0.019l-0.313,0.447
   l0.021-0.416c0.001-0.022-0.016-0.043-0.041-0.051c-0.025-0.007-0.052,0-0.064,0.019l-0.314,0.448l0.021-0.416
   c0.001-0.023-0.016-0.044-0.04-0.051c-0.026-0.008-0.052,0-0.065,0.019l-0.431,0.613l0.098,0.054l0.315-0.449l-0.022,0.417
   c-0.001,0.022,0.016,0.043,0.041,0.051c0.025,0.007,0.052,0,0.065-0.019l0.314-0.449l-0.021,0.417
   c-0.001,0.022,0.016,0.043,0.041,0.051c0.024,0.007,0.051,0,0.064-0.018l0.314-0.449l-0.021,0.417
   c-0.001,0.022,0.016,0.043,0.041,0.051c0.006,0.001,0.013,0.002,0.02,0.002c0.018,0,0.035-0.007,0.045-0.021l0.428-0.613
   L1044.877,56.232z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.108"
        strokeMiterlimit="10"
        d="M1044.877,56.232l-0.313,0.448l0.021-0.416
   c0-0.022-0.016-0.043-0.041-0.051c-0.025-0.008-0.052,0-0.065,0.019l-0.313,0.447l0.021-0.416c0.001-0.022-0.016-0.043-0.041-0.051
   c-0.025-0.007-0.052,0-0.064,0.019l-0.314,0.448l0.021-0.416c0.001-0.023-0.016-0.044-0.04-0.051c-0.026-0.008-0.052,0-0.065,0.019
   l-0.431,0.613l0.098,0.054l0.315-0.449l-0.022,0.417c-0.001,0.022,0.016,0.043,0.041,0.051c0.025,0.007,0.052,0,0.065-0.019
   l0.314-0.449l-0.021,0.417c-0.001,0.022,0.016,0.043,0.041,0.051c0.024,0.007,0.051,0,0.064-0.018l0.314-0.449l-0.021,0.417
   c-0.001,0.022,0.016,0.043,0.041,0.051c0.006,0.001,0.013,0.002,0.02,0.002c0.018,0,0.035-0.007,0.045-0.021l0.428-0.613
   L1044.877,56.232z"
      />
      <path
        d="M837.659,263.471c-0.418-4.527-1.522-9.09-2.59-13.503l-0.143-0.593c-1.076-4.452-2.341-9.02-3.867-13.969
   c-1.444-4.679-3.04-9.437-4.882-14.546c-1.708-4.739-3.613-9.729-5.664-14.829c-1.918-4.77-4.011-9.756-6.219-14.818
   c-2.05-4.701-4.252-9.584-6.541-14.512c-2.109-4.535-4.341-9.216-6.635-13.91c-2.087-4.269-4.273-8.648-6.499-13.015
   c-1.989-3.906-4.052-7.883-6.129-11.822c-1.819-3.45-3.681-6.928-5.532-10.336c-1.568-2.886-3.15-5.763-4.704-8.555
   c-1.243-2.232-2.471-4.411-3.646-6.475c-0.856-1.504-1.626-2.845-2.357-4.103c-0.262-0.454-0.527-0.907-0.792-1.359l0.006-0.193
   c0.457-14.758,0.952-33.136,1.029-36.035l0.011,0.003V52.937c0-0.366-0.229-0.699-0.57-0.828c-5.669-2.155-12.868-4.358-19.22-6.301
   c-2.226-0.682-4.327-1.325-6.284-1.94c-4.297-1.361-8.657-2.663-12.964-3.871c-10.728-2.682-20.354-5.45-29.43-8.46
   c-4.55-1.51-9.564-3.086-14.857-4.415l-0.008-0.003l-0.483-0.147l-0.003,0.027c-4.392-1.088-8.971-1.999-13.633-2.556
   c-0.074-0.01-0.148-0.008-0.217,0.003h-0.02c-0.927-0.013-1.93,0.025-2.016,0.028l-1.751,0.005c-0.54,0-0.914,0.288-1.003,0.772
   c-3.203,17.587-8.952,29.116-9.01,29.231l-0.004,0.01c-0.042,0.09-0.375,0.919,0.677,2.246c0.063,0.089,0.471,0.639,1.404,1.294
   c-4.838,9.488-8.578,19.343-11.132,29.348c-2.367,9.266-3.74,18.732-4.082,28.134c-0.607,16.694,2.231,28.545,3.115,31.779
   c0.214,0.785,0.361,1.595,0.437,2.408c0.407,4.337,1.343,16.35,1.257,34.176c-0.074,15.362,1.968,32.312,3.457,44.689
   c0.676,5.606,1.259,10.448,1.493,13.852c0.534,7.791-0.732,17.027-1.657,23.771c-0.372,2.714-0.693,5.059-0.818,6.736
   c-0.271,3.664-0.164,16.161-0.028,26c0.077,5.47-0.596,10.921-1.996,16.203c-2.567,9.682-5.999,23.56-7.761,34.684
   c-2.767,17.447-7.059,58.657-7.101,59.065c-0.067,0.527-6.676,52.821-7.102,61.446l-0.011,0.219l0.206,0.08
   c9.487,3.672,19.14,6.3,28.686,7.811c6.443,1.02,12.837,1.533,19.058,1.533c1.217,0,2.428-0.02,3.632-0.058
   c12.36-0.406,20.388-2.827,20.825-3.351c0.369-0.443,1.391-4.757,2.377-10.036c0.763-4.08,2.162-12.303,2.962-21.543
   c1.374-15.845,10.349-53.182,10.533-53.946c0.678-2.194,15.614-50.563,16.574-58.022c0.991-7.708,2.257-43.489,1.938-50.289
   c-0.268-5.718,2.88-19.882,3.885-24.228c6.397,3.008,7.941,9.351,7.99,9.567c0.063,0.356,2.177,12.357,3.544,27.397
   c1.39,15.285,2.997,17.793,3.065,17.893l0.011,0.016c0.029,0.037,2.94,3.846,2.947,9.579c-1.677,11.811,0.144,55.514,1.292,71.578
   c1.063,14.877,1.181,49.543,1.182,49.892l0.006,0.056c0.048,0.253,0.746,2.511,10.263,3.783c10.016,1.337,20.064,1.756,35.102,2.058
   c0.491,0.01,0.974,0.015,1.452,0.015c7.64,0,13.775-1.216,17.661-2.271c4.483-1.218,6.96-2.458,7.063-2.51l0.152-0.077l0.014-0.17
   c0.02-0.246,2.036-24.753,1.183-32.544c-0.9-8.209-0.891-28.081,0.964-37.666c0.068-0.349,0.116-0.701,0.155-0.998
   c0.261-2.007,0.372-4.062,0.479-6.048l0.012-0.223c0.188-3.468,0.306-6.884,0.397-9.77c0.116-3.676,0.217-7.604,0.315-12.359
   c0.089-4.292,0.167-8.879,0.24-14.025c0.067-4.64,0.125-9.471,0.179-14.771c0.046-4.692,0.087-9.465,0.124-14.592
   c0.03-4.368,0.057-8.907,0.079-13.491c0.019-3.814,0.033-7.672,0.046-11.467c0.004-1.562,0.008-3.124,0.011-4.686
   c0.002-0.752,0.013-1.515,0.023-2.256C837.842,268.136,837.873,265.79,837.659,263.471 M771.895,52.937v17.164
   c-1.101-0.302-4.466-1.223-9.159-2.487l0.392-17.918c3.036,0.986,5.978,1.989,8.591,2.983
   C771.825,52.719,771.895,52.823,771.895,52.937 M762.129,67.451c-2.777-0.747-5.986-1.605-9.445-2.521l0.462-18.352
   c3.036,0.928,6.247,1.913,9.376,2.923L762.129,67.451z M704.345,101.471l12.146-5.024c1.366-0.566,2.748-1.191,4.107-1.858
   c9.172-4.503,27.485-12.488,30.563-13.828l-0.674,19.873c-5.325,0.998-25.244,5.655-33.336,8.655l-13.927,4.847
   C703.617,109.753,703.991,105.521,704.345,101.471 M743.617,83.345l0.02,0.049c-7.021,3.097-17.191,7.645-23.308,10.648
   c-1.347,0.661-2.718,1.281-4.072,1.841l-11.852,4.902c2.216-25.352,3.645-43.402,3.854-46.059c6.744,1.25,18.41,4.099,29.942,7.056
   l-0.381,13.052l0.234,0.062c0.365,0.094,8.515,2.196,13.255,2.196c0.273,0,0.536-0.008,0.783-0.023
   c0.191-0.003,0.291-0.132,0.296-0.383l0.28-11.13c1.783,0.472,3.498,0.928,5.122,1.362l-0.026,0.535
   c-0.125,2.051-0.581,7.638-1.176,8.828c-0.18,0.363-0.441,0.734-0.773,1.102c-0.65,0.722-1.458,1.297-2.401,1.706L743.617,83.345z
    M738.825,61.313l0.545-18.618l13.167,3.83c-0.039,1.556-0.263,10.489-0.458,18.245c-0.005,0.209-0.011,0.418-0.015,0.626
   c-0.134,5.29-0.251,9.913-0.28,11.078c-4.141,0.144-11.893-1.745-13.341-2.109l0.364-12.428L738.825,61.313z M738.777,42.162
   l-0.557,18.996c-11.693-2.998-23.509-5.879-30.185-7.093c-1.84-0.334-3.803-0.592-5.837-0.785l2.38-20.922
   c8.874,2.922,18.285,5.616,28.732,8.228C735.125,41.095,736.95,41.621,738.777,42.162 M701.522,53.831
   c-0.517,4.55-0.942,8.283-1.056,9.289c-4.602-0.003-13.093-2.213-14.655-2.63l0.735-7.053l0.064-0.611l2.61-25.055l14.753,4.498
   c-0.203,1.783-1.429,12.576-2.382,20.957C701.567,53.429,701.545,53.631,701.522,53.831 M685.994,52.84
   c-9.613,0.232-18.013,1.124-20.202,1.373c1.135-2.411,5.979-13.282,8.822-28.891c0.023-0.132,0.121-0.234,0.244-0.265
   c0.071,0.001,0.139,0.003,0.208,0.004c0.006,0,0.012,0.001,0.018,0.001c4.628,0.558,9.175,1.467,13.538,2.549L685.994,52.84z
    M665.009,54.435c-0.001,0.003-0.004,0.005-0.005,0.008c-0.293,0.538-0.583,1.077-0.868,1.618c-0.571-0.84-0.42-1.325-0.412-1.352
   c0.189-0.375,5.24-10.553,8.415-27.989c0.032-0.174,0.193-0.293,0.366-0.273l0.02,0.002l1.258-0.003
   C670.581,43.143,665.186,54.077,665.009,54.435 M662.206,56.385l-0.013-0.02c-0.802-1.006-0.617-1.591-0.607-1.617
   c0.189-0.382,5.879-11.917,9.06-29.389c0.013-0.074,0.049-0.271,0.403-0.271l1.758-0.004h0.011c0.009,0,0.567-0.021,1.238-0.028
   c-0.019,0.049-0.033,0.102-0.042,0.156c-0.038,0.209-0.077,0.417-0.116,0.624l-1.34,0.003c-0.485-0.048-0.931,0.287-1.019,0.771
   c-3.202,17.586-8.312,27.731-8.363,27.832l-0.006,0.011c-0.041,0.089-0.369,0.904,0.65,2.209c-0.143,0.274-0.285,0.547-0.426,0.82
   C662.551,56.878,662.211,56.389,662.206,56.385 M665.469,54.865c1.274-0.151,10.164-1.162,20.462-1.415l-0.78,7.492l0.25,0.069
   c0.409,0.114,9.937,2.718,15.069,2.718c0.088,0,0.175,0,0.26-0.002c0.277,0.013,0.31-0.268,0.321-0.361l1.078-9.48
   c1.921,0.182,3.777,0.423,5.525,0.731l-2.923,34.907c-15.694-6.299-45.407-12.268-48.881-12.954
   C658.405,69.205,661.614,61.96,665.469,54.865 M655.649,77.152c1.941,0.383,14.918,2.975,28.15,6.45l-0.298,1.203
   c-0.021,0.082-0.071,0.151-0.143,0.194c-0.072,0.043-0.157,0.054-0.238,0.034c-3.606-0.919-21.619-5.47-27.989-6.336
   C655.301,78.182,655.472,77.667,655.649,77.152 M654.939,79.287c6.229,0.82,24.408,5.415,28.031,6.338
   c0.076,0.019,0.152,0.027,0.229,0.027c0.164,0,0.327-0.044,0.472-0.13c0.212-0.128,0.363-0.33,0.422-0.571l0.296-1.194
   c2.837,0.752,5.679,1.541,8.419,2.359l-2.21,12.747c-0.17,0.548-0.756,0.892-1.367,0.803l-38.176-5.592
   C652.063,89.099,653.358,84.167,654.939,79.287 M651.601,147.133c-0.878-3.215-3.696-14.99-3.092-31.597
   c0.159-4.369,0.532-8.715,1.12-13.033c1.175,1.114,2.279,2.256,3.284,3.398c3.999,4.542,6.126,11.345,6.506,20.796
   c0.333,8.294-0.645,18.547-3.079,32.266c-0.777,4.377-1.789,9.229-3.083,14.774c-0.212-12.282-0.874-20.63-1.199-24.093
   C651.98,148.797,651.826,147.953,651.601,147.133 M638.903,408.947c0.043-0.414,4.334-41.608,7.097-59.04
   c1.76-11.099,5.185-24.954,7.748-34.623c1.416-5.336,2.094-10.842,2.017-16.368c-0.112-8.044-0.257-22.112,0.026-25.946
   c0.124-1.658,0.443-3.994,0.814-6.698c0.929-6.771,2.2-16.042,1.661-23.896c-0.235-3.419-0.818-8.269-1.495-13.883
   c-1.489-12.361-3.527-29.289-3.453-44.612c0.013-2.703,0.002-5.272-0.026-7.702l0.014,0.003c1.561-6.53,2.749-12.127,3.634-17.112
   c2.442-13.764,3.423-24.058,3.088-32.398c-0.385-9.596-2.562-16.523-6.656-21.174c-1.096-1.244-2.307-2.487-3.597-3.695
   l-0.057,0.061c0.338-2.406,0.745-4.803,1.217-7.191l38.208,5.596c0.095,0.014,0.188,0.021,0.281,0.021
   c0.809,0,1.539-0.511,1.764-1.27l0.005-0.016l2.203-12.712c4.152,1.25,8.049,2.559,11.316,3.881
   c-0.992,11.56-2.197,25.25-3.56,40.051c-0.445-0.093-0.863-0.181-1.246-0.263l-22.997-4.874l-0.089,0.383
   c-0.777,3.298-18.326,77.912-19.128,86.98l-0.002,0.039c0.011,3.801,0.348,5.024,1.097,6.333
   c0.811,1.419,12.026,9.584,14.466,10.531c0.526,0.204,1.07,0.358,1.597,0.507c0.825,0.236,3.966,0.977,6.262,1.518
   c0.977,0.23,1.749,0.414,2.101,0.498c1.217,0.298,2.502,0.602,4.043,0.956c1.034,0.236,2.12,0.481,3.235,0.729
   c-3.831,32.397-7.226,54.843-10.092,66.716c-5.931,24.557-13.052,71.258-17.981,106.111c-5.045,35.67-8.885,66.531-9.327,70.109
   c-6.577-1.41-13.72-3.454-21.275-6.364C632.336,460.899,638.836,409.476,638.903,408.947 M690.904,232.89
   c-1.204-0.267-2.377-0.532-3.491-0.786c-1.54-0.354-2.822-0.656-4.037-0.952c-0.355-0.087-1.127-0.27-2.107-0.5
   c-2.162-0.51-5.425-1.279-6.233-1.508c-0.519-0.146-1.049-0.298-1.55-0.491c-2.554-0.992-13.478-9.086-14.14-10.242
   c-0.676-1.183-0.981-2.321-0.993-5.922c0.794-8.773,17.629-80.435,19.048-86.466l0.107,0.023
   c-1.961,9.257-4.074,20.054-4.297,22.518l-0.002,0.04c-0.01,3.822,0.306,5.046,1.019,6.346c0.356,0.65,0.991,1.145,1.55,1.582
   c0.156,0.122,0.304,0.237,0.436,0.35c1.322,1.11,2.68,2.147,3.714,2.926c0.481,0.36,0.958,0.733,1.463,1.125
   c2.105,1.638,4.283,3.331,6.63,4.256c2.202,0.866,4.604,1.364,6.933,1.845c0.581,0.121,1.183,0.247,1.764,0.374
   c1.835,0.4,3.707,0.781,5.519,1.15c1.029,0.211,2.059,0.42,3.089,0.635c1.398,0.295,2.789,0.608,4.138,0.944
   c1.501,0.374,2.862,0.704,4.163,1.013c1.28,0.302,2.799,0.656,4.361,0.983l0.367,0.076c0.138,0.031,0.275,0.06,0.415,0.089
   c0.744,0.156,1.508,0.302,2.276,0.368c2.547,0.218,15.983-2.305,17.317-3.258c1.232-0.88,2.059-1.866,3.702-5.393l0.015-0.036
   c0.525-1.451,1.702-6.148,3.013-11.768c-4.629,22.792-14.38,70.122-16.863,76.791c-1.601,3.286-2.385,4.184-3.537,4.947
   c-1.123,0.748-14.755,3.024-17.521,2.736c-0.91-0.095-1.832-0.302-2.723-0.501l-0.384-0.087c-1.619-0.36-3.193-0.744-4.517-1.072
   c-1.353-0.337-2.765-0.695-4.322-1.1C693.819,233.561,692.365,233.212,690.904,232.89 M741.46,163.728
   c-1.558,3.344-2.318,4.263-3.432,5.059c-1.086,0.775-14.224,3.366-16.889,3.138c-0.875-0.075-1.762-0.264-2.621-0.445l-0.368-0.077
   c-1.556-0.325-3.071-0.678-4.346-0.98c-1.3-0.308-2.661-0.639-4.16-1.01c-1.357-0.337-2.755-0.657-4.161-0.949
   c-1.032-0.214-2.063-0.425-3.094-0.635c-1.812-0.369-3.681-0.748-5.513-1.149c-0.584-0.128-1.189-0.252-1.772-0.372
   c-2.303-0.477-4.683-0.97-6.841-1.819c-2.272-0.893-4.416-2.561-6.486-4.174c-0.509-0.394-0.989-0.768-1.474-1.132
   c-1.027-0.775-2.377-1.804-3.69-2.906c-0.141-0.12-0.292-0.238-0.452-0.363c-0.51-0.399-1.091-0.853-1.379-1.379
   c-0.648-1.181-0.935-2.32-0.925-5.948c0.227-2.439,2.373-13.382,4.289-22.405l18.749,3.976l50.065,10.689
   C744.893,150.363,742.311,161.354,741.46,163.728 M737.367,282.75c0.317,6.785-0.946,42.49-1.935,50.183
   c-0.308,2.403-2.138,9.275-4.477,17.485c-4.879,17.135-11.972,40.103-12.078,40.443l-0.005,0.018
   c-0.091,0.379-9.165,38.073-10.549,54.046c-1.388,16.011-4.666,30.307-5.19,31.224c-0.555,0.32-7.873,2.787-20.798,3.162
   c-7.18,0.207-17.012-0.249-28.645-2.688c0.41-3.319,4.262-34.306,9.332-70.15c2.654-18.76,5.941-40.953,9.337-61.273
   c2.91-17.417,5.898-33.456,8.633-44.78c2.668-11.054,5.793-31.237,9.296-60.051c0.265-2.176,0.532-4.401,0.801-6.675
   c1.339,0.299,2.671,0.621,3.961,0.956c1.557,0.405,2.973,0.766,4.327,1.101c1.156,0.286,2.5,0.616,3.9,0.936
   c0.208,0.047,0.419,0.093,0.629,0.14l0.383,0.086c0.909,0.204,1.847,0.415,2.793,0.514c2.643,0.275,16.572-1.924,17.952-2.84
   c1.274-0.845,2.127-1.807,3.815-5.276l0.015-0.037c3.256-8.676,18.652-85.385,19.33-88.773l0.077-0.384l-0.345-0.077l-28.048-5.947
   c-2.504-0.53-6.37-1.324-10.102-2.09c-2.828-0.58-5.726-1.174-8.024-1.653c0.492-5.343,0.964-10.542,1.413-15.547l14.193-4.94
   c8.195-3.039,28.56-7.782,33.48-8.675l0.241-0.042l0.703-20.683l1.874-0.814c1.025-0.445,1.904-1.07,2.611-1.858
   c0.37-0.41,0.661-0.826,0.867-1.238c0.772-1.544,1.22-8.757,1.239-9.067l0.019-0.406c7.12,1.903,12.352,3.337,13.497,3.651
   l-1.035,36.214c-0.271,8.726-0.528,16.178-0.679,18.396c-0.433,6.395-2.925,27.202-5.694,42.014l-20.509,80.366l-2.385,9.346
   l-0.018-0.004c-0.022,0.091-0.103,0.43-0.229,0.968c-0.001,0.004-0.002,0.009-0.003,0.014l-0.05,0.19l0.005,0.002
   C740.303,262.477,737.088,276.82,737.367,282.75 M793.976,449.342c-8.27-0.312-15.012-0.795-21.735-1.693
   c-8.555-1.143-9.642-3.063-9.74-3.285c-0.005-1.497-0.137-35.245-1.183-49.884c-1.147-16.055-2.97-59.733-1.294-71.469l0.003-0.044
   c0-5.84-2.84-9.667-3.066-9.963c-0.083-0.144-1.629-2.975-2.959-17.602c-1.383-15.219-3.531-27.336-3.553-27.456l-0.002-0.012
   c-0.016-0.072-0.403-1.788-1.666-3.906c-1.141-1.913-3.235-4.509-6.775-6.14l22.531-88.292c0.294,3.237,1.456,10.88,5.646,28.339
   l0.017,0.05c5.212,11.92,9.665,33.018,12.483,48.619c3.01,16.655,4.846,30.75,4.919,31.314c0.014,0.78,0.52,25.493,4.52,53.698
   C796.039,359.246,794.114,443.549,793.976,449.342 M837.201,270.396c-0.01,0.74-0.021,1.507-0.022,2.262
   c-0.004,1.561-0.008,3.123-0.012,4.685c-0.012,3.795-0.028,7.653-0.046,11.466c-0.022,4.583-0.049,9.122-0.079,13.49
   c-0.037,5.126-0.076,9.899-0.124,14.591c-0.054,5.298-0.112,10.129-0.178,14.767c-0.02,1.329-0.038,2.621-0.059,3.881
   c-0.056,3.614-0.116,6.96-0.183,10.141c-0.097,4.753-0.197,8.677-0.314,12.352c-0.09,2.882-0.208,6.294-0.396,9.756l-0.012,0.223
   c-0.107,1.975-0.217,4.018-0.474,6.003c-0.038,0.288-0.086,0.627-0.15,0.96c-2.028,10.476-1.782,30.459-0.972,37.849
   c0.811,7.387-0.989,30.032-1.169,32.253c-1.316,0.619-11.034,4.923-25.736,4.627c-4.661-0.094-8.842-0.198-12.69-0.338
   c0.067-2.751,0.556-23.925,0.601-47.938c0.04-21.542-0.279-49.445-1.935-65.52c-0.161-1.578-0.337-3.043-0.526-4.376
   c-4.037-28.479-4.51-53.391-4.515-53.639l-0.002-0.034c-0.018-0.143-1.865-14.43-4.923-31.358c-0.559-3.091-1.181-6.398-1.861-9.807
   c-2.757-13.819-6.458-29.317-10.654-38.926c-6.296-26.234-5.72-30.134-5.694-30.281l-0.161-0.038l0.162,0.031
   c2.776-14.835,5.272-35.686,5.707-42.096c0.143-2.111,0.383-8.946,0.639-17.11c0.1,0.173,0.201,0.347,0.301,0.519
   c0.729,1.256,1.499,2.596,2.354,4.099c1.175,2.062,2.4,4.239,3.644,6.47c1.553,2.79,3.134,5.665,4.7,8.549
   c1.85,3.407,3.71,6.883,5.528,10.329c2.076,3.937,4.138,7.911,6.126,11.815c2.224,4.364,4.409,8.74,6.493,13.006
   c2.294,4.691,4.525,9.368,6.63,13.899c2.288,4.924,4.487,9.801,6.536,14.499c2.206,5.057,4.296,10.036,6.212,14.802
   c2.048,5.093,3.951,10.075,5.657,14.808c1.326,3.679,2.525,7.176,3.63,10.591c0.427,1.319,0.841,2.627,1.242,3.927
   c1.523,4.936,2.784,9.495,3.857,13.933l0.143,0.593c1.063,4.392,2.163,8.934,2.577,13.415
   C837.263,265.813,837.232,268.144,837.201,270.396"
      />
      <path
        d="M1078.877,243.115c-0.001-0.606-0.206-61.273-3.919-120.842c-1.942-31.146-5.349-49.795-7.866-59.956
   c-1.096-4.422-2.113-7.653-2.946-9.946c-0.149-0.171-0.207-0.462-0.246-0.669c-0.495-1.311-0.912-2.269-1.228-2.936
   c-0.317-0.667-0.532-1.043-0.619-1.188l-1.426-17.748c-0.023-0.082-0.005-0.186-0.006-0.263c0-0.004-0.001-0.008-0.001-0.013v-0.01
   c-0.006-0.084-0.016-0.163-0.035-0.245c-0.007-0.024-0.014-0.047-0.022-0.07c-0.004-0.014-0.009-0.026-0.014-0.04
   c-0.001-0.001,0,0,0-0.001c-0.001,0-0.001,0-0.001-0.001c-0.003-0.007-0.005-0.013-0.009-0.019
   c-0.006-0.013-0.013-0.026-0.021-0.038c-0.003-0.005-0.006-0.01-0.009-0.015h-0.002l-0.173-0.028
   c-0.125-0.02-12.646-2.022-28.915-3.859c-14.502-1.638-34.932-3.463-51.22-3.054c-16.288-0.409-36.719,1.416-51.222,3.054
   c-14.694,1.66-26.329,3.454-28.536,3.8c-0.278,0.206-0.5,0.426-0.67,0.773l0.002-0.002l-1.428,17.779
   c-0.171,0.286-0.835,1.461-1.794,3.985c0,0.015-0.003,0.031-0.011,0.048c-0.031,0.057-0.046,0.12-0.063,0.181
   c-0.019,0.07-0.043,0.137-0.068,0.205c-0.028,0.067-0.053,0.137-0.08,0.206c-0.014,0.034-0.032,0.067-0.053,0.097
   c-0.837,2.299-1.864,5.55-2.971,10.017c-2.517,10.161-5.924,28.81-7.865,59.956c-0.579,9.283-1.107,19.159-1.572,29.354
   c-0.032,0.721-0.064,1.44-0.097,2.158c-0.026,0.58-0.05,1.16-0.076,1.739c-0.394,9.052-0.745,18.502-1.044,28.088
   c-0.037,1.222-0.074,2.431-0.109,3.628c-0.023,0.768-0.046,1.532-0.067,2.29c-0.884,30.79-0.954,53.361-0.955,53.58l-1.143,64.658
   v0.014l0.001,0.015c0.035,0.43,3.435,43.011,3.919,48.983c0.483,5.962,0.974,44.815,0.978,45.201
   c-0.004,0.53-0.484,53.171,0.001,61.574c0.489,8.482,1.309,16.226,1.828,17.263c0.079,0.161,0.162,0.326,2.397,0.739
   c1.435,0.266,3.386,0.561,5.641,0.851c3.226,0.415,9.892,1.181,18.296,1.639c12.82,0.701,30.449,0.735,41.627-3.076l0.167-0.057
   l0.033-0.173c0.793-4.062,4.901-39.943,5.564-59.808c0.654-19.623-0.995-68.291-1.471-73.999c-0.462-5.551-1.014-37.483,0.648-45.63
   c1.288-6.308,4.203-27.763,5.769-39.289c0.422-3.106,0.755-5.558,0.928-6.774c0.28-1.955,0.385-5.699,0.519-10.437
   c0.248-8.85,0.589-20.971,2.414-27.733c1.579-5.854,2.733-12.528,3.529-17.556h0.003c0.001-0.021,0.003-0.04,0.005-0.059
   c0.004-0.047,0.009-0.093,0.019-0.138c0-0.003,0.001-0.004,0.001-0.008c0.001-0.011,0.002-0.021,0.003-0.032
   c0.002-0.027,0.005-0.055,0.011-0.082c0.002-0.017,0.006-0.034,0.013-0.051c0.002-0.01,0.006-0.02,0.008-0.03
   c0.001-0.003,0.004-0.011,0.005-0.017c0,0.004-0.001,0.008-0.001,0.013c0.001-0.01,0.004-0.019,0.006-0.028l-0.003-0.013
   c0.16-1.024,0.306-1.975,0.437-2.829c0.323-2.109,0.557-3.634,0.698-4.15c0.107-0.396,0.166-1.703,0.278-4.386
   c0.185-4.448,0.465-11.167,1.282-17.13c0.958-7.001,2.388-10.946,4.247-11.73h0.045c1.858,0.784,3.287,4.729,4.247,11.73
   c0.816,5.963,1.096,12.682,1.28,17.13c0.113,2.683,0.171,3.99,0.278,4.386c0.141,0.516,0.374,2.041,0.698,4.15
   c0.04,0.26,0.081,0.53,0.124,0.805c-0.012,0.235-0.019,0.37-0.02,0.39l0.08,0.003c0.074,0.477,0.151,0.974,0.231,1.492
   c0.002,0.004,0.005,0.008,0.007,0.013c0.058,0.196,0.079,0.423,0.088,0.642c0.003,0.002,0.007,0.003,0.01,0.003
   c0.795,5.019,1.946,11.657,3.518,17.482c1.824,6.762,2.165,18.883,2.413,27.733c0.132,4.738,0.238,8.482,0.518,10.437
   c0.173,1.216,0.506,3.668,0.928,6.774c1.566,11.526,4.482,32.981,5.769,39.289c1.663,8.147,1.111,40.079,0.648,45.63
   c-0.476,5.708-2.124,54.376-1.47,73.999c0.662,19.865,4.77,55.746,5.563,59.808l0.033,0.173l0.168,0.057
   c7.776,2.652,18.671,3.441,28.898,3.441c4.476,0,8.826-0.152,12.729-0.365c8.405-0.458,15.07-1.224,18.296-1.639
   c2.254-0.29,4.204-0.585,5.639-0.851c2.236-0.413,2.319-0.578,2.399-0.739c0.517-1.037,1.338-8.781,1.828-17.263
   c0.484-8.403,0.005-61.044,0-61.568c0.005-0.392,0.496-39.245,0.979-45.207c0.484-5.972,3.884-48.553,3.918-48.983l0.001-0.015
   L1078.877,243.115z M1078.267,243.121l0.256,14.441c-11.324-1.736-23.566-4.512-24.256-4.669
   c-0.802-0.364-18.091-8.229-21.573-12.484c-0.432-0.529-0.782-3.3,1.732-15.921c1.548-7.772,3.974-18.282,7.211-31.24
   c3.5-14.017,7.211-27.927,9.469-36.267c-0.209,1.111-0.424,2.273-0.636,3.441c-2.116,11.692-1.807,12.533-1.706,12.809
   c0.629,1.715,7.254,8.272,13.148,11.529c3.507,1.94,10.229,2.587,15.337,2.787C1078.187,219.397,1078.266,242.744,1078.267,243.121
    M1077.231,186.937c-5.036-0.2-11.63-0.834-15.024-2.71c-5.674-3.137-12.282-9.603-12.871-11.206
   c-0.42-1.147,2.055-14.644,3.856-23.614l22.738,2.523C1076.485,164.193,1076.909,176.052,1077.231,186.937 M1057.113,29.21
   c0.04,0.005,0.081,0.012,0.122,0.019c0.037,0.005,0.073,0.01,0.11,0.016c0.036,0.005,0.072,0.01,0.107,0.016
   c0.164,0.024,0.321,0.048,0.472,0.071c0.04,0.006,0.08,0.012,0.121,0.018c0.059,0.008,0.117,0.018,0.175,0.027
   c0.039,0.005,0.078,0.012,0.115,0.017c0.039,0.005,0.077,0.012,0.115,0.017c0.036,0.007,0.074,0.012,0.109,0.017
   c0.017,0.004,0.032,0.006,0.048,0.008c0.054,0.008,0.109,0.017,0.162,0.024c0.013,0.003,0.027,0.005,0.04,0.007
   c0.054,0.009,0.106,0.016,0.157,0.024c0.073,0.011,0.143,0.022,0.21,0.033c0.029,0.004,0.057,0.009,0.084,0.013
   c0.054,0.007,0.107,0.016,0.157,0.024c0.025,0.004,0.05,0.007,0.074,0.012c0.069,0.011,0.132,0.02,0.191,0.03
   c0.022,0.003,0.042,0.006,0.062,0.009c0.101,0.015,0.187,0.029,0.257,0.04l1.423,17.709l-3.73-0.1l-0.706-18.071
   C1057.03,29.197,1057.072,29.204,1057.113,29.21 M1042.518,27.184c0.202,0.025,0.401,0.051,0.599,0.077
   c0.043,0.005,0.086,0.011,0.13,0.017c0.034,0.004,0.07,0.009,0.104,0.013c0.03,0.004,0.061,0.008,0.092,0.012
   c0.063,0.009,0.125,0.017,0.188,0.025c0.026,0.003,0.051,0.006,0.077,0.009c0.098,0.013,0.196,0.026,0.293,0.039h0.003
   c0.006,0.001,0.011,0.001,0.016,0.002c0.051,0.007,0.101,0.014,0.152,0.02c0.004,0,0.009,0.001,0.013,0.001
   c0.035,0.005,0.071,0.01,0.106,0.015c0.097,0.012,0.193,0.025,0.288,0.037c0.12,0.016,0.24,0.031,0.359,0.048
   c0.021,0.003,0.044,0.005,0.065,0.008c0.05,0.007,0.099,0.013,0.149,0.019c0.04,0.007,0.08,0.011,0.12,0.017
   c0.054,0.007,0.108,0.015,0.161,0.021c0.036,0.005,0.072,0.01,0.107,0.014c0.152,0.021,0.304,0.041,0.453,0.06
   c0.092,0.013,0.185,0.025,0.276,0.037c0.195,0.027,0.388,0.053,0.58,0.078c0.17,0.023,0.338,0.046,0.506,0.068
   c0.001,0,0.003,0.001,0.004,0.001c0.169,0.023,0.337,0.046,0.503,0.068c0.007,0.001,0.016,0.002,0.023,0.004
   c0.075,0.01,0.15,0.02,0.225,0.03c0.012,0.002,0.025,0.004,0.036,0.005c0.071,0.01,0.14,0.019,0.21,0.029
   c0.016,0.002,0.033,0.004,0.05,0.006c0.172,0.023,0.342,0.047,0.512,0.07c0.085,0.012,0.169,0.024,0.251,0.035
   c0.051,0.007,0.1,0.014,0.151,0.021c0.033,0.005,0.067,0.009,0.1,0.013c0.045,0.006,0.092,0.013,0.137,0.02
   c0.156,0.021,0.311,0.043,0.465,0.064c0.126,0.017,0.251,0.035,0.375,0.052c0.028,0.004,0.054,0.008,0.083,0.012
   c0.053,0.007,0.104,0.015,0.156,0.021c0.022,0.004,0.046,0.007,0.068,0.011c0.037,0.005,0.075,0.01,0.111,0.015
   c0.019,0.002,0.038,0.005,0.056,0.007c0.019,0.003,0.039,0.006,0.057,0.009c0.06,0.007,0.119,0.016,0.177,0.023
   c0.015,0.004,0.029,0.006,0.044,0.007c0.139,0.021,0.279,0.04,0.416,0.058c0.227,0.034,0.451,0.065,0.67,0.096
   c0.073,0.011,0.147,0.021,0.218,0.031c0.021,0.003,0.041,0.006,0.062,0.009c0.003,0,0.005,0.001,0.009,0.001
   c0.055,0.007,0.112,0.016,0.167,0.024c0.026,0.002,0.052,0.007,0.078,0.01c0.022,0.005,0.044,0.008,0.066,0.01
   c0.067,0.01,0.134,0.019,0.2,0.029c0.091,0.013,0.179,0.026,0.268,0.037c0.068,0.011,0.136,0.021,0.204,0.031
   c0.09,0.012,0.178,0.026,0.266,0.038c0.078,0.011,0.153,0.022,0.228,0.033c0.102,0.015,0.201,0.03,0.301,0.044
   c0.064,0.01,0.128,0.018,0.191,0.028c0.016,0.002,0.032,0.004,0.048,0.006c0.093,0.014,0.183,0.027,0.274,0.04
   c0.026,0.005,0.052,0.008,0.077,0.012c0.01,0.001,0.018,0.003,0.028,0.004c0.044,0.007,0.089,0.013,0.133,0.018
   c0.008,0.003,0.018,0.004,0.027,0.005c0.052,0.007,0.102,0.015,0.153,0.022c0.119,0.018,0.237,0.035,0.352,0.052
   c0.058,0.009,0.115,0.017,0.172,0.026c0.057,0.007,0.113,0.016,0.169,0.025c0.056,0.008,0.112,0.016,0.167,0.024
   c0.053,0.008,0.107,0.016,0.161,0.024c0.007,0.001,0.014,0.002,0.02,0.003c0.03,0.004,0.058,0.009,0.087,0.013
   c0.004,0.001,0.009,0.001,0.013,0.002l0.709,18.146l0.024,0.611l0.351,8.963c0.01,0.269-0.09,0.522-0.279,0.713
   c-0.189,0.191-0.441,0.289-0.711,0.282l-13.255-0.427c-0.309-0.01-0.559-0.261-0.567-0.572l-0.227-9.353l-0.013-0.61l-0.479-19.744
   C1042.125,27.134,1042.323,27.159,1042.518,27.184 M1031.348,25.834c0.588,0.065,1.17,0.132,1.746,0.198
   c0.232,0.027,0.461,0.053,0.69,0.081c0.115,0.013,0.229,0.026,0.343,0.04c0.228,0.026,0.456,0.053,0.682,0.079
   c0.227,0.027,0.452,0.054,0.676,0.081c0.112,0.013,0.224,0.027,0.336,0.04c0.112,0.013,0.224,0.027,0.335,0.04
   c0.222,0.026,0.444,0.054,0.665,0.081c1.549,0.187,3.05,0.373,4.494,0.556l0.481,19.805l-43.672-1.169l5.552-22.304
   C1013.575,23.973,1023.361,24.932,1031.348,25.834 M978.492,22.75l0.003,0.085c0.562-0.02,1.131-0.037,1.704-0.051
   c0.572,0.014,1.141,0.031,1.703,0.051l0.003-0.085c6.654-0.104,13.923,0.14,21.151,0.575l-6.807,27.349
   c-0.089,0.362-0.413,0.615-0.785,0.615h-31.619c-0.374,0-0.698-0.254-0.786-0.618l-6.675-27.287
   C963.927,22.913,971.545,22.641,978.492,22.75 M919.513,26.976c0.282-0.036,0.567-0.072,0.855-0.109
   c0.413-0.051,0.829-0.103,1.25-0.155c0.824-0.101,1.662-0.203,2.515-0.305c0.147-0.017,0.296-0.036,0.444-0.054
   c0.223-0.027,0.447-0.054,0.673-0.08c0.339-0.041,0.679-0.08,1.021-0.12c0.912-0.107,1.839-0.213,2.779-0.319
   c7.73-0.873,17.145-1.799,26.715-2.411l5.442,22.248l-42.175,1.146L919.513,26.976z M904.471,29.033
   c0.084-0.013,0.17-0.026,0.257-0.038c0.027-0.004,0.055-0.009,0.084-0.013c0.058-0.009,0.116-0.017,0.175-0.026
   c0.136-0.02,0.275-0.041,0.416-0.061c0.056-0.008,0.113-0.016,0.172-0.025c0.046-0.006,0.092-0.014,0.139-0.02
   c0.304-0.044,0.617-0.09,0.941-0.137c0.413-0.059,0.842-0.12,1.288-0.184c0.072-0.01,0.146-0.022,0.218-0.031
   c0.105-0.015,0.211-0.03,0.319-0.045c0.19-0.027,0.385-0.055,0.581-0.083c0.536-0.076,1.093-0.153,1.668-0.232
   c0.411-0.057,0.832-0.115,1.263-0.174c0.185-0.025,0.373-0.05,0.561-0.076c0.149-0.02,0.3-0.041,0.453-0.061
   c0.011-0.001,0.024-0.004,0.036-0.006c0.179-0.023,0.357-0.047,0.539-0.072c0.09-0.012,0.181-0.023,0.272-0.037
   c0.224-0.029,0.449-0.06,0.677-0.09c0.05-0.006,0.102-0.013,0.152-0.02c0.234-0.031,0.47-0.061,0.706-0.094
   c0.238-0.031,0.477-0.062,0.719-0.094c0.096-0.012,0.193-0.025,0.29-0.038c0.195-0.025,0.39-0.051,0.588-0.077
   c0.59-0.077,1.193-0.154,1.805-0.232c0.037-0.004,0.074-0.009,0.111-0.014l-0.479,19.78l-0.015,0.611l-0.227,9.371
   c-0.008,0.311-0.256,0.562-0.566,0.572l-13.255,0.427c-0.27,0.008-0.522-0.091-0.711-0.282c-0.191-0.191-0.289-0.444-0.279-0.713
   l0.341-8.976l0.023-0.611l0.692-18.193C904.44,29.037,904.455,29.035,904.471,29.033 M900.397,29.652
   c0.028-0.004,0.058-0.009,0.092-0.014c0.053-0.009,0.115-0.018,0.183-0.029c0.021-0.003,0.044-0.006,0.066-0.011
   c0.047-0.007,0.095-0.014,0.147-0.022c0.05-0.008,0.104-0.016,0.161-0.025c0.09-0.014,0.188-0.029,0.291-0.045
   c0.091-0.014,0.186-0.029,0.286-0.044c0.073-0.011,0.147-0.023,0.223-0.035c0.07-0.01,0.141-0.021,0.215-0.033
   c0.192-0.029,0.397-0.06,0.616-0.093c0.043-0.007,0.088-0.013,0.132-0.02c0.072-0.011,0.146-0.023,0.222-0.033
   c0.047-0.008,0.094-0.014,0.143-0.022c0.051-0.007,0.105-0.016,0.159-0.023c0.048-0.008,0.097-0.015,0.146-0.023
   c0.109-0.016,0.22-0.032,0.332-0.05l-0.689,18.119l-4.148,0.112L900.397,29.652z M883.262,183.631
   c0.297-9.584,0.648-19.031,1.043-28.08c0.024-0.579,0.05-1.159,0.076-1.739c0.028-0.631,0.056-1.264,0.085-1.896l22.612-2.509
   c1.801,8.97,4.276,22.467,3.856,23.614c-0.589,1.603-7.197,8.069-12.871,11.206c-3.367,1.861-9.882,2.5-14.903,2.705
   C883.194,185.84,883.227,184.741,883.262,183.631 M882.13,243.117c0.001-0.225,0.071-22.788,0.954-53.57
   c0.019-0.664,0.038-1.333,0.059-2.004c5.094-0.206,11.736-0.859,15.215-2.783c5.893-3.257,12.519-9.814,13.148-11.529
   c0.101-0.276,0.41-1.117-1.706-12.809c-0.212-1.168-0.427-2.33-0.636-3.441c2.258,8.34,5.968,22.25,9.47,36.266
   c3.235,12.959,5.662,23.469,7.21,31.24c2.514,12.622,2.164,15.393,1.732,15.922c-3.481,4.255-20.771,12.12-21.573,12.484
   c-0.688,0.156-12.841,2.913-24.128,4.649L882.13,243.117z M979.812,158.34c-2.034,0.994-3.504,4.975-4.487,12.152
   c-0.821,5.992-1.101,12.729-1.287,17.187c-0.09,2.182-0.162,3.906-0.256,4.252c-0.108,0.396-0.254,1.264-0.455,2.542
   c-0.409-8.515-1.526-32.638-1.182-35.835c0.228-2.122,1.908-3.532,2.889-4.185c1.599-1.064,3.522-1.588,4.778-1.322V158.34z
    M979.812,152.511c-1.421-0.245-3.416,0.303-5.116,1.434c-1.847,1.228-2.968,2.872-3.158,4.627
   c-0.421,3.921,1.254,37.468,1.326,38.894h0.003c-0.076,0.495-0.157,1.015-0.242,1.554c-7.064,1.658-15.238-1.026-24.311-7.99
   c-7.836-6.012-13.354-12.539-16.4-19.395c-3.737-8.41-10.957-29.574,2.657-44.438c9.473-10.34,21.386-15.516,29.712-18.038
   c7.716-2.336,13.858-2.887,15.529-3V152.511z M979.812,105.548c-1.645,0.109-7.869,0.656-15.687,3.023
   c-5.347,1.617-10.387,3.756-14.978,6.357c-5.743,3.254-10.799,7.244-15.026,11.858c-5.314,5.802-8.03,13.188-8.072,21.951
   c-0.043,9.159,2.863,17.642,5.308,23.145c3.087,6.951,8.668,13.556,16.586,19.633c4.113,3.157,8.084,5.472,11.8,6.879
   c4.537,1.717,8.832,2.146,12.78,1.275c-0.793,4.984-1.93,11.514-3.477,17.244c-1.843,6.831-2.185,18.994-2.434,27.875
   c-0.127,4.531-0.238,8.446-0.512,10.367c-0.173,1.218-0.507,3.671-0.93,6.777c-1.565,11.52-4.478,32.962-5.761,39.249
   c-1.672,8.193-1.122,40.237-0.658,45.803c0.475,5.704,2.122,54.323,1.468,73.929c-0.653,19.582-4.656,54.735-5.519,59.537
   c-10.966,3.679-28.145,3.675-40.657,3.02c-14.234-0.747-25.442-2.498-26.419-2.98c-0.424-1.06-1.23-8.153-1.739-16.969
   c-0.484-8.384-0.004-61.005,0-61.542c-0.004-0.392-0.495-39.266-0.98-45.248c-0.481-5.931-3.838-47.973-3.918-48.968l0.877-49.602
   c11.612-1.781,24.177-4.652,24.304-4.681l0.03-0.006l0.027-0.013c0.742-0.334,18.186-8.222,21.822-12.666
   c0.575-0.703,1.035-3.17-1.605-16.428c-1.55-7.78-3.978-18.301-7.217-31.268c-5.514-22.076-11.548-43.889-11.609-44.107l-0.07-0.25
   l-23.052,2.558c0.459-10.067,0.982-19.818,1.555-28.989c1.272-20.425,3.176-35.46,5.042-46.242c0.709-0.06,2.96-0.247,6.53-0.504
   l1.207,14.677c0.086,1.041,1,1.877,2.128,1.946l57.828,3.502c0.052,0.003,0.102,0.005,0.152,0.005c1.201,0,2.208-0.865,2.278-1.99
   l1.299-20.926c5.469-0.091,11.255-0.152,17.299-0.17V105.548z M906.916,77.593h0.036l45.624-1.657
   c0.718-0.026,1.28-0.655,1.28-1.433v-1.55c2.595-0.061,5.279-0.117,8.044-0.164l-1.295,20.878c-0.051,0.837-0.853,1.47-1.784,1.415
   l-57.828-3.503c-0.827-0.051-1.496-0.646-1.558-1.388l-1.205-14.67c2.082-0.148,4.577-0.318,7.443-0.499l0.155,1.522
   C905.889,77.139,906.363,77.593,906.916,77.593 M906.314,74.981c9.805-0.615,23.77-1.351,40.413-1.839
   c2.091-0.062,4.256-0.12,6.487-0.174v1.535c0,0.424-0.297,0.779-0.661,0.792l-45.624,1.656c-0.23,0.008-0.435-0.199-0.463-0.472
   L906.314,74.981z M946.705,72.532c-30.731,0.901-52.335,2.65-55.506,2.916c0.933-5.311,1.854-9.564,2.677-12.9
   c2.43-9.831,4.516-13.817,4.944-14.572l4.279-0.117l-0.339,8.937c-0.017,0.434,0.149,0.859,0.456,1.165
   c0.293,0.296,0.696,0.463,1.113,0.463h0.049l13.255-0.428c0.634-0.02,1.141-0.533,1.156-1.165l0.228-9.404l42.339-1.149l1.11,4.538
   c0.156,0.637,0.723,1.082,1.379,1.082h31.619c0.653,0,1.22-0.442,1.378-1.076l1.132-4.55l43.835,1.174l0.228,9.385
   c0.016,0.632,0.523,1.145,1.157,1.165l13.255,0.428h0.049c0.416,0,0.82-0.167,1.114-0.463c0.305-0.306,0.472-0.731,0.456-1.166
   l-0.349-8.923l3.858,0.104c0.428,0.754,2.515,4.739,4.945,14.572c0.824,3.336,1.743,7.588,2.676,12.9
   c-20.263-1.774-42.203-2.88-65.22-3.284C985.445,71.837,966.175,71.961,946.705,72.532 M1007.564,75.909l45.623,1.656h0.037
   c0.553,0,1.026-0.453,1.087-1.049l0.164-1.595l-0.337-0.035c2.786,0.191,5.58,0.397,8.376,0.618l-1.209,14.687
   c-0.061,0.742-0.73,1.337-1.556,1.388l-57.828,3.503c-0.933,0.057-1.733-0.578-1.785-1.415l-1.301-20.961
   c2.456,0.032,4.939,0.072,7.449,0.122v1.649C1006.284,75.253,1006.846,75.883,1007.564,75.909 M1006.926,74.477V72.84
   c14.977,0.305,30.835,0.928,46.909,2.025l-0.163,1.585c-0.028,0.274-0.232,0.482-0.462,0.472l-45.623-1.655
   C1007.222,75.254,1006.926,74.899,1006.926,74.477 M986.996,194.007c-0.162-1.024-0.286-1.731-0.38-2.076
   c-0.095-0.346-0.166-2.07-0.258-4.252c-0.185-4.458-0.466-11.195-1.286-17.187c-1.009-7.367-2.53-11.365-4.65-12.223v-5.121
   c1.254-0.302,3.217,0.221,4.845,1.305c0.982,0.653,2.662,2.063,2.89,4.185C988.495,161.779,987.423,185.112,986.996,194.007
    M987.461,197.015c0.212-4.271,1.703-34.719,1.303-38.443c-0.189-1.755-1.311-3.399-3.159-4.627
   c-1.727-1.149-3.758-1.698-5.183-1.423v-46.354c1.834,0.13,7.869,0.709,15.406,2.991c8.326,2.522,20.24,7.698,29.712,18.038
   c13.614,14.864,6.393,36.028,2.658,44.438c-3.047,6.856-8.565,13.383-16.401,19.395c-8.945,6.867-17.018,9.573-24.014,8.056
   C987.667,198.356,987.561,197.663,987.461,197.015 M1075.493,356.731c-0.485,5.982-0.976,44.856-0.981,45.255
   c0.005,0.53,0.484,53.151,0.001,61.535c-0.509,8.816-1.314,15.909-1.741,16.969c-0.976,0.482-12.184,2.233-26.418,2.98
   c-12.512,0.655-29.691,0.659-40.657-3.02c-0.864-4.802-4.866-39.955-5.519-59.537c-0.653-19.606,0.994-68.225,1.469-73.929
   c0.464-5.566,1.013-37.61-0.658-45.803c-1.283-6.287-4.197-27.729-5.763-39.249c-0.421-3.106-0.754-5.559-0.929-6.777
   c-0.274-1.921-0.384-5.836-0.512-10.367c-0.25-8.881-0.59-21.044-2.434-27.875c-1.54-5.706-2.674-12.206-3.466-17.182
   c1.232,0.25,2.495,0.376,3.791,0.376c2.77,0,5.678-0.572,8.692-1.713c3.717-1.407,7.686-3.722,11.801-6.879
   c7.917-6.077,13.497-12.682,16.586-19.633c2.445-5.503,5.35-13.986,5.306-23.145c-0.042-8.763-2.758-16.149-8.072-21.951
   c-4.226-4.614-9.282-8.604-15.025-11.858c-4.591-2.601-9.631-4.74-14.977-6.357c-7.635-2.311-13.749-2.887-15.565-3.014V72.608
   c5.723-0.014,11.673,0.013,17.802,0.089l1.303,21.008c0.07,1.125,1.077,1.99,2.278,1.99c0.051,0,0.102-0.002,0.152-0.005
   l57.828-3.502c1.128-0.069,2.043-0.905,2.128-1.946l1.208-14.691c2.061,0.165,4.123,0.337,6.185,0.517
   c1.867,10.783,3.77,25.818,5.043,46.243c0.607,9.727,1.119,19.483,1.553,29.003l-23.179-2.572l-0.069,0.25
   c-0.06,0.218-6.095,22.031-11.609,44.107c-3.239,12.967-5.667,23.488-7.217,31.268c-2.64,13.258-2.181,15.725-1.605,16.428
   c3.636,4.444,21.081,12.332,21.822,12.666l0.028,0.013l0.028,0.006c0.127,0.029,12.785,2.922,24.433,4.7l0.876,49.583
   C1079.331,308.758,1075.974,350.8,1075.493,356.731"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M427.754,66.374c-1.812,0.149-11.889,0.915-17.502,0.021c-0.041-1.343-0.239-7.907-0.455-15.002
   c-0.006-0.204-0.012-0.407-0.018-0.61c-0.254-8.411-0.526-17.377-0.58-19.173l18.013,0.378l0.292,18.524l0.009,0.61L427.754,66.374z
   "
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M344.697,31.585c-0.055,1.834-0.337,11.147-0.597,19.711c-0.006,0.204-0.011,0.407-0.017,0.61
   c-0.209,6.887-0.4,13.155-0.44,14.464c-5.612,0.894-15.688,0.129-17.501-0.02l0.234-14.773l0.009-0.61l0.299-19.003L344.697,31.585z
   "
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M326.025,78.093l-3.102,28.92c-7.772,0.728-25.131,6.691-38.579,11.666v-0.001
   c0.472-7.086,1.126-14.577,2.027-22.253C301.314,88.942,322.571,79.603,326.025,78.093"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M469.458,118.678c-13.447-4.975-30.807-10.937-38.577-11.665l-3.103-28.92
   c3.454,1.51,24.71,10.847,39.653,18.331C468.331,104.1,468.986,111.592,469.458,118.678"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M325.161,150.074c-2.136,8.902-5.562,22.197-6.428,23.062c-1.208,1.209-9.926,4.302-16.397,4.763
   c-6.161,0.44-18.559-5.505-19.641-6.032c0.238-10.626,0.457-20.59,0.631-29.389c0.04-2.038,0.095-4.161,0.165-6.358L325.161,150.074
   z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M471.108,171.889c-0.646,0.314-3.808,1.822-7.591,3.252c-3.783,1.43-8.189,2.782-11.324,2.782
   c-0.233,0-0.462-0.008-0.682-0.024c-6.471-0.461-15.187-3.554-16.396-4.763c-0.865-0.865-4.291-14.16-6.428-23.062l41.626-13.939
   c0.069,2.191,0.124,4.311,0.164,6.343C470.65,151.282,470.869,161.255,471.108,171.889"
      />
      <path
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        d="M393.691,355.218c-0.01-0.23-0.018-0.462-0.026-0.699C393.674,354.756,393.683,354.988,393.691,355.218"
      />
      <path
        fill={patchColor}
        onClick={() => handleClick("patch")}
        onMouseEnter={() => setPatchActive(true)}
        onMouseLeave={() => setPatchActive(false)}
        style={
          patchActive && !preview ? {fill: adjust(patchColor, 55)} : {fill: patchColor}
        }
        d="M12.218,271.459c0.01,0.74,0.021,1.507,0.022,2.263c0.004,1.56,0.008,3.122,0.013,4.684
   c0.011,3.795,0.027,7.653,0.045,11.466c0.022,4.584,0.049,9.122,0.079,13.49c0.037,5.126,0.077,9.899,0.124,14.591
   c0.054,5.298,0.112,10.129,0.178,14.767c0.02,1.33,0.038,2.622,0.059,3.882c21.52,1.496,40.17,0.554,43.43,0.367
   c0.161-1.578,0.337-3.043,0.526-4.376c4.037-28.479,4.51-53.391,4.515-53.639l0.002-0.034c0.018-0.143,1.865-14.43,4.923-31.358
   c0.559-3.091,1.181-6.397,1.861-9.807c-2.81-0.051-25.302-0.587-47.81-5.034c-0.427,1.319-0.841,2.627-1.242,3.927
   c-1.523,4.937-2.784,9.495-3.857,13.933l-0.143,0.594c-1.063,4.392-2.163,8.933-2.577,13.415
   C12.156,266.877,12.187,269.207,12.218,271.459"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M98.258,81.824l0.675,19.873c5.325,0.998,25.244,5.654,33.335,8.655l13.928,4.847
   c-0.393-4.383-0.768-8.615-1.121-12.666l-12.146-5.023c-1.366-0.566-2.749-1.191-4.108-1.858
   C119.649,91.149,101.337,83.163,98.258,81.824"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M175.363,26.119c0.02,0.05,0.033,0.103,0.043,0.156c0.038,0.209,0.076,0.418,0.115,0.624l1.341,0.003
   c0.484-0.048,0.93,0.288,1.019,0.772c3.202,17.585,8.311,27.73,8.363,27.831l0.006,0.011c0.04,0.089,0.368,0.905-0.651,2.209
   c0.144,0.273,0.285,0.547,0.426,0.82c0.844-0.603,1.184-1.093,1.188-1.097l0.014-0.019c0.801-1.006,0.616-1.591,0.607-1.619
   c-0.19-0.381-5.879-11.916-9.061-29.387c-0.013-0.075-0.049-0.271-0.402-0.271l-1.759-0.005h-0.011
   C176.592,26.147,176.035,26.126,175.363,26.119"
      />
      <path
        fill="#C6C6C6"
        d="M165.62,84.665l0.298,1.203c0.02,0.081,0.071,0.15,0.142,0.193c0.073,0.043,0.158,0.055,0.239,0.035
   c3.605-0.919,21.619-5.471,27.989-6.336c-0.17-0.515-0.342-1.031-0.519-1.545C191.829,78.598,178.852,81.19,165.62,84.665"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M102.459,141.91c2.066,9.517,4.648,20.508,5.5,22.881c1.558,3.345,2.317,4.263,3.432,5.059
   c1.087,0.776,14.223,3.367,16.888,3.139c0.876-0.075,1.763-0.265,2.621-0.445l0.369-0.078c1.556-0.325,3.071-0.678,4.346-0.98
   c1.3-0.307,2.66-0.639,4.16-1.01c1.357-0.337,2.755-0.656,4.161-0.948c1.032-0.215,2.063-0.426,3.093-0.635
   c1.812-0.369,3.682-0.749,5.514-1.149c0.584-0.128,1.188-0.253,1.771-0.372c2.304-0.478,4.684-0.97,6.841-1.819
   c2.273-0.893,4.416-2.561,6.488-4.174c0.508-0.395,0.988-0.768,1.473-1.133c1.028-0.774,2.377-1.804,3.69-2.905
   c0.14-0.12,0.293-0.239,0.452-0.364c0.511-0.399,1.092-0.853,1.38-1.379c0.647-1.18,0.934-2.319,0.924-5.947
   c-0.227-2.439-2.374-13.383-4.29-22.406l-18.749,3.977L102.459,141.91z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M96.882,47.588c0.039,1.555,0.263,10.489,0.458,18.245c0.005,0.21,0.011,0.418,0.015,0.626
   c0.133,5.29,0.251,9.912,0.28,11.077c4.142,0.144,11.893-1.744,13.341-2.108l-0.364-12.429l-0.018-0.622l-0.546-18.619
   L96.882,47.588z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M145.446,33.332c0.203,1.783,1.43,12.576,2.383,20.957c0.023,0.203,0.046,0.405,0.068,0.605
   c0.518,4.55,0.943,8.283,1.057,9.289c4.601-0.003,13.092-2.213,14.654-2.63l-0.735-7.054l-0.064-0.609L160.2,28.834L145.446,33.332z
   "
      />
      <path
        fill={patchColor}
        onClick={() => handleClick("patch")}
        onMouseEnter={() => setPatchActive(true)}
        onMouseLeave={() => setPatchActive(false)}
        style={
          patchActive && !preview ? {fill: adjust(patchColor, 55)} : {fill: patchColor}
        }
        d="M105.447,248.785l2.385,9.346l0.017-0.005c0.023,0.092,0.104,0.43,0.23,0.969
   c0.001,0.004,0.002,0.008,0.003,0.013l0.049,0.191l-0.004,0.002c0.988,4.239,4.204,18.583,3.925,24.513
   c-0.317,6.784,0.946,42.49,1.934,50.182c0.309,2.403,2.139,9.275,4.478,17.486c26.963,0.174,55.359-4.653,58.595-5.218
   c-2.909-17.417-5.897-33.457-8.632-44.781c-2.668-11.053-5.793-31.237-9.297-60.051
   C156.498,242.035,130.364,247.891,105.447,248.785"
      />
      <path
        fill={patchColor}
        onClick={() => handleClick("patch")}
        onMouseEnter={() => setPatchActive(true)}
        onMouseLeave={() => setPatchActive(false)}
        style={
          patchActive && !preview ? {fill: adjust(patchColor, 55)} : {fill: patchColor}
        }
        d="M472.808,323.197c-0.007,0.031-0.013,0.063-0.019,0.097c-0.006,0.033-0.012,0.068-0.018,0.103
   c-0.038,0.225-0.075,0.495-0.11,0.807c-0.006,0.04-0.01,0.082-0.015,0.125c-0.004,0.044-0.008,0.087-0.014,0.131
   c-0.005,0.052-0.011,0.106-0.015,0.161c-0.008,0.07-0.015,0.142-0.021,0.216c-0.009,0.088-0.017,0.178-0.023,0.27
   c-0.013,0.138-0.025,0.282-0.036,0.432c-0.008,0.104-0.016,0.212-0.024,0.323c-0.028,0.384-0.054,0.802-0.08,1.249
   c-0.007,0.128-0.015,0.258-0.021,0.391c0,0.004,0,0.008-0.001,0.013c-0.004,0.082-0.009,0.166-0.013,0.25
   c-0.004,0.084-0.009,0.17-0.013,0.256c-0.006,0.101-0.01,0.206-0.015,0.311c-0.006,0.14-0.014,0.283-0.019,0.428
   c-0.002,0.021-0.003,0.042-0.004,0.062c-0.005,0.127-0.011,0.257-0.017,0.387c-0.006,0.159-0.013,0.321-0.02,0.484
   c-0.006,0.149-0.012,0.299-0.018,0.453c-0.001,0.04-0.003,0.079-0.004,0.119c-0.006,0.162-0.013,0.327-0.018,0.495
   c-0.022,0.624-0.043,1.279-0.064,1.964c-0.002,0.092-0.006,0.183-0.008,0.276c-0.009,0.292-0.016,0.589-0.025,0.891
   c-0.003,0.12-0.007,0.239-0.01,0.36c-0.009,0.361-0.018,0.73-0.028,1.106c-0.002,0.124-0.005,0.25-0.009,0.377
   c-0.003,0.127-0.005,0.254-0.007,0.382c-0.004,0.128-0.007,0.257-0.009,0.386c-0.008,0.328-0.014,0.659-0.022,0.996
   c-0.002,0.108-0.005,0.216-0.007,0.324c-0.007,0.359-0.013,0.723-0.021,1.093c-0.003,0.186-0.006,0.375-0.01,0.565
   c-0.002,0.113-0.004,0.226-0.006,0.34c-0.004,0.185-0.007,0.371-0.009,0.559v0.011c-0.007,0.384-0.013,0.772-0.02,1.166
   c-0.006,0.303-0.01,0.61-0.014,0.919c-0.01,0.71-0.021,1.434-0.031,2.172c-0.003,0.155-0.005,0.311-0.007,0.467
   c-0.003,0.225-0.006,0.451-0.009,0.679l-0.002,0.268c-0.005,0.317-0.009,0.637-0.012,0.96c-0.004,0.282-0.007,0.565-0.01,0.85
   c-0.002,0.204-0.006,0.41-0.008,0.617c-0.009,0.739-0.015,1.489-0.023,2.251c-0.002,0.154-0.003,0.309-0.004,0.465
   c0,0.049-0.002,0.1-0.002,0.149c-0.001,0.052-0.001,0.103-0.002,0.155c-0.002,0.267-0.005,0.535-0.008,0.805
   c-0.001,0.085-0.002,0.17-0.002,0.255c-0.002,0.219-0.004,0.439-0.006,0.66c-0.002,0.191-0.004,0.382-0.005,0.573
   c-0.002,0.223-0.004,0.447-0.006,0.672c-0.004,0.469-0.008,0.942-0.013,1.417c-0.002,0.253-0.004,0.508-0.006,0.763
   c-0.002,0.291-0.005,0.582-0.007,0.874c-0.003,0.439-0.006,0.879-0.01,1.323c-0.004,0.592-0.009,1.187-0.013,1.786
   c-4.105,0.687-42.8,6.821-77.898,0.292c-0.001-0.011-0.001-0.023-0.002-0.034c0-0.012-0.002-0.024-0.002-0.036
   c-0.001-0.016-0.001-0.032-0.001-0.048v-0.004c-0.004-0.112-0.009-0.228-0.014-0.345c-0.003-0.068-0.006-0.137-0.009-0.205
   c-0.011-0.278-0.022-0.566-0.034-0.867c-0.009-0.227-0.019-0.46-0.028-0.699c-0.011-0.285-0.023-0.579-0.035-0.883
   c-0.006-0.158-0.012-0.317-0.019-0.481c-0.003-0.08-0.006-0.162-0.01-0.245c-0.016-0.413-0.032-0.841-0.049-1.283
   c-0.007-0.163-0.013-0.328-0.019-0.495c-0.001-0.028-0.002-0.057-0.004-0.085c-0.008-0.23-0.017-0.462-0.027-0.699
   c-0.008-0.237-0.018-0.478-0.028-0.721c-0.004-0.104-0.008-0.208-0.012-0.313c-0.021-0.56-0.044-1.139-0.066-1.734
   c-0.013-0.335-0.026-0.677-0.039-1.023c-0.013-0.358-0.026-0.721-0.041-1.092c-0.006-0.178-0.014-0.359-0.021-0.541
   c-0.006-0.204-0.014-0.411-0.023-0.618c-0.008-0.208-0.015-0.419-0.022-0.631c-0.014-0.373-0.029-0.751-0.042-1.134
   c-0.005-0.128-0.01-0.256-0.014-0.386c-0.003-0.047-0.005-0.094-0.006-0.143c-0.007-0.209-0.016-0.423-0.023-0.635
   c-0.008-0.205-0.015-0.41-0.023-0.618c-0.002-0.058-0.005-0.116-0.007-0.174c-0.007-0.205-0.014-0.413-0.022-0.622
   c-0.008-0.194-0.014-0.39-0.022-0.587c-0.008-0.197-0.013-0.395-0.021-0.595c0-0.011-0.001-0.022-0.001-0.032
   c-0.002-0.065-0.004-0.129-0.007-0.194c-0.014-0.38-0.027-0.762-0.042-1.149c-0.014-0.386-0.027-0.776-0.042-1.17
   c-0.007-0.213-0.015-0.427-0.022-0.642c-0.015-0.431-0.031-0.865-0.046-1.303c-0.008-0.22-0.015-0.44-0.023-0.661
   c-0.008-0.224-0.016-0.45-0.023-0.677c-0.017-0.448-0.031-0.899-0.048-1.354c-0.008-0.22-0.015-0.44-0.023-0.661
   c-0.008-0.238-0.016-0.475-0.024-0.714c-0.008-0.22-0.016-0.441-0.022-0.664c0-0.009,0-0.017-0.002-0.027
   c-0.007-0.233-0.016-0.467-0.024-0.703c-0.018-0.533-0.036-1.069-0.054-1.608c-0.013-0.403-0.028-0.807-0.041-1.214
   c-0.016-0.488-0.033-0.98-0.048-1.475c-0.017-0.486-0.033-0.974-0.049-1.466c-0.012-0.385-0.025-0.772-0.038-1.162
   c-0.022-0.657-0.042-1.318-0.064-1.984c-0.013-0.447-0.028-0.894-0.043-1.344c-0.015-0.522-0.032-1.045-0.049-1.572
   c-0.01-0.374-0.022-0.749-0.035-1.125c-0.007-0.232-0.014-0.464-0.021-0.695c-0.007-0.233-0.014-0.466-0.022-0.699
   c-0.002-0.058-0.003-0.116-0.005-0.174c-0.019-0.631-0.039-1.265-0.056-1.901c-0.063-2.083-0.125-4.194-0.185-6.32
   c-0.011-0.355-0.02-0.708-0.03-1.063c-0.014-0.514-0.028-1.028-0.043-1.545c-0.015-0.553-0.03-1.107-0.045-1.662
   c-0.014-0.518-0.028-1.038-0.042-1.558c-0.005-0.196-0.011-0.392-0.015-0.589c-0.019-0.716-0.038-1.433-0.056-2.15
   c-0.027-1.051-0.053-2.102-0.078-3.153c-0.068-2.736-0.13-5.47-0.188-8.185c-0.007-0.34-0.014-0.679-0.021-1.018
   c-0.015-0.736-0.031-1.469-0.044-2.202c-0.007-0.284-0.012-0.568-0.018-0.852c-0.002-0.088-0.003-0.177-0.004-0.265l-0.014-0.746
   v-0.003c-0.01-0.48-0.019-0.958-0.028-1.436c-0.004-0.272-0.01-0.543-0.013-0.814c-0.004-0.185-0.007-0.369-0.01-0.553
   c-0.007-0.349-0.012-0.697-0.019-1.045c-0.01-0.589-0.019-1.176-0.029-1.761c-0.004-0.267-0.007-0.531-0.012-0.797
   c-0.01-0.698-0.021-1.392-0.031-2.083c-0.004-0.339-0.008-0.678-0.014-1.017c-0.007-0.531-0.013-1.06-0.02-1.586
   c-0.003-0.27-0.007-0.539-0.01-0.808c0-0.055-0.001-0.11-0.001-0.166c-0.002-0.152-0.003-0.303-0.005-0.455
   c-0.005-0.322-0.008-0.641-0.011-0.96c-0.002-0.123-0.002-0.247-0.003-0.371c-0.002-0.198-0.004-0.396-0.006-0.593
   c-0.003-0.182-0.004-0.364-0.006-0.546v-0.044c-0.001-0.148-0.003-0.297-0.004-0.444c-0.003-0.163-0.004-0.325-0.005-0.488
   c-0.001-0.095-0.002-0.19-0.002-0.285c-0.001-0.067-0.001-0.133-0.002-0.2c-0.002-0.258-0.005-0.515-0.007-0.771
   c-0.001-0.092-0.001-0.182-0.002-0.273c-0.001-0.294-0.003-0.585-0.005-0.876c-0.002-0.333-0.004-0.666-0.005-0.997
   c-0.002-0.298-0.003-0.596-0.005-0.892c-0.006-1.205-0.009-2.389-0.01-3.548c34.541,6.375,76.145,0.848,81.711,0.056
   c0.011,0.658,0.022,1.313,0.033,1.965c0.037,2.229,0.073,4.425,0.106,6.584c0.003,0.233,0.007,0.464,0.01,0.696
   c0.014,0.926,0.029,1.846,0.041,2.757c0.006,0.456,0.013,0.91,0.02,1.362c0.003,0.226,0.006,0.452,0.01,0.676
   c0.006,0.556,0.014,1.107,0.022,1.655c0.004,0.303,0.008,0.606,0.012,0.907c0.004,0.301,0.009,0.601,0.012,0.9
   c0.001,0.178,0.003,0.356,0.005,0.535c0.004,0.218,0.006,0.436,0.009,0.654c0,0.05,0.001,0.101,0.003,0.152
   c0.001,0.148,0.003,0.295,0.005,0.442c0.004,0.444,0.011,0.885,0.015,1.323v0.029c0.005,0.428,0.01,0.855,0.015,1.279
   c0.004,0.315,0.008,0.629,0.011,0.941c0,0.017,0,0.034,0.001,0.051c0.002,0.244,0.004,0.487,0.008,0.729
   c0.002,0.284,0.005,0.568,0.008,0.851c0.003,0.151,0.003,0.302,0.004,0.453c0.004,0.411,0.009,0.821,0.012,1.228
   c0,0.04,0.001,0.078,0.001,0.118c0.002,0.204,0.005,0.408,0.006,0.61c0.001,0.034,0.001,0.069,0.001,0.102
   c0.003,0.277,0.005,0.551,0.007,0.825c0.003,0.151,0.004,0.303,0.004,0.455c0.002,0.141,0.003,0.283,0.004,0.425
   c0.002,0.32,0.006,0.637,0.007,0.954c0.001,0.198,0.003,0.396,0.004,0.593c0.001,0.134,0.002,0.267,0.004,0.399
   c0.002,0.263,0.003,0.523,0.005,0.782c0.001,0.181,0.002,0.362,0.003,0.541c0.001,0.18,0.003,0.359,0.004,0.537
   c0.003,0.553,0.006,1.1,0.01,1.64c0.001,0.254,0.002,0.505,0.003,0.756c0.001,0.251,0.002,0.5,0.003,0.749
   c0.001,0.202,0.001,0.403,0.002,0.603c0,0.045,0,0.091,0.002,0.136c0,0.246,0.001,0.49,0.001,0.733c0,0.136,0.001,0.272,0.001,0.408
   c0,0.226,0.001,0.451,0.001,0.674C473.481,312.127,473.3,320.732,472.808,323.197"
      />
      <path
        fill={patchColor}
        onClick={() => handleClick("patch")}
        onMouseEnter={() => setPatchActive(true)}
        onMouseLeave={() => setPatchActive(false)}
        style={
          patchActive && !preview ? {fill: adjust(patchColor, 55)} : {fill: patchColor}
        }
        d="M362.493,261.485c-0.024,33.079-2.044,85.446-2.609,99.479c-35.094,6.518-73.802,0.359-77.897-0.328
   c-0.139-19.187-0.35-34.231-0.992-37.439c-0.91-4.553-0.756-30.053-0.213-61.723C284.796,262.066,327.177,268.024,362.493,261.485"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="98.29"
        y1="84.361"
        x2="97.875"
        y2="84.17"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="97.042"
        y1="83.786"
        x2="97.041"
        y2="83.786"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.918,0.917"
        d="M97.041,83.785
   l-1.448-0.667c-0.928-0.363-3.449-1.918-4.142-2.688c-0.311-0.345-0.713-0.74-0.928-1.17c-0.651-1.304-1.303-8.329-1.467-10.195"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M89.056,69.065
   c-0.025-0.29-0.039-0.455-0.039-0.455"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M90.469,68.449
   c0.012,0.151,0.025,0.303,0.039,0.456"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.877,0.876"
        d="M90.59,69.777
   c0.379,3.855,1.032,8,1.38,8.767c0.073,0.146,0.321,0.415,0.502,0.611c0.061,0.067,0.121,0.132,0.178,0.195
   c0.483,0.536,2.758,1.963,3.529,2.264l0.038,0.015l0.037,0.016l1.432,0.609"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="97.686"
        y1="82.254"
        x2="98.107"
        y2="82.433"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="145.531"
        y1="104.945"
        x2="145.105"
        y2="104.777"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="144.268"
        y1="104.444"
        x2="144.267"
        y2="104.444"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.903,0.902"
        d="
   M144.267,104.444l-13.065-5.18c-2.67-1.393-5.933-3.019-9.818-4.84c-4.596-2.154-16.251-7.308-20.014-8.979"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M101.37,85.445
   c-0.153-0.068-0.292-0.13-0.418-0.186l-0.003,0.457"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="100.942"
        y1="86.656"
        x2="100.942"
        y2="86.657"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.941,0.94"
        x1="100.942"
        y1="86.658"
        x2="100.843"
        y2="99.832"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M100.843,99.832l-0.003,0.458
   c0.139,0.025,0.289,0.053,0.449,0.083"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="102.183"
        y1="100.546"
        x2="102.184"
        y2="100.546"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.913,0.912"
        d="
   M102.184,100.546c6.396,1.261,22.733,4.935,29.814,7.59l13.957,5.062"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="145.956"
        y1="113.199"
        x2="146.386"
        y2="113.355"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="145.531"
        y1="103.727"
        x2="145.111"
        y2="103.545"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="144.277"
        y1="103.183"
        x2="144.276"
        y2="103.183"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.911,0.91"
        d="M144.276,103.183
   l-13.274-5.751c-2.363-1.214-5.297-2.657-8.935-4.36c-6.045-2.831-19.085-8.574-22.603-10.121"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M99.464,82.95
   c-0.159-0.07-0.299-0.132-0.418-0.184l0.012,0.457"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="99.083"
        y1="84.153"
        x2="99.083"
        y2="84.154"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.931,0.93"
        x1="99.083"
        y1="84.154"
        x2="99.536"
        y2="100.908"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M99.536,100.908l0.012,0.457
   c0.14,0.018,0.292,0.039,0.453,0.063"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="100.894"
        y1="101.574"
        x2="100.895"
        y2="101.574"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.906,0.905"
        d="
   M100.895,101.574c6.552,1.144,23.792,5.505,31.225,8.275c0,0,9.951,3.346,13.976,4.871"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M146.096,114.721
   c0.151,0.057,0.294,0.112,0.427,0.164"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="77.227"
        y1="54.841"
        x2="77.796"
        y2="54.644"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="78.831"
        y1="54.286"
        x2="78.832"
        y2="54.286"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.096,1.095"
        x1="78.832"
        y1="54.286"
        x2="85.049"
        y2="52.134"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        points="85.049,52.134 85.618,51.937 
   85.629,52.539 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="85.65"
        y1="53.662"
        x2="85.65"
        y2="53.663"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.124,1.123"
        x1="85.65"
        y1="53.662"
        x2="85.898"
        y2="67.148"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        points="85.898,67.148 85.909,67.75 
   85.33,67.916 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="84.256"
        y1="68.223"
        x2="84.255"
        y2="68.223"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.118,1.117"
        x1="84.255"
        y1="68.223"
        x2="77.806"
        y2="70.07"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="77.806"
        y1="70.07"
        x2="77.227"
        y2="70.236"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        x1="85.909"
        y1="67.749"
        x2="77.227"
        y2="62.777"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        x1="85.618"
        y1="51.937"
        x2="77.227"
        y2="61.726"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        x1="86.621"
        y1="51.526"
        x2="96.61"
        y2="48.574"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        x1="87.002"
        y1="67.527"
        x2="97.017"
        y2="64.784"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        d="M110.884,61.63
   c0,0,26.719-7.862,33.897-8.295l2.367-0.107"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        d="M110.383,44.512
   c0,0,28.174-7.18,32.899-9.128l2.014-0.69"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M148.404,88.429
   c0.188-0.067,0.378-0.133,0.568-0.2"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.235,1.233"
        d="M150.138,87.829
   c15.92-5.391,39.093-10.083,43.069-10.872"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M193.207,76.957
   c0.386-0.077,0.591-0.116,0.591-0.116"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M148.118,86.139
   c0.188-0.067,0.377-0.134,0.568-0.2"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.218,1.217"
        d="M149.837,85.542
   c15.793-5.36,38.568-9.87,42.509-10.632"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M192.347,74.91
   c0.386-0.075,0.591-0.113,0.591-0.113"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M149.045,131.499
   c-0.019-0.2-0.036-0.4-0.055-0.6"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="148.883"
        y1="129.713"
        x2="148.883"
        y2="129.712"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.192,1.191"
        d="
   M148.883,129.712c-3.254-35.823-5.926-68.82-6.312-73.625"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M142.571,56.086
   c-0.032-0.395-0.048-0.6-0.048-0.6l0.05,0.6"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="142.672"
        y1="57.272"
        x2="142.672"
        y2="57.273"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.19,1.189"
        x1="142.672"
        y1="57.273"
        x2="145.453"
        y2="90.483"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="145.453"
        y1="90.483"
        x2="145.503"
        y2="91.083"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M197.154,477.999c0,0-0.025-0.204-0.074-0.597"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="196.93"
        y1="476.203"
        x2="196.93"
        y2="476.202"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.209,1.208"
        d="M196.93,476.202
   c-1.96-15.731-16.443-130.516-27.121-174.732c-3.702-15.334-6.155-31.713-10.066-66.579"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M159.743,234.89
   c-0.022-0.199-0.045-0.398-0.067-0.598"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M150.314,131.255
   c-0.018-0.2-0.036-0.4-0.055-0.6"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="150.152"
        y1="129.474"
        x2="150.152"
        y2="129.473"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.188,1.187"
        d="
   M150.152,129.472c-3.241-35.708-5.904-68.589-6.29-73.386"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M143.862,56.086
   c-0.032-0.395-0.049-0.6-0.049-0.6l0.051,0.6"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="143.963"
        y1="57.272"
        x2="143.963"
        y2="57.273"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.19,1.189"
        x1="143.963"
        y1="57.273"
        x2="146.744"
        y2="90.483"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="146.744"
        y1="90.483"
        x2="146.794"
        y2="91.083"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M198.444,477.999c0,0-0.024-0.204-0.073-0.597"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="198.221"
        y1="476.202"
        x2="198.221"
        y2="476.202"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.21,1.209"
        d="M198.221,476.201
   c-1.961-15.734-16.444-130.516-27.121-174.731c-3.708-15.357-6.168-31.805-10.083-66.734"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M161.017,234.735
   c-0.022-0.199-0.045-0.398-0.067-0.598"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M151.491,131.188
   c-0.019-0.2-0.037-0.4-0.055-0.6"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="151.329"
        y1="129.407"
        x2="151.329"
        y2="129.406"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.187,1.186"
        d="
   M151.329,129.406c-3.238-35.676-5.898-68.526-6.285-73.32"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M145.044,56.086
   c-0.031-0.395-0.048-0.6-0.048-0.6l0.051,0.6"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="145.146"
        y1="57.272"
        x2="145.146"
        y2="57.273"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.19,1.189"
        x1="145.146"
        y1="57.273"
        x2="147.927"
        y2="90.483"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="147.927"
        y1="90.483"
        x2="147.978"
        y2="91.083"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M199.627,477.999c0,0-0.025-0.204-0.073-0.597"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="199.405"
        y1="476.213"
        x2="199.405"
        y2="476.212"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.199,1.198"
        d="
   M199.405,476.212c-1.955-15.691-16.442-130.517-27.122-174.742c-3.714-15.379-6.18-31.89-10.1-66.878"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M162.184,234.591
   c-0.022-0.199-0.045-0.398-0.067-0.599"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M85.527,171.776
   c-0.007,0.171-0.018,0.371-0.034,0.601"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="85.384"
        y1="173.576"
        x2="85.384"
        y2="173.577"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.205,1.204"
        d="M85.384,173.577
   c-0.377,3.517-1.63,11.234-5.574,27.667c-10.112,23.128-17.426,80.032-17.426,80.032s-0.431,24.849-4.519,53.677
   c-3.654,25.772-2.253,99.832-1.915,115.251"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M55.95,450.204
   c0.005,0.212,0.009,0.412,0.013,0.602"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M86.603,175.926
   c-0.027,0.191-0.057,0.39-0.088,0.595"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="86.329"
        y1="177.713"
        x2="86.329"
        y2="177.714"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.208,1.207"
        d="M86.328,177.714
   c-0.727,4.479-2.171,11.795-5.013,23.637c-10.112,23.128-17.426,80.032-17.426,80.032s-0.431,24.849-4.519,53.677
   c-3.643,25.693-2.261,99.378-1.917,115.107"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M57.453,450.168
   c0.004,0.211,0.009,0.412,0.013,0.602"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M87.333,178.68
   c-0.033,0.193-0.067,0.391-0.103,0.593"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="87.019"
        y1="180.459"
        x2="87.019"
        y2="180.46"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.206,1.205"
        d="M87.019,180.46
   c-0.829,4.551-2.215,11.179-4.521,20.784c-10.111,23.128-17.426,80.032-17.426,80.032s-0.43,24.849-4.518,53.677
   c-3.645,25.712-2.259,99.491-1.917,115.143"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M58.637,450.097
   c0.004,0.211,0.009,0.412,0.013,0.601"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        d="M162.853,52.152
   c0,0,16.117-0.019,20.375,1.55"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        d="M160.701,30.638
   c0,0,8.896-2.345,14.668-2.894"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M98.34,77.732c0,0.001-0.005-0.211-0.016-0.601"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="98.293"
        y1="75.955"
        x2="98.293"
        y2="75.955"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.177,1.176"
        d="M98.293,75.955
   c-0.155-5.896-0.648-24.634-0.743-28.235"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M97.55,47.719
   c-0.01-0.389-0.016-0.602-0.016-0.602"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M100.614,77.379
   c0,0.001-0.006-0.211-0.018-0.602"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="100.562"
        y1="75.589"
        x2="100.562"
        y2="75.588"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.19,1.189"
        d="M100.562,75.588
   c-0.173-5.957-0.724-24.933-0.83-28.559"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M99.732,47.029
   c-0.011-0.389-0.017-0.602-0.017-0.602"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="109.265"
        y1="43.756"
        x2="109.282"
        y2="44.358"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="109.317"
        y1="45.594"
        x2="109.317"
        y2="45.595"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.238,1.237"
        x1="109.317"
        y1="45.596"
        x2="110.148"
        y2="75.296"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="110.148"
        y1="75.295"
        x2="110.166"
        y2="75.897"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="106.863"
        y1="44.512"
        x2="106.878"
        y2="45.114"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="106.909"
        y1="46.335"
        x2="106.909"
        y2="46.336"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.223,1.222"
        x1="106.909"
        y1="46.336"
        x2="107.647"
        y2="75.683"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="107.648"
        y1="75.684"
        x2="107.663"
        y2="76.286"
      />
      <path
        d="M98.421,47.694l-0.278,0.621l-0.03-0.528c-0.002-0.029-0.022-0.052-0.049-0.057c-0.028-0.005-0.056,0.009-0.067,0.035
   l-0.279,0.62l-0.029-0.527c-0.002-0.028-0.022-0.052-0.05-0.057s-0.055,0.01-0.067,0.035l-0.278,0.621l-0.03-0.528
   c-0.001-0.028-0.022-0.051-0.05-0.057c-0.027-0.005-0.055,0.009-0.066,0.035l-0.381,0.849l0.111,0.051l0.278-0.621l0.03,0.528
   c0.002,0.028,0.022,0.051,0.049,0.056c0.028,0.005,0.056-0.009,0.067-0.034l0.279-0.621l0.029,0.528
   c0.002,0.028,0.022,0.051,0.05,0.056s0.055-0.009,0.067-0.035l0.278-0.62l0.03,0.527c0.001,0.029,0.022,0.052,0.05,0.057
   c0.006,0.002,0.014,0.002,0.021,0c0.019-0.003,0.037-0.016,0.045-0.035l0.381-0.849L98.421,47.694z"
      />
      <path
        d="M99.067,75.877l-0.279,0.621l-0.029-0.528c-0.002-0.029-0.022-0.051-0.05-0.057c-0.027-0.005-0.055,0.009-0.066,0.035
   l-0.279,0.621l-0.029-0.528c-0.002-0.028-0.022-0.052-0.05-0.057s-0.055,0.01-0.067,0.035L97.94,76.64l-0.03-0.528
   c-0.001-0.028-0.022-0.051-0.05-0.056c-0.027-0.006-0.055,0.009-0.066,0.034l-0.381,0.85l0.111,0.05l0.278-0.621l0.03,0.528
   c0.001,0.028,0.022,0.051,0.049,0.057c0.028,0.005,0.056-0.01,0.067-0.035l0.279-0.621l0.029,0.528
   c0.001,0.028,0.022,0.051,0.05,0.056s0.055-0.009,0.067-0.034l0.278-0.621l0.029,0.528c0.002,0.028,0.023,0.051,0.05,0.056
   c0.007,0.002,0.015,0.002,0.022,0.001c0.019-0.004,0.037-0.017,0.045-0.036l0.381-0.849L99.067,75.877z"
      />
      <path
        d="M101.218,75.554l-0.279,0.621l-0.029-0.528c-0.002-0.028-0.022-0.051-0.05-0.057c-0.027-0.005-0.055,0.009-0.066,0.035
   l-0.279,0.621l-0.029-0.528c-0.002-0.028-0.022-0.051-0.05-0.057c-0.028-0.004-0.055,0.01-0.067,0.036l-0.278,0.62l-0.03-0.528
   c-0.001-0.028-0.022-0.051-0.05-0.056c-0.027-0.006-0.055,0.009-0.066,0.034l-0.381,0.85l0.111,0.05l0.278-0.621l0.03,0.528
   c0.001,0.028,0.022,0.051,0.049,0.057c0.028,0.005,0.056-0.01,0.067-0.035l0.279-0.621l0.029,0.528
   c0.002,0.028,0.022,0.051,0.05,0.056s0.055-0.009,0.067-0.034l0.278-0.621l0.03,0.528c0.001,0.028,0.022,0.051,0.049,0.056
   c0.007,0.002,0.015,0.002,0.022,0.001c0.019-0.004,0.037-0.017,0.045-0.036l0.381-0.849L101.218,75.554z"
      />
      <path
        d="M108.425,74.478l-0.278,0.621l-0.03-0.528c-0.002-0.029-0.022-0.051-0.049-0.057c-0.028-0.005-0.056,0.009-0.068,0.035
   l-0.278,0.621l-0.029-0.528c-0.001-0.028-0.022-0.052-0.05-0.057c-0.028-0.004-0.055,0.01-0.067,0.036l-0.278,0.62l-0.029-0.528
   c-0.002-0.028-0.023-0.051-0.05-0.056c-0.028-0.006-0.056,0.009-0.067,0.034l-0.381,0.85l0.111,0.05l0.278-0.621l0.03,0.528
   c0.002,0.028,0.022,0.051,0.049,0.057c0.028,0.005,0.056-0.01,0.068-0.035l0.278-0.621l0.029,0.528
   c0.001,0.028,0.022,0.051,0.05,0.056s0.055-0.009,0.067-0.034l0.278-0.621l0.029,0.528c0.002,0.028,0.023,0.051,0.05,0.056
   c0.008,0.002,0.015,0.002,0.022,0.001c0.019-0.004,0.037-0.017,0.045-0.036l0.381-0.849L108.425,74.478z"
      />
      <path
        d="M110.791,74.048l-0.278,0.621l-0.03-0.528c-0.001-0.029-0.021-0.051-0.049-0.057c-0.028-0.005-0.055,0.009-0.067,0.035
   l-0.278,0.621l-0.029-0.528c-0.002-0.028-0.023-0.052-0.05-0.057c-0.029-0.005-0.056,0.01-0.068,0.035l-0.278,0.621l-0.029-0.528
   c-0.002-0.028-0.023-0.051-0.05-0.057c-0.027-0.005-0.055,0.01-0.066,0.035l-0.382,0.849l0.111,0.051l0.279-0.621l0.03,0.528
   c0.001,0.028,0.021,0.051,0.049,0.057c0.028,0.005,0.055-0.01,0.067-0.035l0.278-0.621l0.029,0.528
   c0.002,0.028,0.023,0.051,0.05,0.056c0.028,0.005,0.056-0.009,0.067-0.035l0.279-0.62l0.029,0.527
   c0.001,0.029,0.022,0.052,0.05,0.057c0.007,0.002,0.014,0.002,0.021,0.001c0.02-0.004,0.037-0.017,0.045-0.036l0.381-0.849
   L110.791,74.048z"
      />
      <path
        d="M100.465,47.048l-0.279,0.621l-0.029-0.528c-0.002-0.029-0.022-0.052-0.05-0.057c-0.027-0.005-0.055,0.009-0.066,0.035
   l-0.279,0.621l-0.029-0.528c-0.002-0.028-0.022-0.052-0.05-0.057s-0.055,0.01-0.067,0.035l-0.278,0.621l-0.03-0.528
   c-0.001-0.028-0.022-0.051-0.05-0.057c-0.027-0.005-0.055,0.01-0.066,0.035l-0.381,0.849l0.111,0.051L99.2,47.54l0.03,0.528
   c0.001,0.028,0.022,0.051,0.049,0.057c0.028,0.005,0.056-0.01,0.067-0.035l0.279-0.621l0.029,0.528
   c0.001,0.028,0.022,0.051,0.05,0.056s0.055-0.009,0.067-0.035l0.278-0.62l0.029,0.527c0.002,0.029,0.023,0.052,0.05,0.057
   c0.007,0.002,0.015,0.002,0.022,0.001c0.019-0.004,0.036-0.017,0.045-0.036l0.381-0.849L100.465,47.048z"
      />
      <path
        d="M107.565,45.22l-0.278,0.621l-0.03-0.528c-0.002-0.029-0.022-0.052-0.049-0.057c-0.029-0.005-0.056,0.009-0.068,0.035
   l-0.278,0.62l-0.029-0.527c-0.002-0.028-0.023-0.052-0.05-0.057c-0.028-0.005-0.055,0.01-0.067,0.035l-0.278,0.621l-0.03-0.528
   c-0.001-0.028-0.022-0.051-0.049-0.057c-0.028-0.005-0.056,0.009-0.067,0.035l-0.381,0.849l0.111,0.051l0.278-0.621l0.03,0.528
   c0.002,0.028,0.022,0.051,0.049,0.057c0.028,0.004,0.055-0.01,0.067-0.035l0.279-0.621l0.029,0.528
   c0.001,0.028,0.022,0.051,0.05,0.056s0.055-0.009,0.067-0.035l0.278-0.62l0.029,0.527c0.002,0.029,0.023,0.052,0.05,0.057
   c0.007,0.002,0.015,0.002,0.022,0c0.019-0.003,0.037-0.016,0.045-0.035l0.381-0.849L107.565,45.22z"
      />
      <path
        d="M109.931,44.467l-0.278,0.621l-0.03-0.528c-0.002-0.029-0.022-0.052-0.049-0.057c-0.028-0.005-0.056,0.009-0.067,0.035
   l-0.279,0.62l-0.029-0.527c-0.001-0.028-0.022-0.052-0.05-0.057s-0.055,0.01-0.067,0.035l-0.278,0.621l-0.029-0.528
   c-0.002-0.028-0.023-0.051-0.05-0.057c-0.028-0.005-0.056,0.009-0.067,0.035l-0.381,0.849l0.111,0.051l0.278-0.621l0.03,0.528
   c0.002,0.028,0.022,0.051,0.049,0.056c0.029,0.005,0.056-0.009,0.068-0.034l0.278-0.621l0.029,0.528
   c0.002,0.028,0.023,0.051,0.05,0.056c0.028,0.005,0.055-0.009,0.067-0.035l0.278-0.62l0.03,0.527
   c0.001,0.029,0.022,0.052,0.049,0.057c0.008,0.002,0.015,0.002,0.022,0c0.019-0.003,0.037-0.016,0.045-0.035l0.381-0.849
   L109.931,44.467z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M149.779,64.35c0,0.001-0.024-0.209-0.068-0.598
   "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="149.572"
        y1="62.54"
        x2="149.572"
        y2="62.539"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.221,1.22"
        d="M149.572,62.54
   c-0.69-6.061-2.902-25.459-3.32-29.119"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M146.251,33.42
   c-0.044-0.387-0.068-0.598-0.068-0.598"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M152.268,63.909
   c0,0.001-0.023-0.209-0.068-0.598"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="152.059"
        y1="62.085"
        x2="152.059"
        y2="62.084"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.236,1.235"
        d="M152.059,62.084
   c-0.703-6.126-2.958-25.778-3.381-29.463"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M148.678,32.62
   c-0.044-0.387-0.068-0.598-0.068-0.598"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="159.265"
        y1="28.89"
        x2="159.327"
        y2="29.489"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="159.45"
        y1="30.672"
        x2="159.45"
        y2="30.673"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.19,1.189"
        x1="159.45"
        y1="30.673"
        x2="162.647"
        y2="61.459"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="162.648"
        y1="61.458"
        x2="162.71"
        y2="62.057"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="156.592"
        y1="29.766"
        x2="156.654"
        y2="30.366"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="156.775"
        y1="31.534"
        x2="156.775"
        y2="31.535"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.176,1.175"
        x1="156.775"
        y1="31.535"
        x2="159.916"
        y2="61.943"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="159.915"
        y1="61.943"
        x2="159.977"
        y2="62.542"
      />
      <path
        d="M147.129,33.29l-0.205,0.649l-0.09-0.521c-0.005-0.028-0.028-0.049-0.057-0.051c-0.027-0.002-0.053,0.016-0.062,0.043
   l-0.205,0.648l-0.09-0.521c-0.005-0.027-0.027-0.048-0.056-0.05c-0.028-0.002-0.053,0.015-0.062,0.042l-0.205,0.649l-0.09-0.521
   c-0.005-0.028-0.028-0.049-0.056-0.051c-0.028-0.002-0.053,0.016-0.062,0.043l-0.281,0.887l0.116,0.037l0.206-0.649l0.089,0.521
   c0.005,0.028,0.028,0.049,0.056,0.051c0.028,0.002,0.054-0.016,0.063-0.042l0.205-0.649l0.09,0.521
   c0.005,0.028,0.027,0.048,0.055,0.05c0.029,0.002,0.054-0.015,0.063-0.042l0.205-0.648l0.09,0.521
   c0.005,0.027,0.028,0.048,0.055,0.05c0.008,0,0.015,0,0.022-0.002c0.019-0.006,0.035-0.021,0.041-0.04l0.281-0.888L147.129,33.29z"
      />
      <path
        d="M149.28,32.645l-0.205,0.648l-0.09-0.521c-0.005-0.027-0.028-0.048-0.057-0.05c-0.027-0.002-0.053,0.015-0.061,0.042
   l-0.206,0.649l-0.09-0.521c-0.005-0.028-0.027-0.049-0.056-0.051c-0.028-0.002-0.053,0.016-0.062,0.043l-0.205,0.648l-0.09-0.521
   c-0.005-0.028-0.028-0.048-0.056-0.05c-0.028-0.002-0.053,0.016-0.062,0.042l-0.281,0.888l0.116,0.037l0.206-0.649l0.09,0.521
   c0.004,0.028,0.027,0.049,0.055,0.051c0.028,0.001,0.054-0.016,0.063-0.043l0.205-0.648l0.09,0.521
   c0.005,0.027,0.027,0.048,0.055,0.05c0.029,0.002,0.054-0.016,0.063-0.043l0.205-0.648l0.09,0.521
   c0.005,0.028,0.028,0.049,0.055,0.051c0.008,0,0.015-0.001,0.022-0.003c0.019-0.005,0.035-0.02,0.041-0.04l0.281-0.887
   L149.28,32.645z"
      />
      <path
        d="M157.348,30.385l-0.205,0.649l-0.09-0.521c-0.005-0.028-0.028-0.049-0.056-0.051c-0.028-0.002-0.053,0.016-0.062,0.043
   l-0.205,0.648l-0.09-0.521c-0.005-0.028-0.028-0.048-0.057-0.05c-0.027-0.002-0.053,0.015-0.061,0.042l-0.206,0.649l-0.09-0.521
   c-0.005-0.028-0.027-0.049-0.056-0.051c-0.028-0.002-0.053,0.016-0.062,0.042l-0.281,0.888l0.117,0.037l0.205-0.649l0.09,0.521
   c0.005,0.028,0.027,0.049,0.055,0.051c0.029,0.002,0.054-0.016,0.063-0.042l0.205-0.649l0.09,0.521
   c0.005,0.027,0.028,0.048,0.055,0.05c0.029,0.002,0.054-0.015,0.063-0.042l0.206-0.648l0.09,0.521
   c0.004,0.027,0.027,0.048,0.055,0.05c0.007,0,0.015,0,0.021-0.002c0.019-0.006,0.035-0.021,0.042-0.041l0.28-0.887L157.348,30.385z"
      />
      <path
        d="M160.145,29.525l-0.205,0.648l-0.09-0.521c-0.005-0.027-0.028-0.048-0.056-0.05c-0.028-0.002-0.053,0.016-0.062,0.043
   l-0.205,0.648l-0.09-0.521c-0.005-0.028-0.028-0.049-0.057-0.051c-0.027-0.001-0.053,0.016-0.062,0.043l-0.205,0.649l-0.09-0.521
   c-0.005-0.028-0.027-0.049-0.056-0.051c-0.028-0.002-0.053,0.016-0.062,0.042l-0.281,0.888l0.117,0.037l0.205-0.649l0.09,0.521
   c0.005,0.028,0.027,0.049,0.055,0.051c0.029,0.002,0.054-0.016,0.063-0.043l0.205-0.648l0.09,0.521
   c0.005,0.027,0.028,0.048,0.055,0.05c0.029,0.002,0.054-0.016,0.063-0.042l0.205-0.649l0.09,0.521
   c0.005,0.028,0.028,0.049,0.056,0.051c0.007,0,0.014-0.001,0.021-0.003c0.019-0.005,0.035-0.02,0.042-0.04l0.28-0.887
   L160.145,29.525z"
      />
      <path
        d="M150.48,62.557l-0.309,0.606l-0.003-0.529c0-0.028-0.02-0.052-0.047-0.058c-0.028-0.007-0.056,0.006-0.069,0.031
   l-0.308,0.606l-0.003-0.529c-0.001-0.028-0.02-0.052-0.047-0.059c-0.027-0.006-0.056,0.007-0.068,0.032l-0.31,0.606l-0.003-0.528
   c0-0.029-0.02-0.053-0.047-0.059c-0.027-0.007-0.056,0.006-0.068,0.031l-0.423,0.829l0.108,0.056l0.31-0.606l0.003,0.529
   c0,0.028,0.019,0.052,0.047,0.059c0.027,0.006,0.055-0.007,0.068-0.032l0.309-0.606l0.004,0.529c0,0.028,0.019,0.052,0.046,0.058
   c0.028,0.007,0.056-0.006,0.069-0.031l0.308-0.606l0.003,0.528c0,0.029,0.02,0.053,0.047,0.06c0.008,0.001,0.015,0.001,0.022,0
   c0.019-0.001,0.038-0.014,0.047-0.032l0.422-0.83L150.48,62.557z"
      />
      <path
        d="M152.738,62.234l-0.309,0.606l-0.003-0.529c0-0.028-0.02-0.052-0.047-0.058c-0.028-0.007-0.056,0.006-0.069,0.031
   l-0.308,0.606l-0.003-0.529c0-0.028-0.02-0.052-0.047-0.059c-0.027-0.006-0.056,0.007-0.068,0.032l-0.309,0.607l-0.004-0.529
   c0-0.029-0.02-0.053-0.047-0.059c-0.027-0.007-0.056,0.006-0.068,0.031l-0.423,0.83l0.109,0.055l0.309-0.606l0.003,0.529
   c0,0.028,0.019,0.052,0.047,0.059c0.027,0.006,0.055-0.007,0.068-0.032l0.31-0.606l0.003,0.529c0,0.028,0.019,0.052,0.046,0.059
   c0.028,0.006,0.056-0.007,0.069-0.032l0.308-0.606l0.003,0.528c0.001,0.029,0.02,0.053,0.047,0.06c0.008,0.001,0.015,0.001,0.022,0
   c0.019-0.001,0.038-0.014,0.048-0.032l0.421-0.83L152.738,62.234z"
      />
      <path
        d="M160.484,60.836l-0.309,0.606l-0.003-0.528c0-0.029-0.02-0.053-0.047-0.059c-0.028-0.007-0.056,0.006-0.069,0.031
   l-0.308,0.606l-0.003-0.529c0-0.027-0.02-0.052-0.047-0.059c-0.027-0.006-0.056,0.007-0.068,0.032l-0.31,0.607l-0.003-0.529
   c0-0.029-0.02-0.053-0.047-0.059c-0.027-0.007-0.056,0.006-0.068,0.031l-0.423,0.83l0.109,0.055l0.309-0.606l0.003,0.529
   c0,0.028,0.019,0.052,0.047,0.059c0.027,0.006,0.055-0.007,0.068-0.032l0.309-0.606l0.004,0.529c0,0.028,0.019,0.052,0.046,0.059
   c0.028,0.006,0.056-0.007,0.069-0.032l0.308-0.606l0.003,0.528c0.001,0.029,0.02,0.053,0.047,0.06c0.008,0.001,0.015,0.001,0.022,0
   c0.019-0.001,0.038-0.014,0.047-0.032l0.422-0.83L160.484,60.836z"
      />
      <path
        d="M163.28,60.298l-0.309,0.606l-0.003-0.528c0-0.029-0.02-0.053-0.047-0.059c-0.028-0.007-0.056,0.006-0.069,0.031
   l-0.308,0.606l-0.003-0.528c-0.001-0.028-0.02-0.053-0.047-0.059c-0.027-0.007-0.056,0.006-0.068,0.032l-0.31,0.606l-0.003-0.529
   c0-0.028-0.02-0.053-0.047-0.059c-0.027-0.007-0.056,0.006-0.068,0.031l-0.423,0.83l0.109,0.056l0.309-0.607l0.003,0.529
   c0,0.028,0.019,0.052,0.047,0.059c0.027,0.006,0.055-0.007,0.068-0.032l0.309-0.606l0.004,0.529c0,0.028,0.019,0.052,0.046,0.059
   c0.028,0.006,0.056-0.007,0.069-0.032l0.308-0.606l0.003,0.529c0,0.028,0.02,0.052,0.047,0.059c0.008,0.001,0.015,0.002,0.022,0.001
   c0.019-0.002,0.038-0.014,0.047-0.033l0.422-0.829L163.28,60.298z"
      />
      <path
        fill={darkContrast}
        onClick={() => handleClick("contrast")}
        onMouseEnter={() => setDarkContrastActive(true)}
        onMouseLeave={() => setDarkContrastActive(false)}
        style={
          darkContrastActive && !preview
            ? {fill: adjust(darkContrast, 55)}
            : {fill: darkContrast}
        }
        d="M156.598,87.195l2.209,12.747c0.171,0.547,0.757,0.892,1.368,0.802l38.176-5.591
   c-1.008-4.975-2.303-9.907-3.884-14.788c-6.229,0.821-24.409,5.415-28.031,6.338c-0.076,0.019-0.152,0.028-0.229,0.028
   c-0.164,0-0.327-0.044-0.472-0.13c-0.212-0.128-0.363-0.33-0.422-0.571l-0.296-1.194C162.18,85.588,159.338,86.377,156.598,87.195"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.392"
        strokeMiterlimit="10"
        strokeDasharray="1.177,1.177"
        d="M157.054,86.842
   l2.238,12.909c0.109,0.368,0.518,0.597,0.951,0.534l38.309-5.611"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.392"
        strokeMiterlimit="10"
        strokeDasharray="1.177,1.177"
        d="M158.902,86.36
   l1.581,10.686c0.189,0.639,0.802,1.044,1.44,0.95l36.212-5.304"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M143.607,466.76c0,0,0.204,0.041,0.592,0.111"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="145.402"
        y1="467.081"
        x2="145.403"
        y2="467.081"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.223,1.222"
        d="
   M145.403,467.081c6.555,1.096,29.785,4.316,48.526-1.376"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M193.93,465.704
   c0.192-0.058,0.384-0.118,0.575-0.178"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M199.104,464.252c0,0,0.207-0.061,0.576-0.172"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        x1="200.787"
        y1="463.744"
        x2="200.788"
        y2="463.744"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.158,1.157"
        d="
   M200.788,463.744c3.632-1.108,12.131-3.763,15.313-5.302"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        d="M216.101,458.441
   c0.2-0.097,0.379-0.189,0.535-0.276"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        d="M15.415,436.454
   c0,0,18.747,6.872,39.527,4.104"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        d="M59.371,440.049
   c0,0,19.714-1.243,27.929-4.171"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="87.002"
        y1="69.806"
        x2="87.015"
        y2="70.263"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="87.04"
        y1="71.169"
        x2="87.04"
        y2="71.17"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.908,0.907"
        d="M87.04,71.17
   l1.482,53.699c0,0-0.305,11.801-7.891,13.975"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M80.632,138.844
   c-0.145,0.042-0.292,0.08-0.443,0.114"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.355"
        strokeMiterlimit="10"
        strokeDasharray="1.065,1.065"
        d="
   M129.944,169.929c-0.66,0.137-1.358,0.276-2.009,0.331c-2.013,0.17-13.391-2.003-15.437-2.805c-0.447-0.34-0.955-0.896-2.221-3.605
   c-0.685-2.035-2.684-10.36-4.704-19.563l47.574-10.195l16.333-3.477c1.842,8.778,3.424,17.034,3.655,19.115
   c0.004,3.245-0.261,3.8-0.546,4.323c-0.128,0.16-0.523,0.469-0.762,0.656c-0.148,0.115-0.337,0.262-0.522,0.419
   c-1.245,1.045-2.515,2.016-3.594,2.829c-0.472,0.354-0.933,0.712-1.421,1.091l-0.081,0.063c-1.952,1.519-3.968,3.089-5.953,3.868
   c-1.807,0.71-3.819,1.155-5.895,1.587c0,0-1.132,0.233-1.396,0.288c-0.338,0.07-0.677,0.141-1.009,0.214
   c-0.692,0.151-1.437,0.309-2.279,0.484c-1.002,0.208-2.003,0.411-2.987,0.611l-0.226,0.046c-1.034,0.209-2.07,0.42-3.105,0.634
   c-1.445,0.299-2.874,0.625-4.251,0.966c-1.592,0.393-2.909,0.712-4.141,1.002c-1.342,0.316-2.792,0.653-4.297,0.966L129.944,169.929
   z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.355"
        strokeMiterlimit="10"
        strokeDasharray="1.065,1.065"
        d="
   M130.249,171.304c-0.692,0.145-1.428,0.29-2.138,0.351c-2.512,0.214-14.706-2.243-16.124-2.944c-0.758-0.549-1.385-1.19-2.866-4.364
   c-0.803-2.31-3.142-12.253-5.101-21.218l48.819-10.442l17.543-3.728c1.796,8.518,3.729,18.386,3.971,20.758
   c0.007,3.519-0.291,4.328-0.745,5.156c-0.164,0.299-0.682,0.704-1.061,1c-0.183,0.142-0.337,0.263-0.491,0.395
   c-1.259,1.057-2.546,2.041-3.638,2.864c-0.466,0.35-0.923,0.705-1.406,1.08l-0.081,0.063c-2.012,1.566-4.091,3.184-6.221,4.021
   c-1.883,0.74-3.94,1.197-6.063,1.639c0,0-1.131,0.234-1.395,0.289c-0.334,0.07-0.67,0.141-0.999,0.212
   c-0.692,0.152-1.441,0.31-2.285,0.486c-1.002,0.209-2.003,0.412-2.988,0.612l-0.229,0.047c-1.032,0.209-2.065,0.42-3.099,0.634
   c-1.429,0.297-2.843,0.62-4.206,0.958c-1.596,0.395-2.915,0.714-4.15,1.006c-1.349,0.318-2.806,0.657-4.323,0.973l-0.431,0.091
   L130.249,171.304z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.355"
        strokeMiterlimit="10"
        strokeDasharray="1.065,1.065"
        d="
   M176.144,152.157c5.889,25.518,12.65,56.291,13.172,61.508c-0.015,3.17-0.274,3.974-0.669,4.691
   c-1.159,1.311-11.091,8.696-13.325,9.563c-0.413,0.158-0.863,0.288-1.407,0.441c-0.814,0.231-4.431,1.08-6.172,1.489
   c-1.016,0.239-1.764,0.415-2.125,0.504c-1.21,0.295-2.488,0.595-4.016,0.944l-0.558,0.127c-0.943,0.213-1.924,0.434-2.925,0.655
   c-0.249,0.055-0.499,0.111-0.748,0.167c-1.215,0.276-2.438,0.572-3.635,0.882c-1.54,0.398-2.949,0.756-4.311,1.093
   c-1.139,0.282-2.494,0.613-3.896,0.931c-0.195,0.045-0.391,0.088-0.587,0.132l-0.387,0.086c-0.85,0.19-1.724,0.386-2.537,0.47
   c-2.422,0.25-14.814-1.853-16.464-2.511c-0.684-0.469-1.28-1.083-2.689-3.972c-1.902-5.272-9.035-38.558-13.787-61.641"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.177"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        points="
   167.542,128.895 168.526,130.004 168.141,128.767 169.125,129.876 168.74,128.64 169.724,129.748 169.339,128.512 170.321,129.62 
   169.938,128.384 170.919,129.493 170.536,128.256 171.518,129.365 171.134,128.128 172.115,129.237 "
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.177"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        points="
   102.124,142.778 103.18,143.896 102.745,142.646 103.8,143.763 103.366,142.513 104.42,143.631 103.986,142.381 105.039,143.498 
   104.606,142.248 105.659,143.366 105.227,142.116 106.278,143.233 105.847,141.984 106.897,143.101 "
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.506"
        strokeMiterlimit="10"
        strokeDasharray="1.518,1.518"
        d="
   M200.053,104.137c-1.139,1.06-2.21,2.146-3.214,3.265c-9.961,11.104-6.246,37.171-3.277,53.418c0.73,3.998,1.686,8.525,2.905,13.692
   "
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.506"
        strokeMiterlimit="10"
        strokeDasharray="1.518,1.518"
        d="
   M200.345,106.282c-0.817,0.763-1.599,1.542-2.343,2.339c-10.048,10.765-6,37.149-2.804,53.64c0.419,2.166,0.906,4.482,1.465,6.964"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.405"
        strokeMiterlimit="10"
        strokeDasharray="1.215,1.215"
        d="M159.201,242.3
   c0,0-27.821,6.719-54.251,7.594"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.405"
        strokeMiterlimit="10"
        strokeDasharray="1.215,1.215"
        d="M159.84,244.099
   c0,0-27.821,6.719-54.252,7.594"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        d="M68.299,238.894
   c0,0-24.401-0.289-48.641-5.145"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.401"
        strokeMiterlimit="10"
        strokeDasharray="1.204,1.204"
        d="M67.869,240.829
   c0,0-24.304-0.332-48.754-5.323"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.268,1.268"
        d="
   M176.779,343.366c0,0-30.63,5.525-59.428,5.271"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.423"
        strokeMiterlimit="10"
        strokeDasharray="1.268,1.268"
        d="
   M177.375,345.191c0,0-30.63,5.525-59.428,5.27"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.422"
        strokeMiterlimit="10"
        strokeDasharray="1.266,1.266"
        d="M56.897,334.2
   c0,0-20.716,1.252-44.368-0.379"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.422"
        strokeMiterlimit="10"
        strokeDasharray="1.266,1.266"
        d="M56.681,336.029
   c0,0-20.32,1.317-44.101-0.349"
      />
      <path
        d="M11.608,271.467c0.009,0.74,0.02,1.504,0.022,2.256c0.004,1.561,0.008,3.123,0.012,4.685
   c0.012,3.795,0.027,7.653,0.045,11.467c0.023,4.584,0.05,9.123,0.08,13.492c0.037,5.126,0.078,9.899,0.123,14.592
   c0.054,5.299,0.112,10.131,0.179,14.77c0.073,5.146,0.152,9.734,0.241,14.026c0.098,4.754,0.198,8.682,0.314,12.359
   c0.092,2.885,0.21,6.301,0.397,9.769l0.013,0.224c0.106,1.986,0.217,4.04,0.479,6.047c0.039,0.297,0.087,0.649,0.155,0.999
   c1.854,9.584,1.864,29.457,0.964,37.666c-0.853,7.791,1.162,32.297,1.183,32.543l0.014,0.17l0.151,0.078
   c0.104,0.052,2.581,1.292,7.063,2.509c3.887,1.056,10.022,2.271,17.661,2.271c0.479,0,0.962-0.005,1.453-0.015
   c15.038-0.302,25.086-0.721,35.102-2.057c9.516-1.272,10.214-3.531,10.263-3.784l0.005-0.056c0.001-0.348,0.12-35.015,1.182-49.891
   c1.148-16.064,2.97-59.768,1.292-71.579c0.008-5.732,2.919-9.541,2.948-9.579l0.01-0.016c0.068-0.099,1.676-2.607,3.065-17.893
   c1.367-15.039,3.481-27.041,3.545-27.397c0.049-0.215,1.593-6.558,7.99-9.566c1.004,4.346,4.152,18.51,3.884,24.228
   c-0.318,6.799,0.947,42.58,1.939,50.288c0.96,7.459,15.895,55.828,16.574,58.023c0.183,0.764,9.158,38.101,10.532,53.945
   c0.801,9.24,2.2,17.464,2.963,21.544c0.986,5.278,2.008,9.592,2.377,10.035c0.436,0.524,8.465,2.946,20.824,3.351
   c1.204,0.038,2.415,0.058,3.633,0.058c6.221,0,12.614-0.513,19.059-1.533c9.544-1.51,19.197-4.138,28.685-7.81l0.205-0.08
   l-0.011-0.22c-0.425-8.625-7.035-60.919-7.101-61.445c-0.042-0.408-4.334-41.618-7.101-59.066
   c-1.763-11.124-5.194-25.001-7.761-34.684c-1.401-5.282-2.073-10.733-1.997-16.203c0.137-9.838,0.244-22.336-0.028-26
   c-0.125-1.677-0.445-4.022-0.817-6.736c-0.925-6.743-2.192-15.979-1.656-23.77c0.233-3.405,0.816-8.247,1.492-13.852
   c1.489-12.377,3.531-29.328,3.457-44.689c-0.086-17.827,0.849-29.84,1.256-34.177c0.077-0.812,0.224-1.622,0.438-2.407
   c0.884-3.235,3.722-15.086,3.115-31.78c-0.342-9.402-1.716-18.867-4.083-28.133c-2.554-10.006-6.294-19.861-11.132-29.349
   c0.933-0.654,1.341-1.205,1.404-1.294c1.053-1.326,0.719-2.156,0.678-2.246l-0.004-0.01c-0.059-0.115-5.807-11.643-9.01-29.231
   c-0.089-0.484-0.463-0.772-1.003-0.772l-1.751-0.004c-0.086-0.004-1.089-0.041-2.016-0.029h-0.02
   c-0.07-0.011-0.144-0.012-0.217-0.002c-4.662,0.557-9.241,1.468-13.633,2.555l-0.004-0.027l-0.482,0.148l-0.008,0.002
   c-5.294,1.329-10.308,2.905-14.857,4.416c-9.077,3.01-18.703,5.777-29.43,8.459c-4.308,1.208-8.667,2.51-12.965,3.871
   c-1.956,0.616-4.058,1.259-6.283,1.94c-6.352,1.944-13.552,4.147-19.221,6.302c-0.341,0.128-0.57,0.462-0.57,0.828v17.964
   l0.011-0.003c0.078,2.899,0.572,21.277,1.029,36.034l0.007,0.194c-0.266,0.452-0.531,0.904-0.793,1.358
   c-0.73,1.258-1.5,2.6-2.357,4.103c-1.174,2.064-2.402,4.243-3.645,6.476c-1.554,2.792-3.137,5.669-4.704,8.554
   c-1.851,3.409-3.714,6.887-5.532,10.336c-2.078,3.94-4.14,7.916-6.13,11.822c-2.225,4.368-4.412,8.747-6.498,13.015
   c-2.295,4.694-4.527,9.375-6.635,13.91c-2.289,4.929-4.491,9.811-6.541,14.512c-2.209,5.063-4.301,10.048-6.219,14.818
   c-2.051,5.101-3.957,10.09-5.665,14.829c-1.841,5.109-3.438,9.867-4.881,14.546c-1.527,4.949-2.792,9.518-3.868,13.969l-0.143,0.594
   c-1.067,4.412-2.171,8.975-2.589,13.502C11.545,266.853,11.576,269.199,11.608,271.467 M77.699,53.742
   c2.613-0.993,5.556-1.997,8.591-2.983l0.393,17.918c-4.693,1.265-8.058,2.185-9.16,2.487V54.001
   C77.523,53.886,77.594,53.782,77.699,53.742 M86.897,50.565c3.128-1.01,6.339-1.996,9.376-2.924l0.461,18.352
   c-3.458,0.916-6.667,1.774-9.445,2.521L86.897,50.565z M146.195,115.199l-13.928-4.847c-8.09-3-28.01-7.657-33.335-8.655
   l-0.675-19.873c3.079,1.34,21.391,9.326,30.563,13.829c1.359,0.666,2.742,1.291,4.109,1.857l12.145,5.024
   C145.428,106.584,145.803,110.817,146.195,115.199 M96.005,80.153c-0.944-0.41-1.751-0.984-2.401-1.706
   c-0.333-0.369-0.593-0.74-0.774-1.103c-0.594-1.19-1.05-6.776-1.175-8.828l-0.026-0.534c1.623-0.434,3.339-0.89,5.121-1.362
   l0.28,11.129c0.005,0.252,0.106,0.381,0.297,0.384c0.247,0.015,0.51,0.022,0.783,0.022c4.739,0,12.89-2.102,13.255-2.196
   l0.234-0.061l-0.381-13.053c11.532-2.957,23.198-5.806,29.941-7.055c0.21,2.656,1.639,20.707,3.854,46.059l-11.851-4.902
   c-1.355-0.561-2.725-1.18-4.073-1.842c-6.117-3.003-16.286-7.55-23.307-10.648l0.021-0.049L96.005,80.153z M110.612,63l0.363,12.428
   c-1.448,0.364-9.199,2.253-13.34,2.109c-0.03-1.165-0.147-5.787-0.28-11.078c-0.005-0.207-0.01-0.416-0.015-0.626
   c-0.195-7.756-0.42-16.689-0.458-18.244l13.166-3.83l0.546,18.618L110.612,63z M116.108,41.65
   c10.447-2.612,19.858-5.307,28.733-8.228l2.379,20.922c-2.034,0.192-3.997,0.451-5.836,0.785
   c-6.676,1.213-18.493,4.094-30.185,7.092l-0.558-18.996C112.469,42.684,114.294,42.158,116.108,41.65 M147.828,54.289
   c-0.953-8.381-2.18-19.174-2.383-20.957l14.754-4.497l2.609,25.055l0.064,0.61l0.735,7.053c-1.562,0.417-10.053,2.627-14.654,2.63
   c-0.114-1.006-0.539-4.739-1.057-9.288C147.874,54.694,147.851,54.492,147.828,54.289 M160.797,28.674
   c4.362-1.082,8.909-1.991,13.538-2.549c0.006,0,0.011-0.001,0.017-0.001c0.069-0.001,0.138-0.002,0.209-0.003
   c0.122,0.031,0.22,0.133,0.244,0.264c2.842,15.61,7.687,26.481,8.822,28.892c-2.189-0.249-10.589-1.142-20.202-1.373L160.797,28.674
   z M175.636,27.509l1.258,0.003l0.02-0.002c0.173-0.02,0.334,0.1,0.365,0.274c3.176,17.435,8.226,27.613,8.415,27.988
   c0.009,0.027,0.159,0.512-0.412,1.352c-0.285-0.541-0.574-1.079-0.868-1.617c-0.001-0.004-0.003-0.006-0.004-0.009
   C184.232,55.141,178.838,44.206,175.636,27.509 M186.024,58.546c-0.14-0.274-0.282-0.547-0.426-0.82
   c1.019-1.305,0.691-2.12,0.651-2.21l-0.006-0.01c-0.052-0.102-5.161-10.247-8.363-27.832c-0.089-0.484-0.535-0.82-1.019-0.771
   L175.52,26.9c-0.039-0.207-0.077-0.416-0.115-0.624c-0.01-0.054-0.023-0.107-0.043-0.157c0.672,0.007,1.23,0.029,1.238,0.029h0.011
   l1.759,0.004c0.353,0,0.39,0.197,0.402,0.271c3.182,17.471,8.871,29.006,9.061,29.388c0.01,0.027,0.194,0.612-0.607,1.618
   l-0.014,0.019C187.208,57.452,186.868,57.942,186.024,58.546 M193.568,77.633c-3.473,0.687-33.187,6.655-48.881,12.954
   l-2.922-34.906c1.748-0.309,3.604-0.55,5.525-0.732l1.078,9.48c0.011,0.094,0.044,0.375,0.32,0.361
   c0.085,0.002,0.172,0.003,0.26,0.003c5.133,0,14.66-2.605,15.07-2.718l0.249-0.069l-0.779-7.492
   c10.297,0.252,19.188,1.264,20.462,1.414C187.804,63.024,191.013,70.268,193.568,77.633 M194.288,79.76
   c-6.37,0.866-24.384,5.417-27.989,6.336c-0.081,0.02-0.166,0.009-0.239-0.034c-0.071-0.043-0.122-0.112-0.142-0.194l-0.298-1.202
   c13.232-3.475,26.209-6.068,28.149-6.451C193.946,78.73,194.118,79.245,194.288,79.76 M198.364,95.137l-38.177,5.592
   c-0.611,0.089-1.196-0.255-1.367-0.803l-2.209-12.747c2.739-0.817,5.581-1.607,8.419-2.359l0.296,1.194
   c0.06,0.242,0.21,0.444,0.422,0.572c0.145,0.086,0.307,0.13,0.472,0.13c0.077,0,0.153-0.009,0.229-0.028
   c3.622-0.923,21.801-5.517,28.03-6.338C196.061,85.23,197.356,90.162,198.364,95.137 M197.36,150.707
   c-0.325,3.464-0.986,11.811-1.198,24.093c-1.294-5.545-2.307-10.396-3.083-14.773c-2.435-13.72-3.412-23.972-3.08-32.267
   c0.38-9.451,2.508-16.253,6.506-20.795c1.006-1.143,2.11-2.285,3.284-3.398c0.589,4.317,0.962,8.663,1.121,13.033
   c0.603,16.606-2.215,28.382-3.093,31.596C197.593,149.016,197.439,149.861,197.36,150.707 M217.602,471.196
   c-7.555,2.911-14.698,4.955-21.274,6.364c-0.442-3.578-4.282-34.439-9.328-70.109c-4.929-34.852-12.05-81.554-17.98-106.111
   c-2.867-11.873-6.261-34.319-10.092-66.716c1.114-0.247,2.201-0.492,3.234-0.729c1.542-0.354,2.826-0.658,4.044-0.955
   c0.351-0.085,1.124-0.268,2.1-0.498c2.296-0.541,5.437-1.283,6.262-1.518c0.527-0.149,1.071-0.304,1.598-0.508
   c2.439-0.947,13.655-9.112,14.466-10.531c0.749-1.309,1.086-2.532,1.097-6.333l-0.002-0.038
   c-0.802-9.069-18.351-83.683-19.129-86.98l-0.088-0.383l-22.997,4.874c-0.383,0.082-0.801,0.17-1.247,0.262
   c-1.362-14.8-2.567-28.49-3.559-40.05c3.267-1.323,7.164-2.632,11.315-3.881l2.203,12.712l0.005,0.016
   c0.226,0.759,0.956,1.269,1.765,1.269c0.093,0,0.186-0.007,0.28-0.021l38.208-5.596c0.473,2.389,0.879,4.785,1.218,7.191
   l-0.057-0.061c-1.291,1.208-2.501,2.452-3.597,3.695c-4.094,4.652-6.272,11.578-6.657,21.175
   c-0.335,8.339,0.647,18.634,3.088,32.397c0.885,4.985,2.074,10.583,3.634,17.112l0.015-0.003c-0.029,2.43-0.039,4.999-0.027,7.702
   c0.075,15.324-1.963,32.252-3.453,44.613c-0.676,5.614-1.259,10.463-1.495,13.883c-0.539,7.853,0.733,17.125,1.661,23.895
   c0.371,2.704,0.691,5.04,0.815,6.698c0.283,3.834,0.137,17.902,0.025,25.946c-0.076,5.526,0.602,11.033,2.018,16.368
   c2.563,9.67,5.988,23.525,7.748,34.624c2.763,17.432,7.054,58.625,7.097,59.039C210.583,410.54,217.082,461.962,217.602,471.196
    M154.192,234.989c-1.556,0.404-2.969,0.763-4.322,1.099c-1.324,0.328-2.898,0.712-4.517,1.073l-0.383,0.086
   c-0.891,0.2-1.813,0.406-2.723,0.501c-2.767,0.288-16.398-1.988-17.521-2.736c-1.152-0.763-1.936-1.66-3.537-4.946
   c-2.484-6.67-12.234-53.999-16.864-76.791c1.312,5.619,2.488,10.316,3.014,11.768l0.014,0.035c1.644,3.528,2.471,4.514,3.703,5.394
   c1.333,0.953,14.769,3.475,17.317,3.257c0.767-0.066,1.531-0.212,2.276-0.368c0.14-0.029,0.278-0.058,0.415-0.088l0.366-0.077
   c1.563-0.327,3.082-0.68,4.362-0.982c1.301-0.31,2.662-0.64,4.163-1.014c1.348-0.336,2.739-0.649,4.138-0.943
   c1.029-0.215,2.06-0.425,3.089-0.636c1.812-0.368,3.683-0.75,5.519-1.15c0.58-0.127,1.183-0.253,1.764-0.373
   c2.329-0.481,4.73-0.979,6.932-1.845c2.348-0.925,4.525-2.619,6.63-4.257c0.506-0.392,0.984-0.764,1.464-1.125
   c1.034-0.779,2.392-1.816,3.714-2.926c0.132-0.113,0.279-0.228,0.436-0.349c0.558-0.438,1.193-0.933,1.549-1.583
   c0.713-1.299,1.03-2.523,1.02-6.346l-0.002-0.039c-0.224-2.464-2.337-13.261-4.298-22.518l0.108-0.023
   c1.418,6.03,18.253,77.692,19.047,86.465c-0.012,3.602-0.316,4.739-0.993,5.922c-0.661,1.157-11.586,9.25-14.14,10.243
   c-0.5,0.192-1.03,0.344-1.549,0.491c-0.809,0.229-4.071,0.998-6.233,1.507c-0.98,0.231-1.753,0.414-2.107,0.501
   c-1.215,0.295-2.497,0.598-4.037,0.951c-1.114,0.255-2.287,0.519-3.492,0.786C157.053,234.276,155.599,234.624,154.192,234.989
    M102.459,141.91l50.064-10.688l18.749-3.977c1.916,9.023,4.063,19.967,4.289,22.406c0.011,3.628-0.276,4.767-0.924,5.947
   c-0.288,0.526-0.869,0.98-1.379,1.379c-0.16,0.125-0.312,0.243-0.453,0.363c-1.312,1.102-2.662,2.132-3.689,2.906
   c-0.485,0.365-0.965,0.738-1.474,1.133c-2.071,1.612-4.214,3.281-6.487,4.173c-2.157,0.85-4.537,1.342-6.841,1.82
   c-0.583,0.119-1.187,0.244-1.771,0.372c-1.832,0.4-3.702,0.78-5.514,1.149c-1.03,0.209-2.061,0.42-3.094,0.634
   c-1.405,0.293-2.803,0.612-4.16,0.949c-1.5,0.371-2.86,0.702-4.16,1.01c-1.275,0.302-2.79,0.655-4.347,0.98l-0.368,0.078
   c-0.858,0.18-1.745,0.37-2.621,0.445c-2.665,0.228-15.802-2.363-16.889-3.139c-1.114-0.796-1.874-1.715-3.431-5.059
   C107.107,162.418,104.525,151.426,102.459,141.91 M108.127,259.301l0.004-0.003l-0.049-0.19c-0.001-0.005-0.002-0.009-0.003-0.014
   c-0.126-0.538-0.207-0.877-0.23-0.968l-0.017,0.005l-2.385-9.346l-20.509-80.367c-2.77-14.811-5.261-35.618-5.695-42.013
   c-0.15-2.218-0.407-9.671-0.678-18.397L77.53,71.795c1.144-0.314,6.377-1.748,13.497-3.652l0.019,0.406
   c0.018,0.31,0.466,7.524,1.239,9.067c0.206,0.412,0.497,0.828,0.866,1.239c0.708,0.787,1.587,1.412,2.612,1.857l1.874,0.815
   l0.702,20.682l0.242,0.043c4.919,0.892,25.284,5.636,33.48,8.674l14.193,4.94c0.449,5.005,0.921,10.204,1.412,15.547
   c-2.297,0.479-5.196,1.074-8.024,1.654c-3.731,0.765-7.597,1.559-10.101,2.089l-28.048,5.947l-0.345,0.077l0.077,0.385
   c0.678,3.387,16.074,80.096,19.329,88.773l0.015,0.036c1.689,3.469,2.541,4.431,3.816,5.277c1.38,0.916,15.308,3.115,17.951,2.839
   c0.947-0.099,1.884-0.31,2.794-0.514l0.382-0.086c0.21-0.046,0.421-0.092,0.63-0.14c1.4-0.319,2.745-0.649,3.9-0.935
   c1.353-0.336,2.769-0.697,4.327-1.101c1.29-0.336,2.621-0.657,3.961-0.957c0.268,2.275,0.535,4.499,0.8,6.675
   c3.504,28.814,6.629,48.997,9.298,60.051c2.734,11.324,5.722,27.364,8.631,44.78c3.397,20.32,6.684,42.513,9.338,61.273
   c5.07,35.845,8.921,66.831,9.331,70.15c-11.633,2.44-21.464,2.896-28.644,2.688c-12.925-0.374-20.243-2.842-20.798-3.161
   c-0.524-0.917-3.803-15.214-5.191-31.225c-1.383-15.973-10.458-53.667-10.548-54.045l-0.006-0.019
   c-0.106-0.34-7.198-23.308-12.077-40.442c-2.339-8.211-4.169-15.083-4.478-17.486c-0.988-7.692-2.251-43.398-1.933-50.182
   C112.331,277.883,109.115,263.54,108.127,259.301 M57.297,332.679c3.999-28.204,4.506-52.917,4.52-53.697
   c0.073-0.565,1.908-14.66,4.918-31.315c2.819-15.601,7.272-36.699,12.484-48.618l0.017-0.051c4.19-17.458,5.351-25.101,5.645-28.339
   l22.532,88.292c-3.54,1.631-5.635,4.228-6.775,6.14c-1.263,2.118-1.65,3.834-1.667,3.906l-0.001,0.012
   c-0.022,0.121-2.17,12.237-3.554,27.456c-1.329,14.627-2.875,17.458-2.959,17.603c-0.226,0.295-3.066,4.123-3.066,9.963l0.004,0.043
   c1.676,11.736-0.148,55.414-1.295,71.469c-1.045,14.639-1.177,48.387-1.183,49.885c-0.097,0.222-1.184,2.141-9.739,3.285
   c-6.723,0.897-13.466,1.38-21.736,1.692C55.304,444.612,53.379,360.309,57.297,332.679 M12.366,264.59
   c0.414-4.481,1.514-9.023,2.576-13.415l0.143-0.594c1.074-4.438,2.335-8.996,3.858-13.932c0.401-1.301,0.814-2.609,1.241-3.928
   c1.106-3.415,2.305-6.912,3.631-10.591c1.706-4.732,3.609-9.715,5.657-14.808c1.915-4.765,4.006-9.745,6.212-14.802
   c2.048-4.697,4.248-9.575,6.536-14.499c2.105-4.531,4.336-9.208,6.629-13.899c2.085-4.265,4.27-8.641,6.494-13.005
   c1.987-3.904,4.049-7.879,6.126-11.816c1.817-3.446,3.677-6.922,5.527-10.329c1.567-2.883,3.148-5.759,4.701-8.548
   c1.244-2.231,2.469-4.408,3.644-6.47c0.855-1.503,1.624-2.843,2.353-4.1c0.1-0.172,0.201-0.345,0.301-0.518
   c0.256,8.163,0.496,14.999,0.64,17.109c0.434,6.411,2.931,27.261,5.706,42.096l0.162-0.03l-0.161,0.037
   c0.027,0.148,0.603,4.047-5.694,30.281c-4.195,9.61-7.896,25.107-10.653,38.927c-0.68,3.409-1.303,6.715-1.861,9.806
   c-3.059,16.928-4.906,31.216-4.924,31.359l-0.002,0.033c-0.004,0.248-0.478,25.16-4.514,53.639c-0.19,1.333-0.365,2.798-0.527,4.376
   c-1.655,16.076-1.975,43.978-1.935,65.52c0.046,24.014,0.535,45.187,0.601,47.938c-3.847,0.141-8.029,0.245-12.69,0.338
   c-14.701,0.296-24.419-4.008-25.735-4.626c-0.18-2.221-1.98-24.866-1.17-32.254c0.81-7.39,1.057-27.372-0.971-37.848
   c-0.065-0.334-0.112-0.673-0.15-0.961c-0.258-1.985-0.368-4.028-0.474-6.003l-0.013-0.223c-0.187-3.462-0.306-6.874-0.396-9.756
   c-0.116-3.674-0.216-7.598-0.314-12.352c-0.067-3.181-0.127-6.526-0.183-10.14c-0.02-1.26-0.038-2.552-0.058-3.882
   c-0.066-4.638-0.125-9.469-0.179-14.767c-0.047-4.692-0.087-9.465-0.123-14.591c-0.031-4.368-0.057-8.906-0.08-13.49
   c-0.018-3.813-0.033-7.671-0.045-11.466c-0.004-1.562-0.009-3.124-0.012-4.684c-0.002-0.756-0.013-1.523-0.022-2.263
   C12.186,269.207,12.155,266.877,12.366,264.59"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
   M282.749,174.846c4.47,1.976,13.906,5.555,18.938,5.555c0.296,0,0.582-0.01,0.849-0.029c5.471-0.391,13.154-2.689,16.507-4.508
   c-1.049,5.844-2.23,12.268-3.462,18.719c-2.502,13.089-4.713,23.625-6.57,31.316c-2.712,11.225-4.064,13.668-4.391,14.134
   c-3.205,1.393-15.051,1.896-23.28,1.959"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M280.508,262.468c0,0,0.206,0.032,0.603,0.089"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="282.009"
        y1="262.684"
        x2="282.009"
        y2="262.684"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="1.211,0.907"
        d="
   M282.009,262.684c8.073,1.115,47.179,5.943,80.223-0.104"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M362.233,262.579c0.2-0.037,0.4-0.074,0.6-0.111
   "
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M280.508,264.017c0,0,0.206,0.032,0.603,0.089"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="282.009"
        y1="264.233"
        x2="282.009"
        y2="264.233"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="1.211,0.907"
        d="
   M282.009,264.233c8.073,1.115,47.179,5.943,80.223-0.104"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M362.233,264.128c0.2-0.037,0.4-0.074,0.6-0.111
   "
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M281.664,359.55c0,0,0.206,0.037,0.602,0.102"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="283.166"
        y1="359.797"
        x2="283.166"
        y2="359.797"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="1.218,0.912"
        d="
   M283.166,359.797c7.689,1.209,43.559,6.22,76.387,0.209"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M359.554,360.006
   c0.199-0.037,0.399-0.074,0.6-0.111"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M281.664,357.829c0,0,0.206,0.036,0.602,0.102"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="283.166"
        y1="358.076"
        x2="283.166"
        y2="358.076"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="1.218,0.912"
        d="
   M283.166,358.076c7.689,1.209,43.559,6.22,76.387,0.209"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M359.554,358.285
   c0.199-0.037,0.399-0.074,0.6-0.111"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M473.336,262.468c0,0-0.206,0.032-0.603,0.089"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="471.835"
        y1="262.684"
        x2="471.835"
        y2="262.684"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="1.211,0.907"
        d="
   M471.835,262.684c-8.073,1.115-47.179,5.943-80.223-0.104"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M391.612,262.579
   c-0.2-0.037-0.4-0.074-0.6-0.111"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M473.336,264.017c0,0-0.206,0.032-0.603,0.089"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="471.835"
        y1="264.233"
        x2="471.835"
        y2="264.233"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="1.211,0.907"
        d="
   M471.835,264.233c-8.073,1.115-47.179,5.943-80.223-0.104"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M391.612,264.128
   c-0.2-0.037-0.4-0.074-0.6-0.111"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M472.18,359.55c0,0-0.206,0.037-0.602,0.102"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="470.678"
        y1="359.797"
        x2="470.678"
        y2="359.797"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="1.218,0.912"
        d="
   M470.678,359.797c-7.689,1.209-43.559,6.22-76.387,0.209"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M394.29,360.006
   c-0.199-0.037-0.399-0.074-0.6-0.111"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M472.18,357.829c0,0-0.206,0.036-0.602,0.102"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="470.678"
        y1="358.076"
        x2="470.678"
        y2="358.076"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="1.218,0.912"
        d="
   M470.678,358.076c-7.689,1.209-43.559,6.22-76.387,0.209"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M394.29,358.285
   c-0.199-0.037-0.399-0.074-0.6-0.111"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="1.22,0.915"
        d="M283.816,464.977
   c0,0,31.425,9.268,71.174,0.258"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="1.22,0.915"
        d="M470.055,464.977
   c0,0-31.597,9.268-71.346,0.258"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="345.427"
        y1="32.498"
        x2="359.292"
        y2="32.256"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M295.176,29.158
   c3.099,3.442,8.949,4.012,9.172,4.04l0.091,0.013l21.426-0.373"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M325.507,49.646
   c-15.474-0.347-28.369-0.758-31.535-0.867"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M359.206,50.157
   c-4.573-0.024-9.354-0.075-14.162-0.145"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="408.374"
        y1="32.541"
        x2="397.16"
        y2="32.334"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M458.178,29.236
   c-3.099,3.442-8.948,4.012-9.172,4.04l-0.091,0.013l-20.818-0.384"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M428.315,49.76
   c15.271-0.354,27.794-0.79,31.068-0.902"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M397.246,50.235
   c3.839-0.02,7.759-0.059,11.672-0.112"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M376.935,133.036
   c0.142-0.044,0.287-0.09,0.436-0.137"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="378.237"
        y1="132.614"
        x2="378.237"
        y2="132.614"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.912,0.911"
        d="
   M378.237,132.614c3.184-1.08,7.422-2.881,9.973-5.432c1.693-1.693,2.534-3.971,2.856-6.307c0.326-2.364,0.047-4.694,0.082-7.057
   c0.027-1.73,0.009-3.461,0.013-5.191l0.02-8.26c0.008-3.204,0.016-6.407,0.023-9.611c0.009-3.373,0.016-6.747,0.024-10.121
   c0.009-3.262,0.017-6.525,0.025-9.788c0.006-2.872,0.013-5.744,0.02-8.615c0.006-2.201,0.011-4.401,0.016-6.601
   c0.004-1.248,0.007-2.497,0.01-3.745v-0.081"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M391.298,51.804
   c0-0.152,0.001-0.305,0.001-0.458"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="378.386"
        y1="51.764"
        x2="378.385"
        y2="52.222"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="378.384"
        y1="53.126"
        x2="378.384"
        y2="53.127"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.907,0.906"
        points="
   378.384,53.127 378.313,132.518 378.313,151.037 "
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="378.313"
        y1="151.037"
        x2="378.313"
        y2="151.494"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
   M283.531,138.065l39.042,13.061c-2.491,10.273-4.957,19.287-5.694,20.803c-1.327,0.94-9.151,3.769-15.228,4.203
   c-0.177,0.013-0.366,0.019-0.563,0.019c-4.924,0-14.949-4.361-18.183-5.844"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
   M283.622,168.743c5.725,2.624,13.734,5.687,17.466,5.687c0.156,0,0.305-0.004,0.441-0.014c5.517-0.394,12.186-2.785,13.983-3.681
   c0.748-2.028,2.708-9.073,5.014-18.478l-37.541-12.559"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
   M471.166,174.846c-4.471,1.976-13.907,5.555-18.938,5.555c-0.296,0-0.583-0.01-0.849-0.029c-5.472-0.391-13.154-2.689-16.508-4.508
   c1.05,5.844,2.23,12.268,3.463,18.719c2.502,13.089,4.712,23.625,6.57,31.316c2.711,11.225,4.063,13.668,4.39,14.134
   c3.205,1.393,15.051,1.896,23.28,1.959"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
   M470.383,138.065l-39.042,13.061c2.492,10.273,4.957,19.287,5.694,20.803c1.327,0.94,9.152,3.769,15.228,4.203
   c0.177,0.013,0.367,0.019,0.564,0.019c4.923,0,14.949-4.361,18.183-5.844"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M470.93,139.697
   l-37.541,12.559c2.306,9.406,4.267,16.451,5.015,18.479c1.796,0.896,8.465,3.286,13.982,3.68c0.136,0.01,0.284,0.015,0.441,0.015
   c3.731,0,11.741-3.064,17.465-5.688"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="325.865"
        y1="82.503"
        x2="326.282"
        y2="82.316"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="327.119"
        y1="81.941"
        x2="327.12"
        y2="81.941"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.918,0.917"
        d="M327.12,81.94
   l15.454-6.935c1.485-0.579,5.519-3.068,6.628-4.3c0.497-0.552,1.14-1.184,1.484-1.873c1.079-2.156,2.156-14.094,2.371-16.585"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M353.058,52.248
   c0.025-0.293,0.038-0.456,0.038-0.456"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="326.159"
        y1="79.246"
        x2="326.579"
        y2="79.065"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="327.406"
        y1="78.71"
        x2="327.407"
        y2="78.71"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.901,0.9"
        d="M327.407,78.71
   l14.11-6.06l0.059-0.026l0.06-0.023c1.235-0.482,4.875-2.765,5.647-3.623c0.092-0.101,0.187-0.206,0.285-0.312
   c0.29-0.314,0.687-0.744,0.809-0.988c0.603-1.331,1.954-8.938,2.528-15.516"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M350.906,52.162
   c0.014-0.152,0.026-0.304,0.039-0.456"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M285.596,100.841
   c0.134-0.07,0.269-0.141,0.405-0.211"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="286.807"
        y1="100.212"
        x2="286.808"
        y2="100.212"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.909,0.908"
        d="
   M286.808,100.212c4.037-2.084,8.857-4.472,14.497-7.115c7.448-3.49,14.904-6.849,20.055-9.142"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M321.361,83.954
   c0.141-0.062,0.28-0.125,0.418-0.186l-0.049,0.455"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="321.633"
        y1="85.125"
        x2="321.633"
        y2="85.126"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.909,0.908"
        x1="321.633"
        y1="85.127"
        x2="319.7"
        y2="103.201"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M319.701,103.201l-0.048,0.455
   c-0.147,0.026-0.298,0.054-0.449,0.084"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="318.293"
        y1="103.924"
        x2="318.293"
        y2="103.924"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.929,0.928"
        d="
   M318.293,103.925c-8.211,1.747-22.039,6.646-33.544,10.954"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M284.748,114.879
   c-0.143,0.054-0.285,0.107-0.428,0.161"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M285.917,97.91
   c0.135-0.069,0.271-0.139,0.407-0.208"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="287.155"
        y1="97.277"
        x2="287.156"
        y2="97.277"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.934,0.933"
        d="M287.156,97.277
   c3.554-1.806,7.856-3.909,13.058-6.344c9.801-4.59,19.613-8.95,24.196-10.969"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M324.409,79.963
   c0.145-0.063,0.284-0.125,0.419-0.184l-0.049,0.455"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="324.679"
        y1="81.173"
        x2="324.678"
        y2="81.174"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.946,0.945"
        x1="324.678"
        y1="81.174"
        x2="322.057"
        y2="105.621"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M322.057,105.622l-0.049,0.455
   c-0.148,0.019-0.299,0.039-0.453,0.062"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="320.665"
        y1="106.277"
        x2="320.664"
        y2="106.277"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.902,0.901"
        d="
   M320.664,106.278c-8.468,1.432-24,6.838-36.109,11.341"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M284.555,117.619
   c-0.144,0.053-0.287,0.106-0.429,0.159"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M342.597,66.637
   c0,0.001,0.005-0.159,0.014-0.457"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="342.639"
        y1="65.251"
        x2="342.639"
        y2="65.25"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.931,0.93"
        d="M342.639,65.25
   c0.183-6.04,0.905-29.905,1.015-33.511"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M343.654,31.737
   c0.009-0.297,0.014-0.457,0.014-0.457"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M339.498,66.637
   c0,0.001,0.005-0.159,0.014-0.457"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="339.54"
        y1="65.251"
        x2="339.54"
        y2="65.25"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.931,0.93"
        d="M339.54,65.25
   c0.184-6.04,0.906-29.905,1.015-33.511"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M340.555,31.737
   c0.01-0.297,0.015-0.457,0.015-0.457"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="327.794"
        y1="31.673"
        x2="327.786"
        y2="32.13"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="327.772"
        y1="33.049"
        x2="327.772"
        y2="33.05"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.92,0.919"
        x1="327.772"
        y1="33.05"
        x2="327.25"
        y2="66.179"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="327.249"
        y1="66.18"
        x2="327.242"
        y2="66.638"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="330.892"
        y1="31.673"
        x2="330.885"
        y2="32.13"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="330.87"
        y1="33.049"
        x2="330.87"
        y2="33.05"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.92,0.919"
        x1="330.87"
        y1="33.05"
        x2="330.348"
        y2="66.179"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="330.348"
        y1="66.18"
        x2="330.341"
        y2="66.638"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="428.005"
        y1="82.503"
        x2="427.588"
        y2="82.316"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="426.751"
        y1="81.941"
        x2="426.75"
        y2="81.941"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.918,0.917"
        d="M426.75,81.94
   l-15.454-6.935c-1.485-0.579-5.519-3.068-6.628-4.3c-0.497-0.552-1.14-1.184-1.484-1.873c-1.078-2.156-2.156-14.094-2.371-16.585"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M400.814,52.248
   c-0.025-0.293-0.039-0.456-0.039-0.456"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M403.098,51.534
   c0.013,0.151,0.025,0.303,0.039,0.455"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="403.217"
        y1="52.891"
        x2="403.217"
        y2="52.892"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.906,0.905"
        d="M403.217,52.892
   c0.594,6.376,1.701,13.517,2.281,14.796c0.117,0.234,0.514,0.664,0.804,0.978c0.098,0.106,0.194,0.21,0.285,0.312
   c0.773,0.858,4.412,3.141,5.648,3.622l0.059,0.024l0.059,0.026l14.94,6.583"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="427.293"
        y1="79.234"
        x2="427.712"
        y2="79.418"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M468.276,100.841
   c-0.135-0.07-0.27-0.141-0.406-0.211"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="467.064"
        y1="100.212"
        x2="467.063"
        y2="100.212"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.909,0.908"
        d="
   M467.063,100.212c-4.037-2.084-8.856-4.472-14.497-7.115c-7.448-3.49-14.904-6.849-20.055-9.142"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M432.51,83.954
   c-0.141-0.062-0.28-0.125-0.417-0.186l0.048,0.455"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="432.238"
        y1="85.125"
        x2="432.238"
        y2="85.126"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.909,0.908"
        x1="432.238"
        y1="85.127"
        x2="434.171"
        y2="103.201"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M434.17,103.201l0.049,0.455
   c0.146,0.026,0.297,0.054,0.448,0.084"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="435.577"
        y1="103.924"
        x2="435.578"
        y2="103.924"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.929,0.928"
        d="
   M435.578,103.925c8.21,1.747,22.038,6.646,33.543,10.954"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M469.122,114.879
   c0.143,0.054,0.285,0.107,0.428,0.161"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M467.953,97.91
   c-0.135-0.069-0.271-0.139-0.407-0.208"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="466.716"
        y1="97.277"
        x2="466.715"
        y2="97.277"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.934,0.933"
        d="M466.715,97.277
   c-3.554-1.806-7.856-3.909-13.057-6.344c-9.802-4.59-19.614-8.95-24.197-10.969"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M429.461,79.963
   c-0.145-0.063-0.284-0.125-0.418-0.184l0.049,0.455"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="429.193"
        y1="81.173"
        x2="429.193"
        y2="81.174"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.946,0.945"
        x1="429.193"
        y1="81.174"
        x2="431.814"
        y2="105.621"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M431.814,105.622l0.049,0.455
   c0.148,0.019,0.3,0.039,0.453,0.062"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="433.205"
        y1="106.277"
        x2="433.206"
        y2="106.277"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.902,0.901"
        d="
   M433.206,106.278c8.468,1.432,24,6.838,36.109,11.341"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M469.317,117.619
   c0.143,0.053,0.286,0.106,0.428,0.159"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M411.365,66.662
   c0,0.001-0.005-0.158-0.014-0.457"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="411.323"
        y1="65.275"
        x2="411.323"
        y2="65.274"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.931,0.93"
        d="M411.323,65.274
   c-0.183-6.04-0.905-29.905-1.015-33.511"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M410.309,31.762
   c-0.009-0.297-0.014-0.457-0.014-0.457"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M414.464,66.662
   c0,0.001-0.005-0.158-0.014-0.457"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="414.422"
        y1="65.275"
        x2="414.422"
        y2="65.274"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.931,0.93"
        d="M414.422,65.274
   c-0.184-6.04-0.906-29.905-1.015-33.511"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        d="M413.407,31.762
   c-0.01-0.297-0.015-0.457-0.015-0.457"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="426.168"
        y1="31.697"
        x2="426.176"
        y2="32.155"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="426.191"
        y1="33.074"
        x2="426.191"
        y2="33.075"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.92,0.919"
        x1="426.191"
        y1="33.075"
        x2="426.713"
        y2="66.204"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="426.713"
        y1="66.204"
        x2="426.72"
        y2="66.662"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="423.071"
        y1="31.697"
        x2="423.078"
        y2="32.155"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="423.092"
        y1="33.074"
        x2="423.092"
        y2="33.075"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.92,0.919"
        x1="423.092"
        y1="33.075"
        x2="423.614"
        y2="66.204"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="423.615"
        y1="66.204"
        x2="423.621"
        y2="66.662"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="359.222"
        y1="31.285"
        x2="359.628"
        y2="31.496"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="360.452"
        y1="31.926"
        x2="360.453"
        y2="31.926"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.931,0.929"
        x1="360.453"
        y1="31.926"
        x2="396.762"
        y2="50.849"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="396.762"
        y1="50.85"
        x2="397.167"
        y2="51.061"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="359.222"
        y1="51.754"
        x2="359.625"
        y2="51.537"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="360.414"
        y1="51.112"
        x2="360.415"
        y2="51.112"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.898,0.897"
        x1="360.415"
        y1="51.111"
        x2="396.765"
        y2="31.502"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        x1="396.765"
        y1="31.502"
        x2="397.167"
        y2="31.285"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="1.22,0.915"
        d="M291.372,359.194
   v-6.949c0,0,32.979,3.863,59.142,0.765v6.496"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="1.22,0.915"
        d="M464.117,359.194
   v-6.949c0,0-32.979,3.863-59.143,0.765v6.496"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M363.647,50.427
   c-1.024,0-2.059-0.001-3.102-0.005V32.27l15.808-0.318l0.556-0.01l18.884,0.379v17.663c-6.927,0.115-13.286,0.227-18.911,0.332
   C372.997,50.39,368.544,50.427,363.647,50.427z"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="1.22,0.915"
        d="M296.308,28.443
   c1.149-0.236,2.255-0.458,3.214-0.649c2.452-0.489,4.37-0.969,6.225-1.432c2.222-0.554,4.321-1.079,7.204-1.597
   c8.231-1.477,15.748-2.713,22.976-3.775c9.392-1.379,17.042-2.293,24.082-2.876c8.087-0.67,16.588-0.847,25.269-0.526
   c8.426,0.311,16.629,1.263,23.539,2.152c7.523,0.968,15.588,2.19,24.657,3.734c3.657,0.623,6.461,1.265,9.431,1.945
   c2.261,0.516,4.598,1.052,7.418,1.597c2.132,0.415,4.627,0.902,7.182,1.43"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
   M383.279,183.114c0.409-8.937,0.981-22.672,0.744-24.878c-0.355-3.312-4.845-5.429-6.936-4.804h-0.091
   c-2.093-0.625-6.581,1.492-6.938,4.804c-0.233,2.176,0.321,15.577,0.729,24.519"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="
   M372.007,173.761v-12.394c0-1.592,0.593-3.145,1.717-4.273c0.773-0.776,1.744-1.196,3.148-1.211"
      />
      <path
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        d="M382.036,173.87
   l-0.172-12.565c0-1.593-0.594-3.146-1.718-4.274c-0.773-0.777-1.744-1.196-3.148-1.211"
      />
      <line
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.305"
        strokeMiterlimit="10"
        strokeDasharray="0.915,0.915"
        x1="380.034"
        y1="133.02"
        x2="380.034"
        y2="152.583"
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.152"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        points="
   325.56,151.302 324.109,152.469 324.739,151.043 323.288,152.209 323.918,150.784 322.467,151.95 323.098,150.525 321.647,151.691 
   322.277,150.266 320.826,151.432 321.456,150.007 320.005,151.173 320.635,149.748 319.184,150.914 "
      />
      <polyline
        fill="none"
        stroke={stitching}
        onClick={() => handleClick("stitching")}
        onMouseEnter={() => setStitchingActive(true)}
        onMouseLeave={() => setStitchingActive(false)}
        style={
          stitchingActive && !preview
            ? {stroke: adjust(stitching, 55)}
            : {stroke: stitching}
        }
        strokeWidth="0.152"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        points="
   428.139,151.302 429.59,152.469 428.959,151.043 430.41,152.209 429.781,150.784 431.232,151.95 430.601,150.525 432.052,151.691 
   431.422,150.266 432.873,151.432 432.243,150.007 433.694,151.173 433.063,149.748 434.514,150.914 "
      />
      <path
        d="M412.377,64.901L412,65.467l0.059-0.525c0.003-0.028-0.014-0.055-0.04-0.064c-0.027-0.01-0.056,0-0.072,0.023l-0.378,0.566
   l0.059-0.525c0.003-0.028-0.014-0.055-0.04-0.064c-0.026-0.01-0.056,0-0.071,0.023l-0.377,0.566l0.057-0.525
   c0.004-0.028-0.012-0.055-0.039-0.064c-0.026-0.01-0.056,0-0.072,0.023l-0.516,0.774l0.102,0.068l0.377-0.566l-0.059,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.027,0.009,0.056-0.001,0.072-0.024l0.378-0.566l-0.059,0.526
   c-0.003,0.028,0.013,0.054,0.04,0.064c0.025,0.009,0.056-0.001,0.071-0.024l0.377-0.566l-0.058,0.526
   c-0.003,0.028,0.013,0.054,0.04,0.064c0.007,0.002,0.013,0.003,0.021,0.003c0.02,0,0.039-0.01,0.051-0.027l0.516-0.775
   L412.377,64.901z"
      />
      <path
        d="M415.304,64.901l-0.378,0.566l0.059-0.525c0.003-0.028-0.014-0.055-0.04-0.064c-0.027-0.01-0.056,0-0.072,0.023
   l-0.377,0.566l0.058-0.525c0.004-0.028-0.013-0.055-0.039-0.064c-0.026-0.01-0.057,0-0.072,0.023l-0.377,0.566l0.058-0.525
   c0.003-0.028-0.013-0.055-0.04-0.064c-0.026-0.01-0.055,0-0.071,0.023l-0.517,0.774l0.102,0.068l0.377-0.566l-0.058,0.526
   c-0.004,0.028,0.013,0.054,0.039,0.064c0.027,0.009,0.057-0.001,0.073-0.024l0.377-0.566l-0.059,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.026,0.009,0.056-0.001,0.071-0.024l0.378-0.566l-0.058,0.526
   c-0.003,0.028,0.012,0.054,0.039,0.064c0.007,0.002,0.014,0.003,0.021,0.003c0.02,0,0.039-0.01,0.051-0.027l0.517-0.775
   L415.304,64.901z"
      />
      <path
        d="M424.598,64.728l-0.377,0.566l0.059-0.525c0.003-0.028-0.014-0.055-0.04-0.064c-0.027-0.01-0.056,0-0.072,0.023
   l-0.378,0.566l0.059-0.525c0.003-0.028-0.013-0.055-0.039-0.064c-0.027-0.01-0.057,0-0.072,0.023l-0.377,0.566l0.058-0.525
   c0.003-0.028-0.013-0.055-0.04-0.064c-0.026-0.01-0.055,0-0.071,0.023l-0.517,0.775l0.102,0.067l0.377-0.566l-0.059,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.027,0.009,0.056,0,0.072-0.024l0.378-0.566l-0.059,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.026,0.009,0.056,0,0.071-0.024l0.377-0.566l-0.057,0.526
   c-0.004,0.028,0.012,0.054,0.039,0.064c0.007,0.002,0.014,0.004,0.021,0.004c0.02,0,0.039-0.01,0.051-0.028l0.516-0.774
   L424.598,64.728z"
      />
      <path
        d="M427.525,64.728l-0.378,0.566l0.059-0.525c0.003-0.028-0.013-0.055-0.039-0.064c-0.028-0.01-0.057,0-0.073,0.023
   l-0.377,0.566l0.059-0.525c0.003-0.028-0.014-0.055-0.04-0.064c-0.026-0.01-0.056,0-0.072,0.023l-0.377,0.566l0.058-0.525
   c0.003-0.028-0.013-0.055-0.04-0.064c-0.026-0.01-0.055,0-0.071,0.023l-0.517,0.775l0.102,0.067l0.377-0.566l-0.058,0.526
   c-0.004,0.028,0.013,0.054,0.039,0.064c0.027,0.009,0.057,0,0.073-0.024l0.377-0.566l-0.059,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.026,0.009,0.056,0,0.071-0.024l0.378-0.566l-0.058,0.526
   c-0.003,0.028,0.013,0.054,0.04,0.064c0.007,0.002,0.013,0.004,0.02,0.004c0.02,0,0.039-0.01,0.051-0.028l0.517-0.774
   L427.525,64.728z"
      />
      <path
        d="M411.345,32.369l-0.378,0.566l0.059-0.525c0.003-0.028-0.013-0.055-0.039-0.064c-0.028-0.01-0.057,0-0.073,0.023
   l-0.377,0.566l0.059-0.525c0.003-0.028-0.014-0.055-0.04-0.064c-0.026-0.01-0.056,0-0.071,0.023l-0.378,0.566l0.058-0.525
   c0.003-0.028-0.013-0.055-0.04-0.064c-0.026-0.01-0.055,0-0.071,0.023l-0.517,0.775l0.102,0.067l0.377-0.566l-0.058,0.526
   c-0.004,0.028,0.013,0.054,0.039,0.064c0.027,0.009,0.057,0,0.073-0.024l0.377-0.566l-0.059,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.026,0.009,0.056,0,0.071-0.024l0.378-0.566l-0.058,0.526
   c-0.003,0.028,0.013,0.054,0.04,0.064c0.007,0.002,0.013,0.004,0.02,0.004c0.02,0,0.039-0.01,0.051-0.028l0.517-0.774
   L411.345,32.369z"
      />
      <path
        d="M414.271,32.369l-0.377,0.566l0.059-0.525c0.003-0.028-0.014-0.055-0.04-0.064c-0.027-0.01-0.057,0-0.073,0.023
   l-0.377,0.566l0.059-0.525c0.003-0.028-0.014-0.055-0.04-0.064c-0.026-0.01-0.056,0-0.071,0.023l-0.378,0.566l0.058-0.525
   c0.003-0.028-0.012-0.055-0.039-0.064c-0.027-0.01-0.056,0-0.072,0.023l-0.517,0.775l0.102,0.067l0.378-0.566l-0.059,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.027,0.009,0.056,0,0.072-0.024l0.377-0.566l-0.058,0.526
   c-0.004,0.028,0.013,0.054,0.039,0.064c0.026,0.009,0.057,0,0.072-0.024l0.377-0.566l-0.058,0.526
   c-0.003,0.028,0.013,0.054,0.04,0.064c0.007,0.002,0.013,0.004,0.02,0.004c0.021,0,0.039-0.01,0.051-0.028l0.517-0.774
   L414.271,32.369z"
      />
      <path
        d="M423.909,32.713l-0.377,0.566l0.059-0.525c0.003-0.028-0.014-0.055-0.04-0.064c-0.027-0.01-0.056,0-0.072,0.023
   l-0.378,0.566l0.059-0.525c0.003-0.028-0.013-0.055-0.039-0.064c-0.027-0.01-0.057,0-0.072,0.023l-0.377,0.566l0.058-0.525
   c0.003-0.028-0.013-0.055-0.04-0.064c-0.026-0.01-0.055,0-0.072,0.023l-0.516,0.775l0.102,0.067l0.377-0.566l-0.059,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.027,0.009,0.056,0,0.072-0.024l0.378-0.566l-0.059,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.026,0.009,0.056,0,0.071-0.024l0.377-0.566l-0.057,0.526
   c-0.004,0.028,0.012,0.054,0.039,0.064c0.007,0.002,0.013,0.004,0.021,0.004c0.02,0,0.039-0.01,0.051-0.028l0.516-0.774
   L423.909,32.713z"
      />
      <path
        d="M426.836,32.713l-0.378,0.566l0.059-0.525c0.003-0.028-0.013-0.055-0.04-0.064c-0.027-0.01-0.056,0-0.072,0.023
   l-0.377,0.566l0.059-0.525c0.003-0.028-0.014-0.055-0.04-0.064c-0.026-0.01-0.057,0-0.072,0.023l-0.377,0.566l0.058-0.525
   c0.003-0.028-0.013-0.055-0.04-0.064c-0.026-0.01-0.055,0-0.071,0.023l-0.517,0.775l0.102,0.067l0.377-0.566l-0.058,0.526
   c-0.004,0.028,0.013,0.054,0.039,0.064c0.027,0.009,0.057,0,0.073-0.024l0.377-0.566l-0.059,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.064c0.026,0.009,0.056,0,0.071-0.024l0.378-0.566l-0.058,0.526
   c-0.003,0.028,0.013,0.054,0.04,0.064c0.007,0.002,0.013,0.004,0.02,0.004c0.02,0,0.039-0.01,0.051-0.028l0.517-0.774
   L426.836,32.713z"
      />
      <path
        d="M328.713,32.702l-0.364,0.575l0.047-0.527c0.002-0.028-0.015-0.054-0.042-0.063c-0.027-0.009-0.056,0.001-0.071,0.025
   l-0.364,0.575l0.046-0.527c0.003-0.028-0.015-0.054-0.041-0.063c-0.027-0.009-0.057,0.002-0.071,0.025l-0.365,0.575l0.046-0.527
   c0.003-0.028-0.013-0.054-0.041-0.063c-0.026-0.009-0.055,0.001-0.07,0.025l-0.499,0.786l0.103,0.066l0.365-0.575l-0.047,0.527
   c-0.002,0.028,0.014,0.054,0.042,0.063c0.026,0.009,0.055-0.001,0.07-0.025l0.364-0.575l-0.045,0.527
   c-0.003,0.028,0.014,0.054,0.041,0.063c0.026,0.009,0.055-0.002,0.071-0.025l0.364-0.575l-0.047,0.527
   c-0.002,0.028,0.015,0.054,0.042,0.063c0.007,0.002,0.014,0.003,0.021,0.003c0.019,0,0.039-0.01,0.049-0.028l0.5-0.787
   L328.713,32.702z"
      />
      <path
        d="M331.639,32.634l-0.364,0.575l0.046-0.527c0.003-0.028-0.015-0.054-0.041-0.063c-0.027-0.009-0.056,0.001-0.072,0.025
   l-0.364,0.574l0.047-0.526c0.002-0.028-0.015-0.054-0.042-0.063c-0.026-0.009-0.056,0.001-0.07,0.025l-0.365,0.575l0.046-0.527
   c0.003-0.028-0.014-0.054-0.041-0.063s-0.056,0.001-0.071,0.025l-0.498,0.786l0.102,0.066l0.365-0.575l-0.046,0.526
   c-0.003,0.029,0.014,0.055,0.041,0.064c0.026,0.008,0.056-0.001,0.071-0.025l0.364-0.575l-0.046,0.527
   c-0.002,0.028,0.014,0.054,0.042,0.063c0.026,0.009,0.055-0.002,0.07-0.025l0.364-0.575l-0.046,0.526
   c-0.003,0.029,0.015,0.055,0.041,0.064c0.007,0.002,0.014,0.003,0.022,0.003c0.019-0.001,0.038-0.011,0.049-0.028l0.499-0.787
   L331.639,32.634z"
      />
      <path
        d="M341.282,32.237l-0.363,0.575l0.046-0.527c0.002-0.028-0.015-0.054-0.041-0.063c-0.028-0.009-0.057,0.001-0.072,0.025
   l-0.364,0.575l0.046-0.527c0.003-0.028-0.015-0.054-0.041-0.063s-0.056,0.002-0.071,0.025l-0.364,0.575l0.046-0.527
   c0.002-0.028-0.014-0.054-0.041-0.063s-0.056,0.001-0.071,0.025l-0.498,0.786l0.102,0.066l0.365-0.575l-0.046,0.527
   c-0.003,0.028,0.014,0.054,0.041,0.063c0.026,0.009,0.055-0.001,0.071-0.025l0.364-0.575l-0.046,0.527
   c-0.002,0.028,0.014,0.054,0.041,0.063s0.056-0.001,0.071-0.025l0.364-0.575l-0.046,0.527c-0.003,0.028,0.015,0.054,0.041,0.063
   c0.007,0.002,0.014,0.003,0.021,0.003c0.02,0,0.039-0.01,0.05-0.028l0.499-0.787L341.282,32.237z"
      />
      <path
        d="M344.208,32.169l-0.364,0.575l0.046-0.527c0.003-0.028-0.015-0.054-0.041-0.063c-0.027-0.009-0.056,0.001-0.072,0.025
   l-0.363,0.575l0.046-0.527c0.002-0.028-0.015-0.054-0.041-0.063c-0.027-0.009-0.057,0.002-0.071,0.025l-0.365,0.575l0.046-0.527
   c0.003-0.028-0.014-0.054-0.041-0.063c-0.026-0.009-0.055,0.001-0.071,0.025l-0.498,0.786l0.103,0.066l0.365-0.575l-0.047,0.527
   c-0.002,0.028,0.014,0.054,0.041,0.063s0.056-0.001,0.071-0.025l0.364-0.575l-0.045,0.527c-0.003,0.028,0.014,0.054,0.041,0.063
   c0.026,0.009,0.055-0.002,0.071-0.025l0.364-0.575l-0.047,0.527c-0.002,0.028,0.015,0.054,0.042,0.063
   c0.007,0.002,0.014,0.003,0.021,0.003c0.019,0,0.039-0.011,0.049-0.028l0.499-0.787L344.208,32.169z"
      />
      <path
        d="M328.198,64.643l-0.37,0.571l0.052-0.526c0.003-0.028-0.015-0.054-0.041-0.064c-0.027-0.009-0.056,0.001-0.072,0.024
   l-0.37,0.571l0.052-0.526c0.003-0.028-0.014-0.054-0.04-0.064c-0.027-0.009-0.057,0.001-0.071,0.025l-0.371,0.571l0.052-0.527
   c0.002-0.028-0.014-0.054-0.041-0.063c-0.026-0.01-0.055,0.001-0.071,0.024l-0.507,0.781l0.103,0.066l0.37-0.57l-0.052,0.526
   c-0.003,0.028,0.014,0.054,0.04,0.063c0.026,0.01,0.057,0,0.071-0.024l0.371-0.57l-0.051,0.525c-0.003,0.029,0.013,0.055,0.04,0.064
   c0.026,0.009,0.055-0.001,0.071-0.024l0.37-0.571l-0.052,0.526c-0.003,0.028,0.014,0.054,0.041,0.064
   c0.007,0.002,0.014,0.003,0.021,0.003c0.019,0,0.039-0.01,0.051-0.027l0.507-0.781L328.198,64.643z"
      />
      <path
        d="M331.123,64.607l-0.37,0.57l0.052-0.526c0.003-0.028-0.014-0.054-0.041-0.063c-0.027-0.009-0.056,0-0.072,0.024l-0.37,0.571
   l0.052-0.526c0.003-0.029-0.014-0.054-0.04-0.064c-0.026-0.009-0.057,0.001-0.071,0.024l-0.371,0.571l0.052-0.526
   c0.002-0.028-0.014-0.055-0.041-0.064c-0.026-0.009-0.055,0.001-0.071,0.025l-0.507,0.78l0.103,0.067l0.37-0.571l-0.052,0.526
   c-0.003,0.029,0.014,0.055,0.04,0.064c0.027,0.009,0.057-0.001,0.072-0.024l0.37-0.571l-0.051,0.526
   c-0.003,0.028,0.013,0.054,0.04,0.064c0.026,0.009,0.055-0.001,0.071-0.024l0.37-0.571l-0.052,0.526
   c-0.003,0.028,0.015,0.054,0.041,0.064c0.007,0.002,0.014,0.003,0.021,0.003c0.02,0,0.039-0.01,0.051-0.028l0.507-0.781
   L331.123,64.607z"
      />
      <path
        d="M340.427,64.66l-0.37,0.57l0.052-0.526c0.003-0.027-0.014-0.054-0.04-0.063c-0.028-0.009-0.057,0-0.073,0.024l-0.37,0.571
   l0.052-0.526c0.003-0.029-0.014-0.054-0.04-0.064c-0.026-0.009-0.056,0.001-0.071,0.024l-0.37,0.571l0.051-0.526
   c0.003-0.028-0.014-0.054-0.041-0.064c-0.026-0.009-0.055,0.001-0.071,0.025l-0.507,0.781l0.103,0.066l0.37-0.571l-0.052,0.526
   c-0.003,0.029,0.014,0.055,0.041,0.064c0.026,0.009,0.056-0.001,0.071-0.024l0.37-0.571l-0.051,0.526
   c-0.003,0.028,0.013,0.055,0.04,0.064c0.026,0.009,0.056-0.001,0.071-0.024l0.371-0.571l-0.053,0.526
   c-0.002,0.028,0.015,0.054,0.041,0.064c0.007,0.002,0.014,0.003,0.021,0.003c0.02,0,0.039-0.01,0.051-0.028l0.507-0.781
   L340.427,64.66z"
      />
      <path
        d="M343.353,64.624l-0.37,0.571l0.052-0.527c0.003-0.027-0.014-0.054-0.04-0.063c-0.028-0.009-0.057,0-0.072,0.024
   l-0.371,0.571l0.052-0.526c0.003-0.029-0.014-0.054-0.04-0.064c-0.026-0.009-0.056,0.001-0.071,0.025l-0.37,0.57l0.051-0.526
   c0.003-0.028-0.013-0.054-0.041-0.063c-0.026-0.01-0.055,0-0.071,0.024l-0.507,0.781l0.103,0.066l0.37-0.571l-0.052,0.527
   c-0.003,0.028,0.015,0.054,0.041,0.063s0.056-0.001,0.071-0.024l0.37-0.571l-0.051,0.526c-0.003,0.028,0.013,0.055,0.04,0.064
   c0.026,0.009,0.056-0.001,0.071-0.024l0.371-0.571l-0.053,0.526c-0.002,0.028,0.015,0.054,0.041,0.064
   c0.007,0.002,0.014,0.003,0.021,0.003c0.02,0,0.039-0.01,0.051-0.028l0.507-0.781L343.353,64.624z"
      />
      <path
        d="M473.637,261.43c-0.392-22.665-0.988-48.775-1.555-73.518c-0.379-16.628-0.737-32.333-0.997-45.446
   c-0.424-21.56-2.093-41.841-4.963-60.283c-2.289-14.719-4.738-24.177-5.66-27.737c-0.04-0.153-0.078-0.299-0.113-0.438
   c-0.037-0.044-0.065-0.096-0.086-0.156c-0.025-0.075-0.027-0.154-0.043-0.231c0.001,0.006,0.002,0.012,0.003,0.018
   c-0.001-0.008-0.002-0.014-0.003-0.019v-0.002c-0.002-0.012-0.002-0.011,0,0.002v0.001c-0.002-0.016-0.004-0.031-0.006-0.048
   c-0.003-0.022-0.005-0.045-0.007-0.069c-0.002-0.024-0.003-0.049-0.006-0.073c-0.002-0.005-0.011-0.045-0.011-0.043
   c-0.001-0.005-0.001-0.01-0.002-0.015c-0.083-0.331-0.139-0.568-0.151-0.661l0.001-0.008c0.898-6.288,0.469-12.915-0.049-17.368
   c-0.301-2.58-0.657-4.68-0.903-5.988c-0.152-0.805-0.273-1.377-0.348-1.714c-0.013-0.061-0.027-0.115-0.038-0.165l0.007,0.002
   c-0.003-0.009-0.004-0.019-0.008-0.028c-0.034-0.103-0.067-0.206-0.108-0.307c-0.003-0.005-0.005-0.012-0.007-0.014
   c-0.005-0.013-0.011-0.027-0.017-0.04c-0.011-0.024-0.023-0.048-0.035-0.071c-0.025-0.049-0.053-0.097-0.083-0.143
   c-0.008-0.012-0.017-0.024-0.025-0.035c-0.003-0.004-0.008-0.01-0.012-0.014c-0.013-0.014-0.026-0.028-0.041-0.041
   c-0.029-0.01-0.059-0.015-0.105-0.024c-0.026-0.005-0.055-0.016-0.082-0.027c-2.739-0.57-5.434-1.098-7.717-1.541
   c-2.805-0.544-5.137-1.077-7.391-1.593c-2.981-0.682-5.796-1.325-9.476-1.952c-9.079-1.547-17.154-2.77-24.688-3.74
   c-6.929-0.892-15.154-1.846-23.613-2.158c-8.711-0.322-17.244-0.144-25.362,0.529c-7.058,0.585-14.726,1.501-24.131,2.882
   c-7.24,1.064-14.764,2.3-23.003,3.779c-2.908,0.522-5.019,1.05-7.255,1.608c-1.845,0.462-3.754,0.938-6.188,1.423
   c-1.136,0.227-2.475,0.496-3.83,0.778l-0.037-0.018l-0.052,0.036c-0.004,0.001-0.009,0.002-0.015,0.003l-0.07,0.015
   c-0.055,0.28-0.178,0.542-0.28,0.807c-0.004,0.016-0.007,0.031-0.011,0.049c-0.075,0.337-0.197,0.909-0.349,1.714
   c-0.245,1.308-0.601,3.408-0.901,5.988c-0.52,4.449-0.948,11.067-0.053,17.349h-0.001c0.001,0.001,0.002,0.003,0.002,0.005
   c0.007,0.026,0.008,0.062,0.001,0.094c0.006,0.032,0.003,0.066-0.011,0.098c-0.001,0.03-0.005,0.061-0.011,0.089
   c-0.011,0.04-0.024,0.074-0.038,0.105c-0.001,0.023-0.002,0.046-0.006,0.068c-0.011,0.082-0.036,0.151-0.078,0.212
   c-0.036,0.139-0.074,0.294-0.119,0.462c-0.048,0.194-0.102,0.405-0.161,0.628c-0.922,3.56-3.371,13.019-5.66,27.738
   c-2.869,18.441-4.538,38.723-4.963,60.282c-0.259,13.113-0.618,28.817-0.997,45.443c-1.365,59.746-2.911,127.462-1.322,135.407
   c0.786,3.931,0.918,26.166,1.073,51.912c0.246,41.086,0.553,92.218,3.59,100.434l0.052,0.142l0.143,0.044
   c0.073,0.023,7.473,2.275,19.634,3.391c7.139,0.655,14.501,0.798,21.883,0.423c9.219-0.467,18.494-1.746,27.569-3.802
   c0.251-0.021,0.267-0.245,0.293-0.601c0.015-0.21,0.034-0.523,0.059-0.931c0.049-0.792,0.116-1.978,0.201-3.525
   c0.158-2.878,0.384-7.11,0.672-12.579c0.481-9.209,1.144-22.05,1.966-38.166c1.401-27.44,2.8-55.237,2.815-55.517
   c0.035-0.823,3.478-82.638,2.617-116.56c1.149-25.825,7.197-50.836,7.257-51.085l0.007-0.03l0.001-0.03
   c0.005-0.096,0.376-9.618,1.416-19.053c1.801-16.33,4.058-18.935,5.256-19.02c1.196,0.085,3.454,2.69,5.255,19.017
   c0.873,7.926,1.275,15.915,1.384,18.324c-0.003,0.049-0.004,0.077-0.004,0.086l0.008,0.001c0.018,0.405,0.026,0.631,0.027,0.645
   l0.002,0.03l0.006,0.03c0.062,0.249,6.109,25.259,7.258,51.085c-0.861,33.922,2.581,115.737,2.616,116.563
   c0.014,0.277,1.416,28.074,2.816,55.514c0.822,16.116,1.484,28.957,1.967,38.166c0.286,5.469,0.512,9.701,0.671,12.579
   c0.086,1.547,0.152,2.733,0.201,3.525c0.024,0.408,0.045,0.721,0.058,0.931c0.027,0.356,0.042,0.58,0.293,0.601
   c9.076,2.056,18.352,3.335,27.571,3.802c2.676,0.136,5.351,0.204,8.014,0.204c4.679,0,9.319-0.21,13.867-0.627
   c12.162-1.116,19.561-3.368,19.634-3.391l0.144-0.044l0.052-0.142c3.037-8.216,3.342-59.347,3.589-100.431
   c0.155-25.748,0.289-47.984,1.075-51.915C474.336,318.662,474.191,293.492,473.637,261.43 M471.295,180.155
   c0.058,2.563,0.118,5.156,0.178,7.771c0.41,17.972,0.853,37.336,1.215,55.66c-0.138,0-0.301,0.001-0.488,0.001
   c-4.087,0-19.483-0.143-23.865-2.268c-0.614-0.298-2.097-2.668-5.121-15.185c-1.861-7.706-4.078-18.269-6.588-31.396
   c-2.714-14.2-5.193-28.392-6.65-36.914c0.278,1.098,0.572,2.246,0.872,3.396c2.995,11.506,3.627,12.14,3.835,12.347
   c1.293,1.293,10.064,4.461,16.785,4.941c0.236,0.017,0.479,0.024,0.73,0.024c6.182,0,16.763-4.931,18.925-5.972
   C471.179,175.058,471.238,177.593,471.295,180.155 M470.477,142.478c0.173,8.804,0.392,18.777,0.631,29.411
   c-0.647,0.314-3.808,1.822-7.591,3.252c-3.783,1.43-8.189,2.782-11.324,2.782c-0.234,0-0.462-0.008-0.682-0.024
   c-6.472-0.461-15.187-3.554-16.396-4.763c-0.866-0.865-4.291-14.16-6.428-23.062l41.626-13.939
   C470.382,138.326,470.437,140.446,470.477,142.478 M469.458,118.677c-13.447-4.975-30.806-10.936-38.577-11.664l-3.102-28.92
   c3.454,1.51,24.71,10.847,39.652,18.331C468.331,104.1,468.987,111.591,469.458,118.677 M467.346,95.698L467.346,95.698
   c-16.227-8.104-39.568-18.272-39.804-18.375l-0.48-0.208l-15.196-6.601c-1.535-0.666-2.849-1.599-3.907-2.774
   c-0.542-0.603-0.966-1.21-1.265-1.806c-1.11-2.218-1.824-13.007-1.922-14.463c1.471-0.024,2.944-0.046,4.416-0.07l0.459,15.161
   c0.003,0.095,0.012,0.376,0.276,0.396c2.067,0.354,4.775,0.471,7.466,0.471c5.343,0,10.622-0.464,10.702-0.471l0.281-0.026
   l-0.249-15.819c16.193-0.241,29.289-0.422,31.548-0.452c-0.063,0.628-0.137,1.256-0.225,1.879c-0.069,0.147,0.013,0.463,0.426,2.058
   C463.354,68.047,465.733,82.149,467.346,95.698 M397.439,50.98V31.289l11.147,0.225l0.583,19.278
   C405.24,50.854,401.3,50.917,397.439,50.98 M409.2,31.61l18.012,0.378l0.292,18.523l0.009,0.611l0.241,15.252
   c-1.812,0.149-11.888,0.914-17.502,0.02c-0.041-1.342-0.239-7.906-0.455-15.001c-0.006-0.204-0.011-0.407-0.017-0.61
   C409.525,42.372,409.253,33.406,409.2,31.61 M459.413,35.67c0.424,3.743,0.784,9.059,0.315,14.379
   c-2.06,0.028-15.257,0.21-31.614,0.454L427.82,31.9l21.447,0.43h0.022l0.023-0.002c0.265-0.035,6.214-0.851,8.846-4.488
   C458.425,29.056,458.984,31.891,459.413,35.67 M297.81,26.898c0.586-0.119,1.149-0.232,1.67-0.336
   c2.448-0.488,4.363-0.967,6.217-1.429c2.224-0.557,4.327-1.082,7.215-1.6c8.232-1.478,15.75-2.713,22.982-3.775
   c9.393-1.38,17.049-2.294,24.094-2.878c8.093-0.671,16.602-0.849,25.289-0.528c8.434,0.312,16.641,1.264,23.556,2.155
   c7.527,0.967,15.594,2.19,24.664,3.735c3.664,0.624,6.471,1.267,9.443,1.945c2.259,0.518,4.596,1.051,7.411,1.597
   c2.213,0.431,4.812,0.94,7.457,1.487c-2.32,3.495-8.151,4.391-8.553,4.449l-72.348-1.453h-0.005l-72.354,1.453
   c-0.402-0.058-6.235-0.954-8.556-4.451C296.611,27.141,297.223,27.016,297.81,26.898 M358.884,31.239v20.2
   c-2.317-0.011-4.67-0.028-7.04-0.051c-2.368-0.022-4.753-0.05-7.135-0.084l0.601-19.793L358.884,31.239z M344.697,31.585
   c-0.055,1.834-0.337,11.147-0.597,19.711c-0.006,0.203-0.012,0.406-0.018,0.61c-0.209,6.886-0.399,13.154-0.439,14.463
   c-5.612,0.894-15.689,0.13-17.501-0.02l0.233-14.773l0.009-0.609l0.3-19.003L344.697,31.585z M294.389,35.67
   c0.43-3.779,0.987-6.614,1.257-7.83c2.631,3.637,8.579,4.453,8.844,4.488l0.022,0.002l21.563-0.432l-0.3,19.055
   c-16.408-0.371-29.656-0.826-31.7-0.898C293.606,44.733,293.965,39.415,294.389,35.67 M286.455,95.699
   c1.615-13.549,3.995-27.651,7.476-41.101c0.19-0.734,0.31-1.198,0.378-1.498v-0.001c0-0.003,0.001-0.004,0.001-0.006
   c0.01-0.025,0.015-0.052,0.017-0.081c0-0.002,0.001-0.002,0.001-0.005c0.001-0.001,0.001-0.002,0.001-0.003
   c0.058-0.281,0.061-0.391,0.028-0.464c-0.088-0.621-0.162-1.246-0.225-1.872c2.284,0.079,15.416,0.528,31.633,0.895l-0.237,15.062
   l-0.005,0.282l0.282,0.026c0.079,0.007,5.359,0.472,10.701,0.472c2.69,0,5.395-0.118,7.461-0.471c0.093-0.003,0.27-0.043,0.28-0.397
   l0.444-14.624c1.435,0.021,2.871,0.039,4.304,0.055c-0.054,0.834-0.257,3.789-0.581,6.804c-0.324,3.015-0.768,6.09-1.303,7.162
   c-0.299,0.596-0.725,1.203-1.267,1.806c-1.057,1.175-2.371,2.108-3.906,2.774l-15.195,6.601l-0.481,0.208
   c-0.236,0.103-23.578,10.271-39.807,18.377V95.699z M284.344,118.677c0.472-7.086,1.126-14.576,2.027-22.252
   c14.943-7.484,36.2-16.822,39.654-18.332l-3.102,28.92c-7.772,0.728-25.132,6.69-38.579,11.665V118.677z M283.327,142.478
   c0.04-2.038,0.094-4.161,0.165-6.358l41.67,13.954c-2.136,8.902-5.563,22.197-6.428,23.062c-1.208,1.209-9.926,4.302-16.398,4.763
   c-6.161,0.44-18.558-5.505-19.64-6.032C282.934,161.241,283.153,151.277,283.327,142.478 M282.329,187.924
   c0.12-5.237,0.237-10.383,0.351-15.385c1.03,0.497,4.217,1.994,7.924,3.369c3.707,1.374,7.934,2.624,11.046,2.624
   c0.251,0,0.495-0.007,0.73-0.024c6.72-0.48,15.491-3.648,16.784-4.941c0.208-0.207,0.842-0.841,3.836-12.347
   c0.299-1.15,0.594-2.298,0.871-3.396c-1.456,8.522-3.935,22.714-6.65,36.914c-2.51,13.127-4.725,23.69-6.588,31.396
   c-3.023,12.517-4.506,14.887-5.121,15.185c-4.604,2.232-21.373,2.277-24.398,2.267C281.478,225.262,281.918,205.897,282.329,187.924
    M376.596,158.197c-1.304,0.324-2.421,2.393-3.41,6.303c-0.811,3.208-1.533,7.655-2.147,13.216
   c-0.535,4.852-0.893,9.727-1.116,13.335c-0.467-9.859-1.398-30.724-1.079-33.682c0.228-2.122,1.908-3.534,2.89-4.187
   c1.636-1.088,3.609-1.61,4.862-1.302V158.197z M376.596,151.254c-1.427-0.281-3.466,0.267-5.2,1.42
   c-1.848,1.23-2.97,2.874-3.159,4.631c-0.422,3.923,1.255,37.489,1.325,38.916l0.084-0.004c-0.006,0.149-0.012,0.272-0.015,0.367
   c-0.005,0.094-0.007,0.16-0.009,0.197c-0.242,1.004-6.134,25.699-7.267,51.184l-0.001,0.01l0.001,0.01
   c0.1,3.924,0.142,8.492,0.139,13.5c-0.025,33.079-2.044,85.446-2.61,99.479c-0.088,2.195-0.14,3.451-0.145,3.549
   c-0.054,1.075-5.319,105.558-5.718,110.794c-20.395,4.593-37.925,4.347-49.055,3.326c-11.172-1.023-18.296-3.008-19.385-3.325
   c-2.952-8.553-3.255-59.278-3.5-100.083c-0.03-5.033-0.059-9.933-0.093-14.589c-0.139-19.187-0.351-34.231-0.992-37.439
   c-0.911-4.553-0.756-30.053-0.213-61.723c0.095-5.593,0.203-11.381,0.319-17.277c0.214,0,0.493,0.001,0.83,0.001
   c4.526,0,19.387-0.168,23.846-2.331c0.818-0.397,2.272-2.443,5.448-15.589c1.864-7.718,4.083-18.29,6.594-31.426
   c4.276-22.363,7.967-44.705,8.004-44.928l0.043-0.257l-42.355-14.183c0.166-5.037,0.418-10.454,0.789-16.14
   c13.594-5.034,31.301-11.127,38.923-11.746l0.251-0.021l3.192-29.765l15.514-6.739c1.615-0.701,3-1.685,4.117-2.925
   c0.578-0.643,1.035-1.297,1.358-1.941c1.145-2.292,1.845-12.605,1.95-14.231c4.766,0.053,9.493,0.084,14.021,0.084
   c4.579,0,8.96-0.031,12.969-0.105V151.254z M376.895,51.339c-5.276,0.1-11.204,0.126-17.401,0.102V31.226l17.408-0.349l19.927,0.4
   V50.99c-3.556,0.06-7.042,0.118-10.387,0.176C383.097,51.225,379.891,51.282,376.895,51.339 M382.763,177.716
   c-0.613-5.561-1.336-10.008-2.147-13.216c-0.988-3.91-2.106-5.979-3.41-6.303v-6.339c1.257-0.261,3.173,0.264,4.769,1.324
   c0.98,0.653,2.662,2.065,2.89,4.187c0.309,2.876-0.562,22.655-1.04,32.82C383.6,186.685,383.257,182.191,382.763,177.716
    M472.808,323.197c-0.007,0.031-0.013,0.063-0.019,0.097c-0.006,0.033-0.012,0.068-0.018,0.103c-0.038,0.225-0.075,0.495-0.11,0.807
   c-0.006,0.04-0.01,0.082-0.015,0.125c-0.004,0.043-0.008,0.087-0.014,0.131c-0.005,0.052-0.011,0.106-0.015,0.161
   c-0.008,0.07-0.015,0.142-0.021,0.216c-0.009,0.088-0.017,0.178-0.023,0.27c-0.013,0.138-0.025,0.282-0.036,0.432
   c-0.008,0.104-0.016,0.212-0.024,0.323c-0.028,0.384-0.054,0.802-0.08,1.249c-0.007,0.128-0.015,0.258-0.021,0.391
   c0,0.004,0,0.008-0.001,0.013c-0.004,0.082-0.009,0.166-0.013,0.25c-0.004,0.084-0.009,0.17-0.013,0.256
   c-0.006,0.101-0.01,0.206-0.015,0.311c-0.006,0.14-0.014,0.283-0.019,0.428c-0.002,0.021-0.003,0.042-0.004,0.062
   c-0.005,0.127-0.011,0.257-0.017,0.387c-0.006,0.159-0.013,0.321-0.02,0.484c-0.006,0.149-0.012,0.299-0.018,0.453
   c-0.001,0.04-0.003,0.079-0.004,0.119c-0.006,0.162-0.013,0.327-0.018,0.495c-0.022,0.624-0.043,1.279-0.064,1.964
   c-0.002,0.092-0.006,0.183-0.008,0.276c-0.009,0.292-0.016,0.589-0.025,0.891c-0.003,0.12-0.007,0.239-0.01,0.36
   c-0.009,0.361-0.018,0.73-0.028,1.106c-0.002,0.124-0.005,0.25-0.009,0.377c-0.003,0.127-0.005,0.254-0.007,0.382
   c-0.004,0.128-0.007,0.257-0.009,0.386c-0.008,0.328-0.014,0.659-0.022,0.996c-0.002,0.108-0.005,0.215-0.007,0.324
   c-0.007,0.359-0.013,0.723-0.021,1.093c-0.003,0.186-0.006,0.375-0.01,0.565c-0.002,0.113-0.004,0.225-0.006,0.34
   c-0.004,0.185-0.007,0.371-0.009,0.559v0.011c-0.007,0.384-0.013,0.772-0.02,1.166c-0.006,0.303-0.01,0.61-0.014,0.919
   c-0.01,0.71-0.021,1.434-0.031,2.172c-0.003,0.155-0.005,0.311-0.007,0.467c-0.003,0.225-0.006,0.451-0.009,0.679
   c0,0.089-0.001,0.178-0.002,0.268c-0.005,0.317-0.009,0.637-0.012,0.96c-0.004,0.282-0.007,0.565-0.01,0.85
   c-0.002,0.204-0.006,0.41-0.008,0.617c-0.009,0.739-0.015,1.489-0.023,2.251c-0.002,0.154-0.003,0.309-0.004,0.465
   c0,0.049-0.002,0.1-0.002,0.149c-0.001,0.052-0.001,0.103-0.002,0.155c-0.002,0.267-0.005,0.535-0.008,0.805
   c-0.001,0.085-0.002,0.17-0.002,0.255c-0.002,0.219-0.004,0.439-0.006,0.66c-0.002,0.191-0.004,0.382-0.005,0.573
   c-0.002,0.223-0.004,0.447-0.006,0.672c-0.004,0.469-0.008,0.942-0.013,1.417c-0.002,0.253-0.004,0.508-0.006,0.763
   c-0.002,0.291-0.005,0.582-0.007,0.874c-0.003,0.439-0.006,0.879-0.01,1.323c-0.004,0.592-0.009,1.187-0.013,1.786
   c-0.003,0.447-0.007,0.894-0.01,1.345c-0.001,0.137-0.002,0.275-0.003,0.412c-0.006,0.76-0.011,1.526-0.015,2.297
   c-0.002,0.303-0.004,0.607-0.006,0.912c-0.008,1.206-0.016,2.424-0.023,3.654c-0.003,0.328-0.005,0.658-0.007,0.99
   c-0.001,0.101-0.001,0.202-0.002,0.304c-0.001,0.309-0.003,0.618-0.005,0.927c-0.002,0.322-0.004,0.646-0.005,0.97
   c-0.002,0.323-0.005,0.648-0.007,0.973c-0.002,0.287-0.003,0.577-0.005,0.865c-0.003,0.313-0.004,0.627-0.006,0.942
   c-0.244,40.803-0.549,91.528-3.5,100.081c-1.088,0.317-8.198,2.299-19.364,3.324c-11.134,1.022-28.671,1.271-49.074-3.325
   c-0.402-5.236-5.664-109.719-5.719-110.792c-0.002-0.011-0.003-0.038-0.004-0.08c-0.001-0.014-0.002-0.03-0.002-0.049
   c-0.001-0.008-0.001-0.017-0.001-0.026c-0.001-0.012-0.001-0.024-0.002-0.038c-0.005-0.118-0.012-0.286-0.02-0.506v-0.008
   c-0.002-0.041-0.004-0.084-0.006-0.129c-0.002-0.042-0.003-0.085-0.005-0.129c-0.002-0.038-0.004-0.077-0.006-0.118
   c-0.001-0.029-0.002-0.059-0.003-0.089c-0.001-0.022-0.002-0.046-0.003-0.07c-0.003-0.046-0.005-0.095-0.006-0.143
   c-0.002-0.05-0.004-0.099-0.006-0.151c-0.005-0.102-0.008-0.209-0.013-0.323c-0.003-0.064-0.005-0.129-0.009-0.197
   c-0.008-0.216-0.018-0.446-0.027-0.691c-0.005-0.104-0.009-0.211-0.013-0.321c-0.007-0.152-0.014-0.311-0.02-0.473
   c-0.001-0.015-0.001-0.03-0.002-0.046c0-0.011-0.001-0.023-0.001-0.034c0-0.012-0.002-0.024-0.002-0.036
   c-0.001-0.016-0.001-0.032-0.001-0.048v-0.004c-0.004-0.112-0.009-0.228-0.014-0.345c-0.003-0.068-0.006-0.137-0.009-0.205
   c-0.011-0.278-0.022-0.566-0.034-0.867c-0.009-0.227-0.019-0.46-0.028-0.699c-0.011-0.285-0.023-0.579-0.035-0.883
   c-0.006-0.158-0.012-0.317-0.019-0.481c-0.003-0.08-0.006-0.162-0.01-0.245c-0.016-0.413-0.032-0.841-0.049-1.283
   c-0.007-0.163-0.013-0.328-0.019-0.495c-0.001-0.028-0.002-0.057-0.004-0.085c-0.008-0.23-0.017-0.462-0.027-0.699
   c-0.008-0.237-0.018-0.478-0.028-0.721c-0.004-0.104-0.008-0.208-0.012-0.313c-0.021-0.56-0.044-1.139-0.066-1.734
   c-0.013-0.335-0.026-0.677-0.039-1.023c-0.013-0.358-0.026-0.721-0.041-1.092c-0.006-0.178-0.014-0.359-0.021-0.541
   c-0.006-0.204-0.014-0.411-0.023-0.618c-0.008-0.208-0.015-0.419-0.022-0.631c-0.014-0.373-0.029-0.751-0.042-1.134
   c-0.005-0.128-0.01-0.257-0.014-0.386c-0.003-0.047-0.005-0.094-0.006-0.143c-0.007-0.209-0.016-0.423-0.023-0.635
   c-0.008-0.205-0.015-0.41-0.023-0.618l-0.007-0.174c-0.007-0.205-0.014-0.413-0.022-0.622c-0.008-0.194-0.014-0.39-0.022-0.587
   c-0.008-0.197-0.013-0.395-0.021-0.595c0-0.011-0.001-0.022-0.001-0.032l-0.007-0.194c-0.014-0.38-0.027-0.762-0.042-1.149
   c-0.014-0.386-0.027-0.776-0.042-1.17c-0.007-0.213-0.015-0.427-0.022-0.642c-0.015-0.43-0.032-0.865-0.046-1.303
   c-0.008-0.22-0.015-0.44-0.023-0.661c-0.008-0.224-0.016-0.45-0.023-0.677c-0.017-0.448-0.031-0.899-0.048-1.354
   c-0.008-0.22-0.015-0.44-0.023-0.661c-0.008-0.238-0.016-0.475-0.024-0.714c-0.008-0.22-0.016-0.441-0.022-0.664
   c0-0.009,0-0.017-0.002-0.027c-0.007-0.233-0.016-0.467-0.024-0.703c-0.018-0.533-0.036-1.069-0.054-1.608
   c-0.013-0.403-0.028-0.807-0.041-1.214c-0.016-0.488-0.033-0.98-0.048-1.475c-0.017-0.486-0.033-0.974-0.049-1.466
   c-0.012-0.385-0.025-0.772-0.038-1.162c-0.022-0.657-0.042-1.318-0.064-1.984c-0.013-0.447-0.028-0.894-0.043-1.344
   c-0.015-0.521-0.032-1.045-0.049-1.572c-0.01-0.374-0.022-0.749-0.035-1.125c-0.007-0.232-0.014-0.464-0.021-0.695
   c-0.007-0.233-0.014-0.466-0.022-0.699c-0.002-0.058-0.003-0.116-0.005-0.174c-0.019-0.631-0.039-1.265-0.056-1.901
   c-0.063-2.083-0.125-4.194-0.185-6.32c-0.011-0.355-0.02-0.708-0.03-1.063c-0.014-0.514-0.028-1.028-0.043-1.545
   c-0.015-0.553-0.03-1.107-0.045-1.662c-0.014-0.519-0.028-1.038-0.042-1.558c-0.005-0.196-0.011-0.392-0.015-0.589
   c-0.019-0.716-0.038-1.433-0.056-2.15c-0.027-1.051-0.053-2.102-0.078-3.153c-0.068-2.736-0.13-5.47-0.188-8.185
   c-0.007-0.34-0.014-0.679-0.021-1.018c-0.015-0.736-0.031-1.469-0.044-2.202c-0.007-0.284-0.012-0.568-0.018-0.852
   c-0.002-0.088-0.003-0.177-0.004-0.265l-0.014-0.746v-0.003c-0.01-0.48-0.019-0.958-0.028-1.436
   c-0.004-0.272-0.01-0.543-0.013-0.814c-0.004-0.185-0.007-0.369-0.01-0.553c-0.007-0.349-0.012-0.697-0.019-1.045
   c-0.01-0.589-0.019-1.176-0.029-1.761c-0.004-0.267-0.007-0.531-0.012-0.797c-0.01-0.698-0.021-1.392-0.031-2.083
   c-0.004-0.339-0.008-0.678-0.014-1.017c-0.007-0.531-0.013-1.06-0.02-1.586c-0.003-0.27-0.007-0.539-0.01-0.807
   c0-0.056-0.001-0.111-0.001-0.167c-0.002-0.152-0.003-0.303-0.005-0.455c-0.005-0.322-0.008-0.641-0.011-0.96
   c-0.002-0.123-0.002-0.247-0.003-0.371c-0.002-0.198-0.004-0.396-0.006-0.593c-0.003-0.182-0.004-0.364-0.006-0.546v-0.044
   c-0.001-0.148-0.003-0.297-0.004-0.444c-0.003-0.163-0.004-0.325-0.005-0.488c-0.001-0.095-0.002-0.19-0.002-0.285
   c-0.001-0.067-0.001-0.133-0.002-0.2c-0.002-0.258-0.005-0.515-0.007-0.771c-0.001-0.092-0.001-0.182-0.002-0.273
   c-0.002-0.293-0.004-0.585-0.005-0.876c-0.002-0.333-0.004-0.666-0.005-0.997c-0.002-0.298-0.003-0.596-0.005-0.892
   c-0.006-1.205-0.009-2.389-0.01-3.548c-0.001-0.643,0-1.277,0.001-1.905c0.001-0.293,0.001-0.586,0.002-0.875
   c0.001-0.3,0.002-0.599,0.003-0.895c0.001-0.248,0.002-0.495,0.005-0.74c0-0.188,0.001-0.376,0.002-0.562
   c0.002-0.239,0.003-0.476,0.005-0.712c0.001-0.186,0.002-0.37,0.004-0.554c0.002-0.225,0.003-0.448,0.005-0.671
   c0.004-0.323,0.007-0.643,0.011-0.959v-0.047c0.002-0.203,0.005-0.406,0.008-0.607c0.004-0.309,0.009-0.617,0.013-0.92v-0.026
   c0.003-0.211,0.006-0.42,0.009-0.627c0.003-0.166,0.006-0.331,0.009-0.493v-0.019c0.003-0.215,0.008-0.427,0.012-0.638
   c0.014-0.763,0.031-1.506,0.05-2.227v-0.01l-0.001-0.01c-1.132-25.481-7.024-50.174-7.268-51.184
   c-0.003-0.079-0.013-0.307-0.029-0.663c0.028-0.547,0.128-2.57,0.263-5.427c0.475-10.036,1.379-30.385,1.057-33.386
   c-0.188-1.757-1.31-3.401-3.158-4.631c-1.698-1.127-3.687-1.676-5.107-1.436V51.944c7.964-0.151,17.38-0.309,26.955-0.463
   c0.1,1.504,0.808,12.366,1.988,14.726c0.321,0.644,0.779,1.298,1.357,1.941c1.117,1.24,2.501,2.224,4.116,2.925l15.514,6.739
   l3.193,29.765l0.251,0.021c7.621,0.619,25.328,6.711,38.921,11.746c0.185,2.846,0.342,5.624,0.472,8.321
   c0.131,2.698,0.235,5.313,0.318,7.833l-42.309,14.169l0.042,0.257c0.037,0.223,3.728,22.565,8.004,44.928
   c2.511,13.136,4.729,23.708,6.593,31.426c3.176,13.146,4.631,15.192,5.449,15.589c4.459,2.163,19.322,2.331,23.846,2.331
   c0.313,0,0.577-0.001,0.785-0.001c0.014,0.74,0.028,1.477,0.043,2.212c0.006,0.368,0.013,0.735,0.021,1.101
   c0.014,0.742,0.027,1.481,0.042,2.218c0.014,0.721,0.027,1.441,0.04,2.158c0.004,0.191,0.008,0.382,0.011,0.573
   c0.013,0.681,0.026,1.36,0.038,2.036c0.004,0.213,0.008,0.426,0.012,0.638c0.012,0.717,0.026,1.433,0.039,2.145
   c0.025,1.424,0.05,2.839,0.074,4.24c0.011,0.658,0.022,1.313,0.033,1.965c0.037,2.229,0.073,4.425,0.106,6.584
   c0.003,0.233,0.007,0.465,0.01,0.696c0.014,0.926,0.029,1.846,0.041,2.757c0.006,0.456,0.013,0.91,0.02,1.362
   c0.003,0.226,0.006,0.452,0.01,0.676c0.006,0.556,0.014,1.107,0.022,1.655c0.004,0.303,0.008,0.606,0.012,0.907
   c0.004,0.301,0.009,0.601,0.012,0.9c0.001,0.178,0.003,0.356,0.005,0.535c0.004,0.218,0.006,0.436,0.009,0.654
   c0,0.05,0.001,0.101,0.003,0.152c0.001,0.148,0.003,0.295,0.005,0.442c0.004,0.444,0.011,0.885,0.015,1.323v0.029
   c0.005,0.428,0.01,0.855,0.015,1.279c0.004,0.315,0.008,0.629,0.011,0.941c0,0.017,0,0.034,0.001,0.051
   c0.002,0.244,0.004,0.487,0.008,0.729c0.002,0.284,0.005,0.568,0.008,0.851c0.003,0.151,0.003,0.302,0.004,0.453
   c0.004,0.411,0.009,0.821,0.012,1.228c0,0.04,0.001,0.078,0.001,0.118c0.002,0.204,0.005,0.408,0.006,0.61
   c0.001,0.034,0.001,0.069,0.001,0.102c0.003,0.277,0.005,0.551,0.007,0.825c0.003,0.151,0.004,0.303,0.004,0.455
   c0.002,0.141,0.003,0.283,0.004,0.425c0.002,0.32,0.006,0.637,0.007,0.954c0.001,0.198,0.003,0.396,0.004,0.593
   c0.001,0.134,0.002,0.267,0.004,0.399c0.002,0.263,0.003,0.523,0.005,0.782c0.001,0.181,0.002,0.362,0.003,0.541
   c0.001,0.18,0.003,0.359,0.004,0.537c0.003,0.553,0.006,1.1,0.01,1.64c0.001,0.254,0.002,0.505,0.003,0.756
   c0.001,0.251,0.002,0.5,0.003,0.749c0.001,0.202,0.001,0.403,0.002,0.603c0,0.045,0,0.091,0.002,0.136
   c0,0.246,0.001,0.49,0.001,0.733c0,0.136,0.001,0.272,0.001,0.408c0,0.226,0.001,0.451,0.001,0.674
   C473.481,312.127,473.3,320.732,472.808,323.197"
      />
      <path d="M354.234,475.26c-0.005,0-0.009,0.001-0.012,0.002c0.006-0.002,0.014-0.003,0.022-0.005L354.234,475.26z" />
      <polygon
        fill={lightContrast}
        onClick={() => handleClick("base")}
        onMouseEnter={() => setLightContrastActive(true)}
        onMouseLeave={() => setLightContrastActive(false)}
        style={
          lightContrastActive && !preview
            ? {fill: adjust(lightContrast, 55)}
            : {fill: lightContrast}
        }
        points="669.955,143.196 669.877,143.918 669.962,143.193 "
      />
    </svg>
  );
}
